export interface apple_health_data {
  date: string;
  activeEnergyBurned?: number;
  basalEnergyBurned?: number;
  distanceWalkingRunning?: number;
  flightsClimbed?: number;
  stepCount?: number;
  walkingSpeed?: number;
}

export const johnSmithAppleHealthData: apple_health_data[] = [
  {
    "date": "2023-08-15",
    "activeEnergyBurned": 164.02200000000002,
    "basalEnergyBurned": 1436.0590000000002,
    "distanceWalkingRunning": 2.3312853799999997,
    "stepCount": 5148,
    "walkingSpeed": 2.820082068965517
  },
  {
    "date": "2023-08-16",
    "activeEnergyBurned": 150.552,
    "basalEnergyBurned": 1431.3560000000002,
    "distanceWalkingRunning": 2.17056345,
    "flightsClimbed": 1,
    "stepCount": 4961,
    "walkingSpeed": 2.744241785714286
  },
  {
    "date": "2023-08-17",
    "activeEnergyBurned": 318.08700000000005,
    "basalEnergyBurned": 1537.7549999999997,
    "distanceWalkingRunning": 4.22789986,
    "flightsClimbed": 4,
    "stepCount": 8701,
    "walkingSpeed": 2.912490888888889
  },
  {
    "date": "2023-08-18",
    "activeEnergyBurned": 133.73099999999997,
    "basalEnergyBurned": 1361.278,
    "distanceWalkingRunning": 2.0588890299999996,
    "flightsClimbed": 1,
    "stepCount": 4956,
    "walkingSpeed": 2.7449066666666666
  },
  {
    "date": "2023-08-19",
    "activeEnergyBurned": 57.748,
    "basalEnergyBurned": 1562.5310000000002,
    "distanceWalkingRunning": 0.11730254000000001,
    "flightsClimbed": 2,
    "stepCount": 304,
    "walkingSpeed": 2.200585625
  },
  {
    "date": "2023-08-20",
    "activeEnergyBurned": 79.37599999999999,
    "basalEnergyBurned": 1288.897,
    "walkingSpeed": 2.545847142857143
  },
  {
    "date": "2023-08-21",
    "activeEnergyBurned": 225.451,
    "basalEnergyBurned": 1661.6370000000002,
    "walkingSpeed": 2.8503544444444446
  },
  {
    "date": "2023-08-22",
    "activeEnergyBurned": 139.097,
    "basalEnergyBurned": 1416.942,
    "walkingSpeed": 3.0768045454545456
  },
  {
    "date": "2023-08-23",
    "activeEnergyBurned": 167.296,
    "basalEnergyBurned": 1503.8360000000002,
    "walkingSpeed": 2.7725583333333335
  },
  {
    "date": "2023-08-24",
    "activeEnergyBurned": 169.961,
    "basalEnergyBurned": 1461.277,
    "distanceWalkingRunning": 11.868149529,
    "flightsClimbed": 23,
    "stepCount": 28307,
    "walkingSpeed": 2.896513142857143
  },
  {
    "date": "2023-08-25",
    "activeEnergyBurned": 43.803000000000004,
    "basalEnergyBurned": 1393.9660000000001,
    "distanceWalkingRunning": 0.9449196699999999,
    "flightsClimbed": 1,
    "stepCount": 2510,
    "walkingSpeed": 2.3334778947368418
  },
  {
    "date": "2023-08-26",
    "activeEnergyBurned": 137.605,
    "basalEnergyBurned": 1555.568,
    "distanceWalkingRunning": 2.031417916,
    "flightsClimbed": 10,
    "stepCount": 4116,
    "walkingSpeed": 2.3579345454545453
  },
  {
    "date": "2023-08-27",
    "activeEnergyBurned": 152.51600000000002,
    "basalEnergyBurned": 1457.456,
    "distanceWalkingRunning": 2.42322484,
    "flightsClimbed": 6,
    "stepCount": 5238,
    "walkingSpeed": 2.3270018421052634
  },
  {
    "date": "2023-08-28",
    "activeEnergyBurned": 154.751,
    "basalEnergyBurned": 1464.866,
    "distanceWalkingRunning": 2.0302300300000002,
    "flightsClimbed": 8,
    "stepCount": 3621,
    "walkingSpeed": 2.39352
  },
  {
    "date": "2023-08-29",
    "activeEnergyBurned": 88.63000000000001,
    "basalEnergyBurned": 1412.6340000000002,
    "distanceWalkingRunning": 1.15051983,
    "flightsClimbed": 7,
    "stepCount": 2268,
    "walkingSpeed": 2.514317
  },
  {
    "date": "2023-08-30",
    "activeEnergyBurned": 104.78899999999999,
    "basalEnergyBurned": 1521.6770000000001,
    "distanceWalkingRunning": 1.4458309,
    "flightsClimbed": 6,
    "stepCount": 2496,
    "walkingSpeed": 2.2694718181818185
  },
  {
    "date": "2023-08-31",
    "activeEnergyBurned": 251.206,
    "basalEnergyBurned": 1467.577,
    "distanceWalkingRunning": 3.212860527,
    "flightsClimbed": 7,
    "stepCount": 5378,
    "walkingSpeed": 2.500042857142857
  },
  {
    "date": "2023-09-01",
    "activeEnergyBurned": 120.558,
    "basalEnergyBurned": 1451.558,
    "distanceWalkingRunning": 1.72358433,
    "flightsClimbed": 6,
    "stepCount": 3490,
    "walkingSpeed": 2.4205520833333334
  },
  {
    "date": "2023-09-02",
    "activeEnergyBurned": 312.75800000000004,
    "basalEnergyBurned": 1364.708,
    "distanceWalkingRunning": 4.11742788,
    "flightsClimbed": 24,
    "stepCount": 9139,
    "walkingSpeed": 2.715127213114754
  },
  {
    "date": "2023-09-03",
    "activeEnergyBurned": 288.71500000000003,
    "basalEnergyBurned": 1576.626,
    "distanceWalkingRunning": 3.55991619,
    "flightsClimbed": 20,
    "stepCount": 8068,
    "walkingSpeed": 2.6430257692307695
  },
  {
    "date": "2023-09-04",
    "activeEnergyBurned": 551.5370000000001,
    "basalEnergyBurned": 1448.4959999999999,
    "distanceWalkingRunning": 6.438902178999999,
    "flightsClimbed": 39,
    "stepCount": 14432,
    "walkingSpeed": 2.5438734426229512
  },
  {
    "date": "2023-09-05",
    "activeEnergyBurned": 302.425,
    "basalEnergyBurned": 1567.353,
    "distanceWalkingRunning": 3.58849604,
    "flightsClimbed": 31,
    "stepCount": 9173,
    "walkingSpeed": 2.765048043478261
  },
  {
    "date": "2023-09-06",
    "activeEnergyBurned": 352.29499999999996,
    "basalEnergyBurned": 1504.1320000000003,
    "distanceWalkingRunning": 4.03180394,
    "flightsClimbed": 31,
    "stepCount": 9210,
    "walkingSpeed": 2.6853409090909097
  },
  {
    "date": "2023-09-07",
    "activeEnergyBurned": 373.10699999999997,
    "basalEnergyBurned": 1504.8909999999998,
    "distanceWalkingRunning": 4.527241109999999,
    "flightsClimbed": 37,
    "stepCount": 11295,
    "walkingSpeed": 2.600668493150685
  },
  {
    "date": "2023-09-08",
    "activeEnergyBurned": 437.512,
    "basalEnergyBurned": 1486.3379999999997,
    "distanceWalkingRunning": 4.9733158799999995,
    "flightsClimbed": 35,
    "stepCount": 11718,
    "walkingSpeed": 2.5161058
  },
  {
    "date": "2023-09-09",
    "activeEnergyBurned": 176.22199999999998,
    "basalEnergyBurned": 1314.1190000000001,
    "distanceWalkingRunning": 2.4722988200000002,
    "flightsClimbed": 15,
    "stepCount": 6299,
    "walkingSpeed": 2.8422651515151514
  },
  {
    "date": "2023-09-10",
    "activeEnergyBurned": 222.44199999999998,
    "basalEnergyBurned": 1583.6660000000002,
    "distanceWalkingRunning": 2.4514372599999996,
    "flightsClimbed": 22,
    "stepCount": 5737,
    "walkingSpeed": 2.8304231250000003
  },
  {
    "date": "2023-09-11",
    "activeEnergyBurned": 437.119,
    "basalEnergyBurned": 1496.729,
    "distanceWalkingRunning": 5.05955134,
    "flightsClimbed": 42,
    "stepCount": 12046,
    "walkingSpeed": 2.607002826086956
  },
  {
    "date": "2023-09-12",
    "activeEnergyBurned": 246.23999999999998,
    "basalEnergyBurned": 1424.479,
    "distanceWalkingRunning": 3.0500751699999995,
    "flightsClimbed": 19,
    "stepCount": 7515,
    "walkingSpeed": 2.8197186842105264
  },
  {
    "date": "2023-09-13",
    "activeEnergyBurned": 267.1,
    "basalEnergyBurned": 1595.313,
    "distanceWalkingRunning": 3.02415228,
    "flightsClimbed": 28,
    "stepCount": 8040,
    "walkingSpeed": 2.8708758490566044
  },
  {
    "date": "2023-09-14",
    "activeEnergyBurned": 324.681,
    "basalEnergyBurned": 1500.844,
    "distanceWalkingRunning": 3.6677944479999995,
    "flightsClimbed": 33,
    "stepCount": 8675,
    "walkingSpeed": 2.8185395348837208
  },
  {
    "date": "2023-09-15",
    "activeEnergyBurned": 307.064,
    "basalEnergyBurned": 1487.8709999999999,
    "distanceWalkingRunning": 3.7026198000000003,
    "flightsClimbed": 30,
    "stepCount": 8943,
    "walkingSpeed": 2.770072142857143
  },
  {
    "date": "2023-09-16",
    "activeEnergyBurned": 684.764,
    "basalEnergyBurned": 1534.784,
    "distanceWalkingRunning": 7.00434773,
    "flightsClimbed": 56,
    "stepCount": 14936,
    "walkingSpeed": 2.8947089873417724
  },
  {
    "date": "2023-09-17",
    "activeEnergyBurned": 272.834,
    "basalEnergyBurned": 1354.344,
    "distanceWalkingRunning": 3.1761657970000003,
    "flightsClimbed": 33,
    "stepCount": 7931,
    "walkingSpeed": 2.7733044444444443
  },
  {
    "date": "2023-09-18",
    "activeEnergyBurned": 335.37799999999993,
    "basalEnergyBurned": 1615.9819999999997,
    "distanceWalkingRunning": 3.97585574,
    "flightsClimbed": 27,
    "stepCount": 9526,
    "walkingSpeed": 2.6916176086956525
  },
  {
    "date": "2023-09-19",
    "activeEnergyBurned": 233.997,
    "basalEnergyBurned": 1368.2739999999994,
    "distanceWalkingRunning": 2.63125902,
    "flightsClimbed": 21,
    "stepCount": 6112,
    "walkingSpeed": 2.882935757575758
  },
  {
    "date": "2023-09-20",
    "activeEnergyBurned": 307.05,
    "basalEnergyBurned": 1600.6570000000002,
    "distanceWalkingRunning": 3.47678401,
    "flightsClimbed": 28,
    "stepCount": 8736,
    "walkingSpeed": 2.6382932692307692
  },
  {
    "date": "2023-09-21",
    "activeEnergyBurned": 335.82399999999996,
    "basalEnergyBurned": 1457.53,
    "distanceWalkingRunning": 4.2717468599999995,
    "flightsClimbed": 27,
    "stepCount": 9957,
    "walkingSpeed": 2.7441041379310347
  },
  {
    "date": "2023-09-22",
    "activeEnergyBurned": 289.84399999999994,
    "basalEnergyBurned": 1493.69,
    "distanceWalkingRunning": 3.334786844,
    "flightsClimbed": 25,
    "stepCount": 7652,
    "walkingSpeed": 2.713575641025641
  },
  {
    "date": "2023-09-23",
    "activeEnergyBurned": 249.01300000000003,
    "basalEnergyBurned": 1504.876,
    "distanceWalkingRunning": 2.9786012299999998,
    "flightsClimbed": 26,
    "stepCount": 7106,
    "walkingSpeed": 2.6837916666666666
  },
  {
    "date": "2023-09-24",
    "activeEnergyBurned": 267.333,
    "basalEnergyBurned": 1423.462,
    "distanceWalkingRunning": 3.2136145899999997,
    "flightsClimbed": 22,
    "stepCount": 7866,
    "walkingSpeed": 2.649651
  },
  {
    "date": "2023-09-25",
    "activeEnergyBurned": 261.783,
    "basalEnergyBurned": 1480.746,
    "distanceWalkingRunning": 3.076304856,
    "flightsClimbed": 25,
    "stepCount": 7751,
    "walkingSpeed": 2.6721663043478263
  },
  {
    "date": "2023-09-26",
    "activeEnergyBurned": 212.093,
    "basalEnergyBurned": 1475.337,
    "distanceWalkingRunning": 2.5519399499999995,
    "flightsClimbed": 14,
    "stepCount": 5695,
    "walkingSpeed": 2.7178771052631583
  },
  {
    "date": "2023-09-27",
    "activeEnergyBurned": 381.37199999999996,
    "basalEnergyBurned": 1535.5720000000001,
    "distanceWalkingRunning": 4.219591299999999,
    "flightsClimbed": 31,
    "stepCount": 9702,
    "walkingSpeed": 2.9159391666666665
  },
  {
    "date": "2023-09-28",
    "activeEnergyBurned": 393.28800000000007,
    "basalEnergyBurned": 1517.3880000000001,
    "distanceWalkingRunning": 4.83874706,
    "flightsClimbed": 30,
    "stepCount": 11356,
    "walkingSpeed": 2.7937732142857143
  },
  {
    "date": "2023-09-29",
    "activeEnergyBurned": 268.549,
    "basalEnergyBurned": 1503.3539999999998,
    "distanceWalkingRunning": 3.3634825900000003,
    "flightsClimbed": 22,
    "stepCount": 7839,
    "walkingSpeed": 2.906492045454546
  },
  {
    "date": "2023-09-30",
    "activeEnergyBurned": 321.05800000000005,
    "basalEnergyBurned": 1486.379,
    "distanceWalkingRunning": 3.85117147,
    "flightsClimbed": 28,
    "stepCount": 8771,
    "walkingSpeed": 2.7708828260869565
  },
  {
    "date": "2023-10-01",
    "activeEnergyBurned": 473.722,
    "basalEnergyBurned": 1383.7169999999999,
    "distanceWalkingRunning": 5.25845988,
    "flightsClimbed": 37,
    "stepCount": 12458,
    "walkingSpeed": 2.6237229090909095
  },
  {
    "date": "2023-10-02",
    "activeEnergyBurned": 387.22800000000007,
    "basalEnergyBurned": 1559.5359999999998,
    "distanceWalkingRunning": 4.3467177,
    "flightsClimbed": 40,
    "stepCount": 10703,
    "walkingSpeed": 2.57457328125
  },
  {
    "date": "2023-10-03",
    "activeEnergyBurned": 265.007,
    "basalEnergyBurned": 1517.393,
    "distanceWalkingRunning": 3.25685525,
    "flightsClimbed": 22,
    "stepCount": 7716,
    "walkingSpeed": 2.814887959183674
  },
  {
    "date": "2023-10-04",
    "activeEnergyBurned": 273.812,
    "basalEnergyBurned": 1484.421,
    "distanceWalkingRunning": 3.18890755,
    "flightsClimbed": 27,
    "stepCount": 7973,
    "walkingSpeed": 2.5610437777777775
  },
  {
    "date": "2023-10-05",
    "activeEnergyBurned": 342.78499999999997,
    "basalEnergyBurned": 1467.411,
    "distanceWalkingRunning": 4.209279,
    "flightsClimbed": 27,
    "stepCount": 9620,
    "walkingSpeed": 2.869817076923077
  },
  {
    "date": "2023-10-06",
    "activeEnergyBurned": 187.685,
    "basalEnergyBurned": 1466.2079999999999,
    "distanceWalkingRunning": 2.18436174,
    "flightsClimbed": 20,
    "stepCount": 5194,
    "walkingSpeed": 2.6859814814814817
  },
  {
    "date": "2023-10-07",
    "activeEnergyBurned": 356.25,
    "basalEnergyBurned": 1553.248,
    "distanceWalkingRunning": 4.8711455,
    "flightsClimbed": 10,
    "stepCount": 9367,
    "walkingSpeed": 2.450542156862745
  },
  {
    "date": "2023-10-08",
    "activeEnergyBurned": 323.303,
    "basalEnergyBurned": 1493.9669999999999,
    "distanceWalkingRunning": 5.5519244799999985,
    "flightsClimbed": 7,
    "stepCount": 13173,
    "walkingSpeed": 2.3562395959595963
  },
  {
    "date": "2023-10-09",
    "activeEnergyBurned": 245.20999999999995,
    "basalEnergyBurned": 1351.378,
    "distanceWalkingRunning": 3.46670044,
    "flightsClimbed": 12,
    "stepCount": 7817,
    "walkingSpeed": 2.6974075471698122
  },
  {
    "date": "2023-10-10",
    "activeEnergyBurned": 508.77299999999997,
    "basalEnergyBurned": 1635.2269999999999,
    "distanceWalkingRunning": 5.59955011,
    "flightsClimbed": 40,
    "stepCount": 12789,
    "walkingSpeed": 2.881790344827587
  },
  {
    "date": "2023-10-11",
    "activeEnergyBurned": 439.52900000000005,
    "basalEnergyBurned": 1515.033,
    "distanceWalkingRunning": 4.8411622,
    "flightsClimbed": 39,
    "stepCount": 11428,
    "walkingSpeed": 2.685639264705882
  },
  {
    "date": "2023-10-12",
    "activeEnergyBurned": 263.562,
    "basalEnergyBurned": 1389.6149999999998,
    "distanceWalkingRunning": 2.7928835900000006,
    "flightsClimbed": 29,
    "stepCount": 6662,
    "walkingSpeed": 2.7325944736842107
  },
  {
    "date": "2023-10-13",
    "activeEnergyBurned": 247.92,
    "basalEnergyBurned": 1576.4889999999998,
    "distanceWalkingRunning": 3.2009338200000004,
    "flightsClimbed": 19,
    "stepCount": 8081,
    "walkingSpeed": 2.5053681578947367
  },
  {
    "date": "2023-10-14",
    "activeEnergyBurned": 444.64200000000005,
    "basalEnergyBurned": 1493.319,
    "distanceWalkingRunning": 5.074002290000001,
    "flightsClimbed": 39,
    "stepCount": 11964,
    "walkingSpeed": 2.636900666666667
  },
  {
    "date": "2023-10-15",
    "activeEnergyBurned": 262.90999999999997,
    "basalEnergyBurned": 1351.4279999999999,
    "distanceWalkingRunning": 2.90472743,
    "flightsClimbed": 28,
    "stepCount": 7140,
    "walkingSpeed": 2.822607272727273
  },
  {
    "date": "2023-10-16",
    "activeEnergyBurned": 388.21000000000004,
    "basalEnergyBurned": 1643.647,
    "distanceWalkingRunning": 4.685581750000001,
    "flightsClimbed": 32,
    "stepCount": 11027,
    "walkingSpeed": 2.7339091666666664
  },
  {
    "date": "2023-10-17",
    "activeEnergyBurned": 484.8109999999999,
    "basalEnergyBurned": 1500.6580000000004,
    "distanceWalkingRunning": 5.745044212,
    "flightsClimbed": 42,
    "stepCount": 13106,
    "walkingSpeed": 2.671961315789473
  },
  {
    "date": "2023-10-18",
    "activeEnergyBurned": 259.486,
    "basalEnergyBurned": 1438.1000000000001,
    "distanceWalkingRunning": 3.1685264599999994,
    "flightsClimbed": 21,
    "stepCount": 7885,
    "walkingSpeed": 2.7455453947368422
  },
  {
    "date": "2023-10-19",
    "activeEnergyBurned": 334.48,
    "basalEnergyBurned": 1492.193,
    "distanceWalkingRunning": 3.96751842,
    "flightsClimbed": 22,
    "stepCount": 9584,
    "walkingSpeed": 2.7298334482758624
  },
  {
    "date": "2023-10-20",
    "activeEnergyBurned": 355.774,
    "basalEnergyBurned": 1514.9879999999998,
    "distanceWalkingRunning": 4.203350497999999,
    "flightsClimbed": 38,
    "stepCount": 10062,
    "walkingSpeed": 2.7070928571428574
  },
  {
    "date": "2023-10-21",
    "activeEnergyBurned": 443.565,
    "basalEnergyBurned": 1508.281,
    "distanceWalkingRunning": 5.2461157400000005,
    "flightsClimbed": 43,
    "stepCount": 12979,
    "walkingSpeed": 2.4638261904761904
  },
  {
    "date": "2023-10-22",
    "activeEnergyBurned": 255.24900000000005,
    "basalEnergyBurned": 1442.861,
    "distanceWalkingRunning": 3.2764087500000003,
    "flightsClimbed": 23,
    "stepCount": 8512,
    "walkingSpeed": 2.497206216216216
  },
  {
    "date": "2023-10-23",
    "activeEnergyBurned": 452.8470000000001,
    "basalEnergyBurned": 1568.0809999999997,
    "distanceWalkingRunning": 5.16516068,
    "flightsClimbed": 48,
    "stepCount": 13172,
    "walkingSpeed": 2.51392205882353
  },
  {
    "date": "2023-10-24",
    "activeEnergyBurned": 363.051,
    "basalEnergyBurned": 1467.02,
    "distanceWalkingRunning": 4.0885178799999995,
    "flightsClimbed": 28,
    "stepCount": 9917,
    "walkingSpeed": 2.8259964583333335
  },
  {
    "date": "2023-10-25",
    "activeEnergyBurned": 382.98500000000007,
    "basalEnergyBurned": 1415.8619999999999,
    "distanceWalkingRunning": 4.328201439999999,
    "flightsClimbed": 28,
    "stepCount": 9538,
    "walkingSpeed": 2.7911375
  },
  {
    "date": "2023-10-26",
    "activeEnergyBurned": 416.073,
    "basalEnergyBurned": 1499.6870000000004,
    "distanceWalkingRunning": 4.92709954,
    "flightsClimbed": 36,
    "stepCount": 12334,
    "walkingSpeed": 2.638126304347826
  },
  {
    "date": "2023-10-27",
    "activeEnergyBurned": 430.55999999999995,
    "basalEnergyBurned": 1622.238,
    "distanceWalkingRunning": 5.3327826300000005,
    "flightsClimbed": 33,
    "stepCount": 12873,
    "walkingSpeed": 2.7362373584905653
  },
  {
    "date": "2023-10-28",
    "activeEnergyBurned": 619.66,
    "basalEnergyBurned": 1527.1660000000002,
    "distanceWalkingRunning": 7.480062230000001,
    "flightsClimbed": 45,
    "stepCount": 18237
  },
  {
    "date": "2023-10-29",
    "activeEnergyBurned": 382.466,
    "basalEnergyBurned": 1459.588,
    "distanceWalkingRunning": 4.221116029999999,
    "flightsClimbed": 28,
    "stepCount": 9763,
    "walkingSpeed": 2.7743272352941175
  },
  {
    "date": "2023-10-30",
    "activeEnergyBurned": 485.14099999999996,
    "basalEnergyBurned": 1477.867,
    "distanceWalkingRunning": 5.285901269999999,
    "flightsClimbed": 48,
    "stepCount": 12411,
    "walkingSpeed": 2.834330294117647
  },
  {
    "date": "2023-10-31",
    "activeEnergyBurned": 355.566,
    "basalEnergyBurned": 1478.493,
    "distanceWalkingRunning": 3.8170376299999997,
    "flightsClimbed": 34,
    "stepCount": 8393,
    "walkingSpeed": 2.7212037837837832
  },
  {
    "date": "2023-11-01",
    "activeEnergyBurned": 358.745,
    "basalEnergyBurned": 1520.931,
    "distanceWalkingRunning": 4.102291686,
    "flightsClimbed": 31,
    "stepCount": 9303,
    "walkingSpeed": 2.8031606250000003
  },
  {
    "date": "2023-11-02",
    "activeEnergyBurned": 262.258,
    "basalEnergyBurned": 1439.3220000000001,
    "distanceWalkingRunning": 3.26861828,
    "flightsClimbed": 23,
    "stepCount": 8222,
    "walkingSpeed": 2.774193684210527
  },
  {
    "date": "2023-11-03",
    "activeEnergyBurned": 272.106,
    "basalEnergyBurned": 1502.0529999999999,
    "distanceWalkingRunning": 2.9999659700000003,
    "flightsClimbed": 33,
    "stepCount": 7320,
    "walkingSpeed": 2.8516464000000004
  },
  {
    "date": "2023-11-04",
    "activeEnergyBurned": 394.72400000000005,
    "basalEnergyBurned": 1536.6360000000002,
    "distanceWalkingRunning": 4.70693298,
    "flightsClimbed": 35,
    "stepCount": 12082,
    "walkingSpeed": 2.5754593333333333
  },
  {
    "date": "2023-11-05",
    "activeEnergyBurned": 324.83500000000004,
    "basalEnergyBurned": 1420.1570000000002,
    "distanceWalkingRunning": 4.1112641000000005,
    "flightsClimbed": 28,
    "stepCount": 9970,
    "walkingSpeed": 2.6517866666666667
  },
  {
    "date": "2023-11-06",
    "activeEnergyBurned": 372.763,
    "basalEnergyBurned": 1533.7820000000002,
    "distanceWalkingRunning": 4.533035879999999,
    "flightsClimbed": 31,
    "stepCount": 10981,
    "walkingSpeed": 2.558860579710145
  },
  {
    "date": "2023-11-07",
    "activeEnergyBurned": 344.562,
    "basalEnergyBurned": 1549.221,
    "distanceWalkingRunning": 3.81912625,
    "flightsClimbed": 40,
    "stepCount": 9023,
    "walkingSpeed": 2.7341273584905665
  },
  {
    "date": "2023-11-08",
    "activeEnergyBurned": 400.646,
    "basalEnergyBurned": 1506.7669999999998,
    "distanceWalkingRunning": 4.70971352,
    "flightsClimbed": 31,
    "stepCount": 11070,
    "walkingSpeed": 2.7857570689655176
  },
  {
    "date": "2023-11-09",
    "activeEnergyBurned": 241.329,
    "basalEnergyBurned": 1478.1989999999998,
    "distanceWalkingRunning": 3.07414067,
    "flightsClimbed": 17,
    "stepCount": 7649,
    "walkingSpeed": 2.71765
  },
  {
    "date": "2023-11-10",
    "activeEnergyBurned": 327.46,
    "basalEnergyBurned": 1477.8750000000002,
    "distanceWalkingRunning": 3.5926887,
    "flightsClimbed": 34,
    "stepCount": 8458,
    "walkingSpeed": 2.7818910638297876
  },
  {
    "date": "2023-11-11",
    "activeEnergyBurned": 447.249,
    "basalEnergyBurned": 1502.6930000000002,
    "distanceWalkingRunning": 5.81724016,
    "flightsClimbed": 37,
    "stepCount": 14386,
    "walkingSpeed": 2.3537831764705883
  },
  {
    "date": "2023-11-12",
    "activeEnergyBurned": 545.1899999999999,
    "basalEnergyBurned": 1547.098,
    "distanceWalkingRunning": 6.416047542,
    "flightsClimbed": 51,
    "stepCount": 16564,
    "walkingSpeed": 2.4098389411764702
  },
  {
    "date": "2023-11-13",
    "activeEnergyBurned": 266.163,
    "basalEnergyBurned": 1456.962,
    "distanceWalkingRunning": 2.83896428,
    "flightsClimbed": 28,
    "stepCount": 7226,
    "walkingSpeed": 2.659753934426229
  },
  {
    "date": "2023-11-14",
    "activeEnergyBurned": 228.40099999999998,
    "basalEnergyBurned": 1488.788,
    "distanceWalkingRunning": 2.53761742,
    "flightsClimbed": 26,
    "stepCount": 6092,
    "walkingSpeed": 2.6043366666666667
  },
  {
    "date": "2023-11-15",
    "activeEnergyBurned": 317.349,
    "basalEnergyBurned": 1492.708,
    "distanceWalkingRunning": 3.5122188800000003,
    "flightsClimbed": 32,
    "stepCount": 8827,
    "walkingSpeed": 2.8917995000000003
  },
  {
    "date": "2023-11-16",
    "activeEnergyBurned": 367.55299999999994,
    "basalEnergyBurned": 1402.163,
    "distanceWalkingRunning": 4.27041826,
    "flightsClimbed": 29,
    "stepCount": 9909,
    "walkingSpeed": 2.7706057142857143
  },
  {
    "date": "2023-11-17",
    "activeEnergyBurned": 452.19399999999996,
    "basalEnergyBurned": 1574.92,
    "distanceWalkingRunning": 5.61140533,
    "flightsClimbed": 38,
    "stepCount": 13022,
    "walkingSpeed": 2.667727419354839
  },
  {
    "date": "2023-11-18",
    "activeEnergyBurned": 220.14399999999998,
    "basalEnergyBurned": 1505.278,
    "distanceWalkingRunning": 2.8254195300000005,
    "flightsClimbed": 25,
    "stepCount": 6519,
    "walkingSpeed": 2.6511835802469137
  },
  {
    "date": "2023-11-19",
    "activeEnergyBurned": 203.371,
    "basalEnergyBurned": 1445.573,
    "distanceWalkingRunning": 3.3725037600000003,
    "flightsClimbed": 10,
    "stepCount": 7624,
    "walkingSpeed": 2.3656369863013698
  },
  {
    "date": "2023-11-20",
    "activeEnergyBurned": 785.289,
    "basalEnergyBurned": 1593.7530000000002,
    "distanceWalkingRunning": 11.57804069,
    "flightsClimbed": 22,
    "stepCount": 27040,
    "walkingSpeed": 2.6851906976744186
  },
  {
    "date": "2023-11-21",
    "activeEnergyBurned": 173.971,
    "basalEnergyBurned": 1466.0170000000003,
    "distanceWalkingRunning": 1.992085011,
    "flightsClimbed": 15,
    "stepCount": 5004,
    "walkingSpeed": 2.6318845901639345
  },
  {
    "date": "2023-11-22",
    "activeEnergyBurned": 330.99799999999993,
    "basalEnergyBurned": 1498.8740000000003,
    "distanceWalkingRunning": 5.77472486,
    "flightsClimbed": 9,
    "stepCount": 12112,
    "walkingSpeed": 2.4306452127659575
  },
  {
    "date": "2023-11-23",
    "activeEnergyBurned": 95.12800000000001,
    "basalEnergyBurned": 1487.6889999999999,
    "distanceWalkingRunning": 1.7182753300000004,
    "flightsClimbed": 7,
    "stepCount": 4141,
    "walkingSpeed": 2.4484286363636363
  },
  {
    "date": "2023-11-24",
    "activeEnergyBurned": 297.159,
    "basalEnergyBurned": 1431.8190000000002,
    "distanceWalkingRunning": 4.825813049999999,
    "flightsClimbed": 5,
    "stepCount": 11637,
    "walkingSpeed": 2.42007010989011
  },
  {
    "date": "2023-11-25",
    "activeEnergyBurned": 138.043,
    "basalEnergyBurned": 1508.639,
    "distanceWalkingRunning": 1.78642997,
    "flightsClimbed": 14,
    "stepCount": 3875,
    "walkingSpeed": 2.147459090909091
  },
  {
    "date": "2023-11-26",
    "activeEnergyBurned": 297.118,
    "basalEnergyBurned": 1473.642,
    "distanceWalkingRunning": 3.30938596,
    "flightsClimbed": 31,
    "stepCount": 7812,
    "walkingSpeed": 2.55737725
  },
  {
    "date": "2023-11-27",
    "activeEnergyBurned": 243.843,
    "basalEnergyBurned": 1495.9750000000001,
    "distanceWalkingRunning": 2.7886324300000003,
    "flightsClimbed": 24,
    "stepCount": 7391,
    "walkingSpeed": 2.668582222222222
  },
  {
    "date": "2023-11-28",
    "activeEnergyBurned": 261.82,
    "basalEnergyBurned": 1485.1860000000001,
    "distanceWalkingRunning": 2.88479118,
    "flightsClimbed": 26,
    "stepCount": 6724,
    "walkingSpeed": 2.7793928125000003
  },
  {
    "date": "2023-11-29",
    "activeEnergyBurned": 279.26300000000003,
    "basalEnergyBurned": 1424.9150000000002,
    "distanceWalkingRunning": 2.9985405299999996,
    "flightsClimbed": 29,
    "stepCount": 6982,
    "walkingSpeed": 2.7066932142857145
  },
  {
    "date": "2023-11-30",
    "activeEnergyBurned": 330.614,
    "basalEnergyBurned": 1516.207,
    "distanceWalkingRunning": 3.95594729,
    "flightsClimbed": 31,
    "stepCount": 9632,
    "walkingSpeed": 2.7264809615384613
  },
  {
    "date": "2023-12-01",
    "activeEnergyBurned": 376.0259999999999,
    "basalEnergyBurned": 1540.602,
    "distanceWalkingRunning": 5.05339395,
    "flightsClimbed": 26,
    "stepCount": 12372,
    "walkingSpeed": 2.521637142857143
  },
  {
    "date": "2023-12-02",
    "activeEnergyBurned": 291.62499999999994,
    "basalEnergyBurned": 1392.9990000000003,
    "distanceWalkingRunning": 3.3059038049999994,
    "flightsClimbed": 28,
    "stepCount": 8201,
    "walkingSpeed": 2.869989
  },
  {
    "date": "2023-12-03",
    "activeEnergyBurned": 443.288,
    "basalEnergyBurned": 1506.414,
    "distanceWalkingRunning": 4.528152575,
    "flightsClimbed": 54,
    "stepCount": 10357,
    "walkingSpeed": 2.7618705
  },
  {
    "date": "2023-12-04",
    "activeEnergyBurned": 285.153,
    "basalEnergyBurned": 1570.0339999999999,
    "distanceWalkingRunning": 3.16174793,
    "flightsClimbed": 25,
    "stepCount": 7958,
    "walkingSpeed": 2.866568529411765
  },
  {
    "date": "2023-12-05",
    "activeEnergyBurned": 218.094,
    "basalEnergyBurned": 1478.2690000000002,
    "distanceWalkingRunning": 2.59062056,
    "flightsClimbed": 24,
    "stepCount": 6088,
    "walkingSpeed": 2.7301020930232562
  },
  {
    "date": "2023-12-06",
    "activeEnergyBurned": 319.056,
    "basalEnergyBurned": 1468.027,
    "distanceWalkingRunning": 3.2945945400000007,
    "flightsClimbed": 30,
    "stepCount": 7273,
    "walkingSpeed": 2.7507109677419352
  },
  {
    "date": "2023-12-07",
    "activeEnergyBurned": 381.937,
    "basalEnergyBurned": 1485.925,
    "distanceWalkingRunning": 4.33891124,
    "flightsClimbed": 26,
    "stepCount": 10246,
    "walkingSpeed": 2.8208942105263155
  },
  {
    "date": "2023-12-08",
    "activeEnergyBurned": 328.133,
    "basalEnergyBurned": 1528.8120000000001,
    "distanceWalkingRunning": 3.91356997,
    "flightsClimbed": 24,
    "stepCount": 8977,
    "walkingSpeed": 2.7460830434782606
  },
  {
    "date": "2023-12-09",
    "activeEnergyBurned": 435.957,
    "basalEnergyBurned": 1419.9460000000001,
    "distanceWalkingRunning": 4.878073399,
    "flightsClimbed": 36,
    "stepCount": 10594,
    "walkingSpeed": 2.926057741935484
  },
  {
    "date": "2023-12-10",
    "activeEnergyBurned": 302.37999999999994,
    "basalEnergyBurned": 1554.907,
    "distanceWalkingRunning": 3.12958546,
    "flightsClimbed": 34,
    "stepCount": 7843,
    "walkingSpeed": 2.633433
  },
  {
    "date": "2023-12-11",
    "activeEnergyBurned": 172.04500000000002,
    "basalEnergyBurned": 1441.934,
    "distanceWalkingRunning": 1.7790046,
    "flightsClimbed": 19,
    "stepCount": 4410,
    "walkingSpeed": 2.6482833333333335
  },
  {
    "date": "2023-12-12",
    "activeEnergyBurned": 360.972,
    "basalEnergyBurned": 1462.5510000000004,
    "distanceWalkingRunning": 4.319325599999999,
    "flightsClimbed": 37,
    "stepCount": 10690,
    "walkingSpeed": 2.728219056603774
  },
  {
    "date": "2023-12-13",
    "activeEnergyBurned": 539.533,
    "basalEnergyBurned": 1565.063,
    "distanceWalkingRunning": 5.84489357,
    "flightsClimbed": 44,
    "stepCount": 13134,
    "walkingSpeed": 2.8299522448979593
  },
  {
    "date": "2023-12-14",
    "activeEnergyBurned": 465.591,
    "basalEnergyBurned": 1501.923,
    "distanceWalkingRunning": 4.950864729999998,
    "flightsClimbed": 41,
    "stepCount": 11728,
    "walkingSpeed": 2.600314444444445
  },
  {
    "date": "2023-12-15",
    "activeEnergyBurned": 180.65200000000002,
    "basalEnergyBurned": 1468.8960000000002,
    "distanceWalkingRunning": 2.3590109099999994,
    "flightsClimbed": 18,
    "stepCount": 5934,
    "walkingSpeed": 2.6606384313725493
  },
  {
    "date": "2023-12-16",
    "activeEnergyBurned": 334.814,
    "basalEnergyBurned": 1420.7389999999998,
    "distanceWalkingRunning": 4.13746933,
    "flightsClimbed": 29,
    "stepCount": 10500,
    "walkingSpeed": 2.630397857142857
  },
  {
    "date": "2023-12-17",
    "activeEnergyBurned": 347.466,
    "basalEnergyBurned": 1535.64,
    "distanceWalkingRunning": 3.99155807,
    "flightsClimbed": 22,
    "stepCount": 9111,
    "walkingSpeed": 2.7937744642857143
  },
  {
    "date": "2023-12-18",
    "activeEnergyBurned": 231.02100000000002,
    "basalEnergyBurned": 1451.569,
    "distanceWalkingRunning": 2.6171727100000006,
    "flightsClimbed": 25,
    "stepCount": 6815,
    "walkingSpeed": 2.7095605128205134
  },
  {
    "date": "2023-12-19",
    "activeEnergyBurned": 331.991,
    "basalEnergyBurned": 1436.498,
    "distanceWalkingRunning": 3.9891097499999995,
    "flightsClimbed": 26,
    "stepCount": 9975,
    "walkingSpeed": 2.8632781818181816
  },
  {
    "date": "2023-12-20",
    "activeEnergyBurned": 285.501,
    "basalEnergyBurned": 1576.0339999999999,
    "distanceWalkingRunning": 3.4931751700000007,
    "flightsClimbed": 21,
    "stepCount": 8342,
    "walkingSpeed": 2.71053765625
  },
  {
    "date": "2023-12-21",
    "activeEnergyBurned": 241.517,
    "basalEnergyBurned": 1494.411,
    "distanceWalkingRunning": 2.65246399,
    "flightsClimbed": 33,
    "stepCount": 6469,
    "walkingSpeed": 2.857685
  },
  {
    "date": "2023-12-22",
    "activeEnergyBurned": 166.876,
    "basalEnergyBurned": 1478.628,
    "distanceWalkingRunning": 2.04609154,
    "flightsClimbed": 22,
    "stepCount": 5062,
    "walkingSpeed": 2.5159652631578946
  },
  {
    "date": "2023-12-23",
    "activeEnergyBurned": 120.50200000000001,
    "basalEnergyBurned": 1420.256,
    "distanceWalkingRunning": 2.0428562699999997,
    "flightsClimbed": 5,
    "stepCount": 5005,
    "walkingSpeed": 2.500983137254902
  },
  {
    "date": "2023-12-24",
    "activeEnergyBurned": 24.534,
    "basalEnergyBurned": 1472.519,
    "distanceWalkingRunning": 0.5177082199999999,
    "flightsClimbed": 3,
    "stepCount": 1242,
    "walkingSpeed": 2.25371
  },
  {
    "date": "2023-12-25",
    "activeEnergyBurned": 16.898,
    "basalEnergyBurned": 1446.757,
    "distanceWalkingRunning": 0.27587635,
    "flightsClimbed": 4,
    "stepCount": 743,
    "walkingSpeed": 2.02567
  },
  {
    "date": "2023-12-26",
    "activeEnergyBurned": 138.659,
    "basalEnergyBurned": 1443.0079999999998,
    "distanceWalkingRunning": 1.78669219,
    "flightsClimbed": 6,
    "stepCount": 3424,
    "walkingSpeed": 2.4129739130434786
  },
  {
    "date": "2023-12-27",
    "activeEnergyBurned": 117.12000000000002,
    "basalEnergyBurned": 1508.676,
    "distanceWalkingRunning": 1.39872518,
    "flightsClimbed": 7,
    "stepCount": 2310,
    "walkingSpeed": 2.6619525
  },
  {
    "date": "2023-12-28",
    "activeEnergyBurned": 86.096,
    "basalEnergyBurned": 1411.2669999999998,
    "distanceWalkingRunning": 1.1629515,
    "flightsClimbed": 5,
    "stepCount": 1987,
    "walkingSpeed": 2.0654383333333333
  },
  {
    "date": "2023-12-29",
    "activeEnergyBurned": 357.78099999999995,
    "basalEnergyBurned": 1514.6109999999999,
    "distanceWalkingRunning": 5.85217293,
    "flightsClimbed": 4,
    "stepCount": 13274,
    "walkingSpeed": 2.6157718279569893
  },
  {
    "date": "2023-12-30",
    "activeEnergyBurned": 65.709,
    "basalEnergyBurned": 1477.806,
    "distanceWalkingRunning": 0.9322631399999999,
    "flightsClimbed": 2,
    "stepCount": 1565,
    "walkingSpeed": 3.32558
  },
  {
    "date": "2023-12-31",
    "activeEnergyBurned": 199.185,
    "basalEnergyBurned": 1435.3020000000001,
    "distanceWalkingRunning": 2.6740702929999998,
    "flightsClimbed": 8,
    "stepCount": 4517,
    "walkingSpeed": 2.440205652173913
  },
  {
    "date": "2024-01-01",
    "activeEnergyBurned": 218.401,
    "basalEnergyBurned": 1485.0649999999998,
    "distanceWalkingRunning": 2.88704645,
    "flightsClimbed": 6,
    "stepCount": 4831,
    "walkingSpeed": 2.4028425000000007
  },
  {
    "date": "2024-01-02",
    "activeEnergyBurned": 119.356,
    "basalEnergyBurned": 1457.478,
    "distanceWalkingRunning": 1.5466485799999998,
    "flightsClimbed": 6,
    "stepCount": 2750,
    "walkingSpeed": 2.3935221428571434
  },
  {
    "date": "2024-01-03",
    "activeEnergyBurned": 160.839,
    "basalEnergyBurned": 1348.143,
    "distanceWalkingRunning": 2.07243332,
    "flightsClimbed": 6,
    "stepCount": 3666,
    "walkingSpeed": 2.3919235714285714
  },
  {
    "date": "2024-01-04",
    "activeEnergyBurned": 113.756,
    "basalEnergyBurned": 1550.1689999999999,
    "distanceWalkingRunning": 1.42802749,
    "flightsClimbed": 4,
    "stepCount": 2348,
    "walkingSpeed": 2.637098888888889
  },
  {
    "date": "2024-01-05",
    "activeEnergyBurned": 135.88,
    "basalEnergyBurned": 1489.278,
    "distanceWalkingRunning": 2.2669097600000003,
    "flightsClimbed": 5,
    "stepCount": 5346,
    "walkingSpeed": 2.6497533333333334
  },
  {
    "date": "2024-01-06",
    "activeEnergyBurned": 83.31499999999998,
    "basalEnergyBurned": 1326.1990000000003,
    "distanceWalkingRunning": 1.0976012800000001,
    "flightsClimbed": 13,
    "stepCount": 2440,
    "walkingSpeed": 2.4248399999999997
  },
  {
    "date": "2024-01-07",
    "activeEnergyBurned": 230.34,
    "basalEnergyBurned": 1608.5330000000001,
    "distanceWalkingRunning": 2.80846551,
    "flightsClimbed": 14,
    "stepCount": 6452,
    "walkingSpeed": 2.7365183333333336
  },
  {
    "date": "2024-01-08",
    "activeEnergyBurned": 373.108,
    "basalEnergyBurned": 1435.034,
    "distanceWalkingRunning": 4.139996192,
    "flightsClimbed": 37,
    "stepCount": 9916,
    "walkingSpeed": 2.6619545614035096
  },
  {
    "date": "2024-01-09",
    "activeEnergyBurned": 414.89000000000004,
    "basalEnergyBurned": 1554.425,
    "distanceWalkingRunning": 4.71541219,
    "flightsClimbed": 37,
    "stepCount": 11866,
    "walkingSpeed": 2.616928333333333
  },
  {
    "date": "2024-01-10",
    "activeEnergyBurned": 402.64799999999997,
    "basalEnergyBurned": 1403.2459999999999,
    "distanceWalkingRunning": 4.97350513,
    "flightsClimbed": 30,
    "stepCount": 11903,
    "walkingSpeed": 2.805204423076923
  },
  {
    "date": "2024-01-11",
    "activeEnergyBurned": 392.522,
    "basalEnergyBurned": 1574.907,
    "distanceWalkingRunning": 4.76279033,
    "flightsClimbed": 28,
    "stepCount": 11991,
    "walkingSpeed": 2.7072525
  },
  {
    "date": "2024-01-12",
    "activeEnergyBurned": 315.809,
    "basalEnergyBurned": 1517.8110000000001,
    "distanceWalkingRunning": 4.14998135,
    "flightsClimbed": 19,
    "stepCount": 9474,
    "walkingSpeed": 2.5481974390243898
  },
  {
    "date": "2024-01-13",
    "activeEnergyBurned": 228.403,
    "basalEnergyBurned": 1388.878,
    "distanceWalkingRunning": 3.767527752,
    "flightsClimbed": 9,
    "stepCount": 9757,
    "walkingSpeed": 2.3577925000000004
  },
  {
    "date": "2024-01-14",
    "activeEnergyBurned": 706.058,
    "basalEnergyBurned": 1646.1200000000003,
    "distanceWalkingRunning": 10.179913567,
    "flightsClimbed": 24,
    "stepCount": 24205,
    "walkingSpeed": 2.5732643661971832
  },
  {
    "date": "2024-01-15",
    "activeEnergyBurned": 142.88400000000001,
    "basalEnergyBurned": 1471.475,
    "distanceWalkingRunning": 1.84172543,
    "flightsClimbed": 13,
    "stepCount": 4654,
    "walkingSpeed": 2.6132199999999997
  },
  {
    "date": "2024-01-16",
    "activeEnergyBurned": 304.37999999999994,
    "basalEnergyBurned": 1444.775,
    "distanceWalkingRunning": 3.19206497,
    "flightsClimbed": 33,
    "stepCount": 8390,
    "walkingSpeed": 2.5730364999999997
  },
  {
    "date": "2024-01-17",
    "activeEnergyBurned": 296.64000000000004,
    "basalEnergyBurned": 1471.3530000000005,
    "distanceWalkingRunning": 3.64696634,
    "flightsClimbed": 18,
    "stepCount": 8921,
    "walkingSpeed": 2.8322503225806446
  },
  {
    "date": "2024-01-18",
    "activeEnergyBurned": 311.105,
    "basalEnergyBurned": 1521.441,
    "distanceWalkingRunning": 3.28253637,
    "flightsClimbed": 35,
    "stepCount": 7559,
    "walkingSpeed": 2.819311034482758
  },
  {
    "date": "2024-01-19",
    "activeEnergyBurned": 333.71200000000005,
    "basalEnergyBurned": 1461.748,
    "distanceWalkingRunning": 3.9479447000000008,
    "flightsClimbed": 27,
    "stepCount": 9865,
    "walkingSpeed": 2.751087230769231
  },
  {
    "date": "2024-01-20",
    "activeEnergyBurned": 286.124,
    "basalEnergyBurned": 1514.1019999999999,
    "distanceWalkingRunning": 3.9958017399999997,
    "flightsClimbed": 19,
    "stepCount": 9071
  },
  {
    "date": "2024-01-21",
    "activeEnergyBurned": 253.914,
    "basalEnergyBurned": 1482.9669999999999,
    "distanceWalkingRunning": 2.4766369400000006,
    "flightsClimbed": 33,
    "stepCount": 5895,
    "walkingSpeed": 2.5694767073170732
  },
  {
    "date": "2024-01-22",
    "activeEnergyBurned": 423.92199999999997,
    "basalEnergyBurned": 1460.2200000000003,
    "distanceWalkingRunning": 4.98905744,
    "flightsClimbed": 24,
    "stepCount": 11140,
    "walkingSpeed": 2.8545490243902445
  },
  {
    "date": "2024-01-23",
    "activeEnergyBurned": 215.666,
    "basalEnergyBurned": 1511.275,
    "distanceWalkingRunning": 2.7575657999999996,
    "flightsClimbed": 13,
    "stepCount": 6243,
    "walkingSpeed": 2.789591176470588
  },
  {
    "date": "2024-01-24",
    "activeEnergyBurned": 456.97,
    "basalEnergyBurned": 1453.913,
    "distanceWalkingRunning": 5.4655463599999985,
    "flightsClimbed": 26,
    "stepCount": 12605,
    "walkingSpeed": 2.6334564383561645
  },
  {
    "date": "2024-01-25",
    "activeEnergyBurned": 208.49900000000002,
    "basalEnergyBurned": 1512.976,
    "distanceWalkingRunning": 2.70861238,
    "flightsClimbed": 17,
    "stepCount": 6469,
    "walkingSpeed": 2.60043875
  },
  {
    "date": "2024-01-26",
    "activeEnergyBurned": 508.76900000000006,
    "basalEnergyBurned": 1417.1890000000003,
    "distanceWalkingRunning": 5.83457176,
    "flightsClimbed": 42,
    "stepCount": 13059,
    "walkingSpeed": 2.7178773529411764
  },
  {
    "date": "2024-01-27",
    "activeEnergyBurned": 159.89899999999997,
    "basalEnergyBurned": 1547.31,
    "distanceWalkingRunning": 1.8467220899999999,
    "flightsClimbed": 22,
    "stepCount": 4247,
    "walkingSpeed": 2.73667829787234
  },
  {
    "date": "2024-01-28",
    "activeEnergyBurned": 250.81099999999995,
    "basalEnergyBurned": 1439.997,
    "distanceWalkingRunning": 2.508606029,
    "flightsClimbed": 31,
    "stepCount": 5939,
    "walkingSpeed": 2.786002424242424
  },
  {
    "date": "2024-01-29",
    "activeEnergyBurned": 437.19,
    "basalEnergyBurned": 1488.985,
    "distanceWalkingRunning": 5.298304995999999,
    "flightsClimbed": 33,
    "stepCount": 12681,
    "walkingSpeed": 2.7090167532467535
  },
  {
    "date": "2024-01-30",
    "activeEnergyBurned": 285.726,
    "basalEnergyBurned": 1492.119,
    "distanceWalkingRunning": 3.02939386,
    "flightsClimbed": 32,
    "stepCount": 7740,
    "walkingSpeed": 2.739230303030303
  },
  {
    "date": "2024-01-31",
    "activeEnergyBurned": 390.041,
    "basalEnergyBurned": 1466.88,
    "distanceWalkingRunning": 4.49942206,
    "flightsClimbed": 19,
    "stepCount": 9771,
    "walkingSpeed": 2.75087225
  },
  {
    "date": "2024-02-01",
    "activeEnergyBurned": 236.784,
    "basalEnergyBurned": 1544.3500000000004,
    "distanceWalkingRunning": 3.00011144,
    "flightsClimbed": 16,
    "stepCount": 7057,
    "walkingSpeed": 2.761550952380953
  },
  {
    "date": "2024-02-02",
    "activeEnergyBurned": 297.934,
    "basalEnergyBurned": 1461.0829999999999,
    "distanceWalkingRunning": 3.3542802099999998,
    "flightsClimbed": 25,
    "stepCount": 7804,
    "walkingSpeed": 2.8291033333333333
  },
  {
    "date": "2024-02-03",
    "activeEnergyBurned": 265.396,
    "basalEnergyBurned": 1490.1800000000003,
    "distanceWalkingRunning": 3.13388457,
    "flightsClimbed": 22,
    "stepCount": 7732,
    "walkingSpeed": 2.8101512499999997
  },
  {
    "date": "2024-02-04",
    "activeEnergyBurned": 325.428,
    "basalEnergyBurned": 1496.879,
    "distanceWalkingRunning": 3.48697742,
    "flightsClimbed": 27,
    "stepCount": 8000,
    "walkingSpeed": 2.6798488000000003
  },
  {
    "date": "2024-02-05",
    "activeEnergyBurned": 430.41900000000004,
    "basalEnergyBurned": 1486.1400000000003,
    "distanceWalkingRunning": 4.856348140000001,
    "flightsClimbed": 37,
    "stepCount": 11380,
    "walkingSpeed": 2.7975266666666667
  },
  {
    "date": "2024-02-06",
    "activeEnergyBurned": 310.2339999999999,
    "basalEnergyBurned": 1435.68,
    "distanceWalkingRunning": 3.5274618099999997,
    "flightsClimbed": 33,
    "stepCount": 8530,
    "walkingSpeed": 2.471815
  },
  {
    "date": "2024-02-07",
    "activeEnergyBurned": 659.66,
    "basalEnergyBurned": 1587.2540000000004,
    "distanceWalkingRunning": 7.954762713,
    "flightsClimbed": 35,
    "stepCount": 17528,
    "walkingSpeed": 2.7141495726495726
  },
  {
    "date": "2024-02-08",
    "activeEnergyBurned": 303.042,
    "basalEnergyBurned": 1472.1999999999998,
    "distanceWalkingRunning": 3.4743992300000004,
    "flightsClimbed": 30,
    "stepCount": 8322,
    "walkingSpeed": 2.6491714285714285
  },
  {
    "date": "2024-02-09",
    "activeEnergyBurned": 361.29100000000005,
    "basalEnergyBurned": 1472.165,
    "distanceWalkingRunning": 4.15555021,
    "flightsClimbed": 29,
    "stepCount": 10516,
    "walkingSpeed": 2.843777179487179
  },
  {
    "date": "2024-02-10",
    "activeEnergyBurned": 433.896,
    "basalEnergyBurned": 1553.9470000000001,
    "distanceWalkingRunning": 6.393544100000001,
    "flightsClimbed": 17,
    "stepCount": 15567,
    "walkingSpeed": 2.4306455319148936
  },
  {
    "date": "2024-02-11",
    "activeEnergyBurned": 160.74400000000003,
    "basalEnergyBurned": 1325.363,
    "distanceWalkingRunning": 1.6568649899999999,
    "flightsClimbed": 18,
    "stepCount": 3952,
    "walkingSpeed": 2.7479907692307695
  },
  {
    "date": "2024-02-12",
    "activeEnergyBurned": 58.763,
    "basalEnergyBurned": 1473.166,
    "distanceWalkingRunning": 0.75233024,
    "flightsClimbed": 6,
    "stepCount": 1877,
    "walkingSpeed": 2.8692440000000006
  },
  {
    "date": "2024-02-13",
    "activeEnergyBurned": 114.66199999999999,
    "basalEnergyBurned": 1470.07,
    "distanceWalkingRunning": 1.18909437,
    "flightsClimbed": 12,
    "stepCount": 2783,
    "walkingSpeed": 2.5814239999999997
  },
  {
    "date": "2024-02-14",
    "activeEnergyBurned": 281.142,
    "basalEnergyBurned": 1570.028,
    "distanceWalkingRunning": 2.7777587299999995,
    "flightsClimbed": 38,
    "stepCount": 5834,
    "walkingSpeed": 3.0214628571428572
  },
  {
    "date": "2024-02-15",
    "activeEnergyBurned": 246.61999999999998,
    "basalEnergyBurned": 1428.9810000000002,
    "distanceWalkingRunning": 2.71046596,
    "flightsClimbed": 21,
    "stepCount": 6154,
    "walkingSpeed": 2.6517274285714287
  },
  {
    "date": "2024-02-16",
    "activeEnergyBurned": 228.542,
    "basalEnergyBurned": 1526.982,
    "distanceWalkingRunning": 2.72547656,
    "flightsClimbed": 15,
    "stepCount": 6277,
    "walkingSpeed": 2.7932521739130434
  },
  {
    "date": "2024-02-17",
    "activeEnergyBurned": 166.326,
    "basalEnergyBurned": 1402.6490000000001,
    "distanceWalkingRunning": 2.11993161,
    "flightsClimbed": 17,
    "stepCount": 5096,
    "walkingSpeed": 2.5828625000000005
  },
  {
    "date": "2024-02-18",
    "activeEnergyBurned": 741.911,
    "basalEnergyBurned": 1584.425,
    "distanceWalkingRunning": 8.33227233,
    "flightsClimbed": 54,
    "stepCount": 19251,
    "walkingSpeed": 2.5933141095890413
  },
  {
    "date": "2024-02-19",
    "activeEnergyBurned": 397.75999999999993,
    "basalEnergyBurned": 1473.533,
    "distanceWalkingRunning": 4.2519762000000005,
    "flightsClimbed": 31,
    "stepCount": 9725,
    "walkingSpeed": 2.7296825
  },
  {
    "date": "2024-02-20",
    "activeEnergyBurned": 291.82899999999995,
    "basalEnergyBurned": 1500.6510000000003,
    "distanceWalkingRunning": 3.35586574,
    "flightsClimbed": 28,
    "stepCount": 8108,
    "walkingSpeed": 2.5219857142857145
  },
  {
    "date": "2024-02-21",
    "activeEnergyBurned": 418.976,
    "basalEnergyBurned": 1520.3549999999998,
    "distanceWalkingRunning": 4.67315936,
    "flightsClimbed": 28,
    "stepCount": 11117,
    "walkingSpeed": 2.618232727272727
  },
  {
    "date": "2024-02-22",
    "activeEnergyBurned": 255.32000000000002,
    "basalEnergyBurned": 1452.6020000000003,
    "distanceWalkingRunning": 3.07086625,
    "flightsClimbed": 30,
    "stepCount": 7402,
    "walkingSpeed": 2.5315453191489357
  },
  {
    "date": "2024-02-23",
    "activeEnergyBurned": 216.065,
    "basalEnergyBurned": 1493.3579999999997,
    "distanceWalkingRunning": 2.4066351499999996,
    "flightsClimbed": 27,
    "stepCount": 5551,
    "walkingSpeed": 2.6097587499999997
  },
  {
    "date": "2024-02-24",
    "activeEnergyBurned": 315.368,
    "basalEnergyBurned": 1504.7200000000003,
    "distanceWalkingRunning": 3.85793758,
    "flightsClimbed": 32,
    "stepCount": 9671,
    "walkingSpeed": 2.694794042553191
  },
  {
    "date": "2024-02-25",
    "activeEnergyBurned": 512.0640000000001,
    "basalEnergyBurned": 1484.2499999999998,
    "distanceWalkingRunning": 4.957907860000001,
    "flightsClimbed": 41,
    "stepCount": 10736,
    "walkingSpeed": 2.674737142857143
  },
  {
    "date": "2024-02-26",
    "activeEnergyBurned": 264.902,
    "basalEnergyBurned": 1473.243,
    "distanceWalkingRunning": 3.14173891,
    "flightsClimbed": 23,
    "stepCount": 8290,
    "walkingSpeed": 2.69659064516129
  },
  {
    "date": "2024-02-27",
    "activeEnergyBurned": 300.04400000000004,
    "basalEnergyBurned": 1485.4260000000002,
    "distanceWalkingRunning": 3.51298389,
    "flightsClimbed": 25,
    "stepCount": 8227,
    "walkingSpeed": 2.6435320588235296
  },
  {
    "date": "2024-02-28",
    "activeEnergyBurned": 366.2369999999999,
    "basalEnergyBurned": 1508.085,
    "distanceWalkingRunning": 4.28711273,
    "flightsClimbed": 27,
    "stepCount": 10551,
    "walkingSpeed": 2.6181674468085103
  },
  {
    "date": "2024-02-29",
    "activeEnergyBurned": 275.59000000000003,
    "basalEnergyBurned": 1482.6740000000002,
    "distanceWalkingRunning": 2.661720127,
    "flightsClimbed": 29,
    "stepCount": 6304,
    "walkingSpeed": 2.727341794871795
  },
  {
    "date": "2024-03-01",
    "activeEnergyBurned": 247.504,
    "basalEnergyBurned": 1346.0180000000003,
    "distanceWalkingRunning": 3.1847276300000003,
    "flightsClimbed": 15,
    "stepCount": 7590,
    "walkingSpeed": 2.5805678723404255
  },
  {
    "date": "2024-03-02",
    "activeEnergyBurned": 180.874,
    "basalEnergyBurned": 1617.3239999999998,
    "distanceWalkingRunning": 2.28910634,
    "flightsClimbed": 15,
    "stepCount": 6222,
    "walkingSpeed": 2.668878095238095
  },
  {
    "date": "2024-03-03",
    "activeEnergyBurned": 218.81399999999996,
    "basalEnergyBurned": 1465.2870000000005,
    "distanceWalkingRunning": 2.5431659200000003,
    "flightsClimbed": 25,
    "stepCount": 5854,
    "walkingSpeed": 2.697649361702127
  },
  {
    "date": "2024-03-04",
    "activeEnergyBurned": 332.219,
    "basalEnergyBurned": 1483.9830000000002,
    "distanceWalkingRunning": 3.91522346,
    "flightsClimbed": 23,
    "stepCount": 9493,
    "walkingSpeed": 2.7017712
  },
  {
    "date": "2024-03-05",
    "activeEnergyBurned": 268.833,
    "basalEnergyBurned": 1493.964,
    "distanceWalkingRunning": 2.872475809,
    "flightsClimbed": 26,
    "stepCount": 7054,
    "walkingSpeed": 2.7001458536585363
  },
  {
    "date": "2024-03-06",
    "activeEnergyBurned": 288.049,
    "basalEnergyBurned": 1431.8860000000002,
    "distanceWalkingRunning": 3.54718271,
    "flightsClimbed": 22,
    "stepCount": 8718,
    "walkingSpeed": 2.6952488372093026
  },
  {
    "date": "2024-03-07",
    "activeEnergyBurned": 177.78699999999998,
    "basalEnergyBurned": 1464.6050000000002,
    "distanceWalkingRunning": 2.000541354,
    "flightsClimbed": 20,
    "stepCount": 4780,
    "walkingSpeed": 2.573221666666667
  },
  {
    "date": "2024-03-08",
    "activeEnergyBurned": 343.72299999999996,
    "basalEnergyBurned": 1468.7310000000002,
    "distanceWalkingRunning": 3.823757057,
    "flightsClimbed": 34,
    "stepCount": 8749,
    "walkingSpeed": 2.7181648717948717
  },
  {
    "date": "2024-03-09",
    "activeEnergyBurned": 345.92599999999993,
    "basalEnergyBurned": 1566.4610000000002,
    "distanceWalkingRunning": 3.979248890000001,
    "flightsClimbed": 30,
    "stepCount": 9387,
    "walkingSpeed": 2.7062863636363645
  },
  {
    "date": "2024-03-10",
    "activeEnergyBurned": 177.983,
    "basalEnergyBurned": 1420.438,
    "distanceWalkingRunning": 1.8688545500000002,
    "flightsClimbed": 22,
    "stepCount": 4487,
    "walkingSpeed": 2.739004444444445
  },
  {
    "date": "2024-03-11",
    "activeEnergyBurned": 482.18499999999995,
    "basalEnergyBurned": 1485.6049999999998,
    "distanceWalkingRunning": 4.53551481,
    "flightsClimbed": 59,
    "stepCount": 11411,
    "walkingSpeed": 2.896087
  },
  {
    "date": "2024-03-12",
    "activeEnergyBurned": 348.036,
    "basalEnergyBurned": 1531.5619999999997,
    "distanceWalkingRunning": 3.8705203100000003,
    "flightsClimbed": 35,
    "stepCount": 9065,
    "walkingSpeed": 2.787472222222222
  },
  {
    "date": "2024-03-13",
    "activeEnergyBurned": 328.017,
    "basalEnergyBurned": 1508.5260000000003,
    "distanceWalkingRunning": 4.15208259,
    "flightsClimbed": 19,
    "stepCount": 9946,
    "walkingSpeed": 2.671228780487805
  },
  {
    "date": "2024-03-14",
    "activeEnergyBurned": 431.10499999999996,
    "basalEnergyBurned": 1422.338,
    "distanceWalkingRunning": 5.242968439999999,
    "flightsClimbed": 35,
    "stepCount": 13456,
    "walkingSpeed": 2.688494406779661
  },
  {
    "date": "2024-03-15",
    "activeEnergyBurned": 256.469,
    "basalEnergyBurned": 1535.614,
    "distanceWalkingRunning": 2.8724372200000006,
    "flightsClimbed": 26,
    "stepCount": 6591,
    "walkingSpeed": 2.6894074999999997
  },
  {
    "date": "2024-03-16",
    "activeEnergyBurned": 230.20299999999997,
    "basalEnergyBurned": 1524.7189999999998,
    "distanceWalkingRunning": 4.31807675,
    "flightsClimbed": 4,
    "stepCount": 11671,
    "walkingSpeed": 2.259819885057471
  },
  {
    "date": "2024-03-17",
    "activeEnergyBurned": 93.59,
    "basalEnergyBurned": 1471.8919999999998,
    "distanceWalkingRunning": 1.6304734099999998,
    "flightsClimbed": 10,
    "stepCount": 4105,
    "walkingSpeed": 2.3701808695652176
  },
  {
    "date": "2024-03-18",
    "activeEnergyBurned": 77.492,
    "basalEnergyBurned": 1438.5460000000003,
    "distanceWalkingRunning": 1.228877556,
    "flightsClimbed": 9,
    "stepCount": 2843,
    "walkingSpeed": 2.4667309090909098
  },
  {
    "date": "2024-03-19",
    "activeEnergyBurned": 239.81500000000003,
    "basalEnergyBurned": 1431.532,
    "distanceWalkingRunning": 3.49119583,
    "flightsClimbed": 5,
    "stepCount": 8008,
    "walkingSpeed": 2.5880681818181817
  },
  {
    "date": "2024-03-20",
    "activeEnergyBurned": 552.3299999999999,
    "basalEnergyBurned": 1539.1560000000002,
    "distanceWalkingRunning": 7.975564889999999,
    "flightsClimbed": 27,
    "stepCount": 18929,
    "walkingSpeed": 2.710875853658537
  },
  {
    "date": "2024-03-21",
    "activeEnergyBurned": 196.61699999999996,
    "basalEnergyBurned": 1526.344,
    "distanceWalkingRunning": 3.117830612,
    "flightsClimbed": 9,
    "stepCount": 7403,
    "walkingSpeed": 2.5744849999999997
  },
  {
    "date": "2024-03-22",
    "activeEnergyBurned": 127.36999999999999,
    "basalEnergyBurned": 1379.889,
    "distanceWalkingRunning": 2.16749454,
    "flightsClimbed": 8,
    "stepCount": 4757,
    "walkingSpeed": 2.4985903030303036
  },
  {
    "date": "2024-03-23",
    "activeEnergyBurned": 167.507,
    "basalEnergyBurned": 1489.8749999999998,
    "distanceWalkingRunning": 2.1063686,
    "flightsClimbed": 18,
    "stepCount": 5055,
    "walkingSpeed": 2.7203100000000004
  },
  {
    "date": "2024-03-24",
    "activeEnergyBurned": 394.83,
    "basalEnergyBurned": 1492.0700000000002,
    "distanceWalkingRunning": 4.682352590000001,
    "flightsClimbed": 37,
    "stepCount": 11918,
    "walkingSpeed": 2.5525166153846155
  },
  {
    "date": "2024-03-25",
    "activeEnergyBurned": 380.69,
    "basalEnergyBurned": 1497.382,
    "distanceWalkingRunning": 4.40021577,
    "flightsClimbed": 28,
    "stepCount": 10523,
    "walkingSpeed": 2.631318043478261
  },
  {
    "date": "2024-03-26",
    "activeEnergyBurned": 276.95000000000005,
    "basalEnergyBurned": 1555.268,
    "distanceWalkingRunning": 3.0597327300000003,
    "flightsClimbed": 24,
    "stepCount": 7046,
    "walkingSpeed": 2.762296285714286
  },
  {
    "date": "2024-03-27",
    "activeEnergyBurned": 393.314,
    "basalEnergyBurned": 1473.5660000000003,
    "distanceWalkingRunning": 4.58243238,
    "flightsClimbed": 23,
    "stepCount": 11521,
    "walkingSpeed": 2.64557625
  },
  {
    "date": "2024-03-28",
    "activeEnergyBurned": 349.473,
    "basalEnergyBurned": 1450.56,
    "distanceWalkingRunning": 4.42984043,
    "flightsClimbed": 22,
    "stepCount": 10997,
    "walkingSpeed": 2.7236210810810815
  },
  {
    "date": "2024-03-29",
    "activeEnergyBurned": 511.75700000000006,
    "basalEnergyBurned": 1592.793,
    "distanceWalkingRunning": 6.006789773,
    "flightsClimbed": 43,
    "stepCount": 14795,
    "walkingSpeed": 2.710018648648649
  },
  {
    "date": "2024-03-30",
    "activeEnergyBurned": 344.234,
    "basalEnergyBurned": 1351.835,
    "distanceWalkingRunning": 3.4306592900000004,
    "flightsClimbed": 41,
    "stepCount": 8001,
    "walkingSpeed": 2.6797670370370366
  },
  {
    "date": "2024-03-31",
    "activeEnergyBurned": 361.94899999999996,
    "basalEnergyBurned": 1615.8679999999997,
    "distanceWalkingRunning": 3.93480983,
    "flightsClimbed": 31,
    "stepCount": 9288,
    "walkingSpeed": 2.7165869230769237
  },
  {
    "date": "2024-04-01",
    "activeEnergyBurned": 394.252,
    "basalEnergyBurned": 1359.71,
    "distanceWalkingRunning": 4.33581534,
    "flightsClimbed": 34,
    "stepCount": 10188,
    "walkingSpeed": 2.695094074074074
  },
  {
    "date": "2024-04-02",
    "activeEnergyBurned": 350.514,
    "basalEnergyBurned": 1529.661,
    "distanceWalkingRunning": 3.82111564,
    "flightsClimbed": 37,
    "stepCount": 9714,
    "walkingSpeed": 2.811868596491228
  },
  {
    "date": "2024-04-03",
    "activeEnergyBurned": 446.90099999999995,
    "basalEnergyBurned": 1597.6390000000001,
    "distanceWalkingRunning": 4.52914914,
    "flightsClimbed": 39,
    "stepCount": 10578,
    "walkingSpeed": 2.7290619999999994
  },
  {
    "date": "2024-04-04",
    "activeEnergyBurned": 375.11999999999995,
    "basalEnergyBurned": 1473.8799999999999,
    "distanceWalkingRunning": 4.283072272,
    "flightsClimbed": 38,
    "stepCount": 9684,
    "walkingSpeed": 2.8161425
  },
  {
    "date": "2024-04-05",
    "activeEnergyBurned": 369.5,
    "basalEnergyBurned": 1512.306,
    "distanceWalkingRunning": 4.49005835,
    "flightsClimbed": 29,
    "stepCount": 10521,
    "walkingSpeed": 2.6318705172413788
  },
  {
    "date": "2024-04-06",
    "activeEnergyBurned": 204.50599999999997,
    "basalEnergyBurned": 1413.122,
    "distanceWalkingRunning": 2.1503770799999997,
    "flightsClimbed": 22,
    "stepCount": 5131,
    "walkingSpeed": 2.6121635483870973
  },
  {
    "date": "2024-04-07",
    "activeEnergyBurned": 274.896,
    "basalEnergyBurned": 1508.4359999999997,
    "distanceWalkingRunning": 2.69046878,
    "flightsClimbed": 29,
    "stepCount": 5875,
    "walkingSpeed": 2.783121388888889
  },
  {
    "date": "2024-04-08",
    "activeEnergyBurned": 359.753,
    "basalEnergyBurned": 1499.843,
    "distanceWalkingRunning": 4.01869246,
    "flightsClimbed": 32,
    "stepCount": 10162,
    "walkingSpeed": 2.8064486486486486
  },
  {
    "date": "2024-04-09",
    "activeEnergyBurned": 294.154,
    "basalEnergyBurned": 1518.3300000000002,
    "distanceWalkingRunning": 3.462834343999999,
    "flightsClimbed": 23,
    "stepCount": 8420,
    "walkingSpeed": 2.66956
  },
  {
    "date": "2024-04-10",
    "activeEnergyBurned": 296.7,
    "basalEnergyBurned": 1386.221,
    "distanceWalkingRunning": 3.4384869199999994,
    "flightsClimbed": 27,
    "stepCount": 8655,
    "walkingSpeed": 2.7051320930232556
  },
  {
    "date": "2024-04-11",
    "activeEnergyBurned": 243.79199999999997,
    "basalEnergyBurned": 1574.0729999999999,
    "distanceWalkingRunning": 2.99464124,
    "flightsClimbed": 21,
    "stepCount": 7312,
    "walkingSpeed": 2.709813488372093
  },
  {
    "date": "2024-04-12",
    "activeEnergyBurned": 236.12099999999998,
    "basalEnergyBurned": 1296.0590000000004,
    "distanceWalkingRunning": 3.1912566099999995,
    "flightsClimbed": 13,
    "stepCount": 7715,
    "walkingSpeed": 2.543716666666667
  },
  {
    "date": "2024-04-13",
    "activeEnergyBurned": 41.918,
    "basalEnergyBurned": 1639.4899999999998,
    "distanceWalkingRunning": 0.6508795799999999,
    "flightsClimbed": 7,
    "stepCount": 1740,
    "walkingSpeed": 2.37861
  },
  {
    "date": "2024-04-14",
    "activeEnergyBurned": 179.765,
    "basalEnergyBurned": 1398.9920000000002,
    "distanceWalkingRunning": 2.36181327,
    "flightsClimbed": 14,
    "stepCount": 6338,
    "walkingSpeed": 2.855355625
  },
  {
    "date": "2024-04-15",
    "activeEnergyBurned": 235.4,
    "basalEnergyBurned": 1391.6490000000003,
    "distanceWalkingRunning": 2.4856226699999997,
    "flightsClimbed": 23,
    "stepCount": 5897,
    "walkingSpeed": 2.6317549999999996
  },
  {
    "date": "2024-04-16",
    "activeEnergyBurned": 265.3020000000001,
    "basalEnergyBurned": 1584.063,
    "distanceWalkingRunning": 3.17236056,
    "flightsClimbed": 26,
    "stepCount": 7904,
    "walkingSpeed": 2.6924140425531915
  },
  {
    "date": "2024-04-17",
    "activeEnergyBurned": 410.566,
    "basalEnergyBurned": 1487.5210000000002,
    "distanceWalkingRunning": 4.56465586,
    "flightsClimbed": 28,
    "stepCount": 10592,
    "walkingSpeed": 2.6420706666666667
  },
  {
    "date": "2024-04-18",
    "activeEnergyBurned": 245.042,
    "basalEnergyBurned": 1525.409,
    "distanceWalkingRunning": 3.0558185,
    "flightsClimbed": 23,
    "stepCount": 8325,
    "walkingSpeed": 2.5501088095238096
  },
  {
    "date": "2024-04-19",
    "activeEnergyBurned": 265.72400000000005,
    "basalEnergyBurned": 1500.679,
    "distanceWalkingRunning": 2.7976148700000008,
    "flightsClimbed": 29,
    "stepCount": 6822,
    "walkingSpeed": 2.6449345652173912
  },
  {
    "date": "2024-04-20",
    "activeEnergyBurned": 261.74,
    "basalEnergyBurned": 1491.655,
    "distanceWalkingRunning": 3.50547757,
    "flightsClimbed": 17,
    "stepCount": 8295,
    "walkingSpeed": 2.7027462745098036
  },
  {
    "date": "2024-04-21",
    "activeEnergyBurned": 436.117,
    "basalEnergyBurned": 1477.487,
    "distanceWalkingRunning": 5.03669822,
    "flightsClimbed": 38,
    "stepCount": 12618,
    "walkingSpeed": 2.4603468354430382
  },
  {
    "date": "2024-04-22",
    "activeEnergyBurned": 370.63599999999997,
    "basalEnergyBurned": 1407.0020000000004,
    "distanceWalkingRunning": 4.051577549999999,
    "flightsClimbed": 33,
    "stepCount": 10719,
    "walkingSpeed": 2.600153898305085
  },
  {
    "date": "2024-04-23",
    "activeEnergyBurned": 242.03800000000004,
    "basalEnergyBurned": 1602.389,
    "distanceWalkingRunning": 2.700295562000001,
    "flightsClimbed": 28,
    "stepCount": 7019,
    "walkingSpeed": 2.687008
  },
  {
    "date": "2024-04-24",
    "activeEnergyBurned": 297.4990000000001,
    "basalEnergyBurned": 1451.9199999999998,
    "distanceWalkingRunning": 3.485694139999999,
    "flightsClimbed": 32,
    "stepCount": 8344,
    "walkingSpeed": 2.5549252307692307
  },
  {
    "date": "2024-04-25",
    "activeEnergyBurned": 268.93600000000004,
    "basalEnergyBurned": 1440.647,
    "distanceWalkingRunning": 2.7212027,
    "flightsClimbed": 34,
    "stepCount": 7047,
    "walkingSpeed": 2.649371875
  },
  {
    "date": "2024-04-26",
    "activeEnergyBurned": 158.89400000000003,
    "basalEnergyBurned": 1522.028,
    "distanceWalkingRunning": 2.002760154,
    "flightsClimbed": 21,
    "stepCount": 4913,
    "walkingSpeed": 2.601728846153846
  },
  {
    "date": "2024-04-27",
    "activeEnergyBurned": 202.11700000000002,
    "basalEnergyBurned": 1468.765,
    "distanceWalkingRunning": 1.95027227,
    "flightsClimbed": 32,
    "stepCount": 4523,
    "walkingSpeed": 2.8978495454545454
  },
  {
    "date": "2024-04-28",
    "activeEnergyBurned": 164.598,
    "basalEnergyBurned": 1265.3029999999999,
    "distanceWalkingRunning": 1.8420426400000003,
    "flightsClimbed": 16,
    "stepCount": 4729,
    "walkingSpeed": 2.8008810526315795
  },
  {
    "date": "2024-04-29",
    "activeEnergyBurned": 429.133,
    "basalEnergyBurned": 1681.7779999999998,
    "distanceWalkingRunning": 4.946344369999999,
    "flightsClimbed": 34,
    "stepCount": 12178,
    "walkingSpeed": 2.705226393442623
  },
  {
    "date": "2024-04-30",
    "activeEnergyBurned": 248.876,
    "basalEnergyBurned": 1507.045,
    "distanceWalkingRunning": 2.9024427169999996,
    "flightsClimbed": 28,
    "stepCount": 7363,
    "walkingSpeed": 2.5516235593220338
  },
  {
    "date": "2024-05-01",
    "activeEnergyBurned": 406.39200000000005,
    "basalEnergyBurned": 1525.204,
    "distanceWalkingRunning": 4.713037087000002,
    "flightsClimbed": 31,
    "stepCount": 11464,
    "walkingSpeed": 2.7651964102564097
  },
  {
    "date": "2024-05-02",
    "activeEnergyBurned": 283.552,
    "basalEnergyBurned": 1470.999,
    "distanceWalkingRunning": 3.34311128,
    "flightsClimbed": 29,
    "stepCount": 8943,
    "walkingSpeed": 2.7147128301886796
  },
  {
    "date": "2024-05-03",
    "activeEnergyBurned": 195.392,
    "basalEnergyBurned": 1469.682,
    "distanceWalkingRunning": 2.2596172300000004,
    "flightsClimbed": 25,
    "stepCount": 5601,
    "walkingSpeed": 2.5297715909090908
  },
  {
    "date": "2024-05-04",
    "activeEnergyBurned": 274.4720000000001,
    "basalEnergyBurned": 1515.8990000000001,
    "distanceWalkingRunning": 3.4052681000000002,
    "flightsClimbed": 13,
    "stepCount": 8121,
    "walkingSpeed": 2.634199814814815
  },
  {
    "date": "2024-05-05",
    "activeEnergyBurned": 181.813,
    "basalEnergyBurned": 1423.3909999999998,
    "distanceWalkingRunning": 1.8040508199999998,
    "flightsClimbed": 22,
    "stepCount": 4238,
    "walkingSpeed": 2.6927112500000003
  },
  {
    "date": "2024-05-06",
    "activeEnergyBurned": 326.828,
    "basalEnergyBurned": 1503.028,
    "distanceWalkingRunning": 4.07163098,
    "flightsClimbed": 22,
    "stepCount": 10445,
    "walkingSpeed": 2.602807627118644
  },
  {
    "date": "2024-05-07",
    "activeEnergyBurned": 239.38400000000001,
    "basalEnergyBurned": 1482.832,
    "distanceWalkingRunning": 3.061139223,
    "flightsClimbed": 21,
    "stepCount": 7754,
    "walkingSpeed": 2.6440582222222226
  },
  {
    "date": "2024-05-08",
    "activeEnergyBurned": 250.86600000000004,
    "basalEnergyBurned": 1516.5300000000002,
    "distanceWalkingRunning": 2.7127321799999997,
    "flightsClimbed": 33,
    "stepCount": 7212,
    "walkingSpeed": 2.6212822727272727
  },
  {
    "date": "2024-05-09",
    "activeEnergyBurned": 291.891,
    "basalEnergyBurned": 1772.827,
    "distanceWalkingRunning": 3.47391839,
    "flightsClimbed": 26,
    "stepCount": 8257,
    "walkingSpeed": 2.8597199999999994
  },
  {
    "date": "2024-05-10",
    "activeEnergyBurned": 243.142,
    "basalEnergyBurned": 1682.0939999999998,
    "distanceWalkingRunning": 2.9931426599999997,
    "flightsClimbed": 28,
    "stepCount": 7354,
    "walkingSpeed": 2.6493712499999997
  },
  {
    "date": "2024-05-11",
    "activeEnergyBurned": 170.612,
    "basalEnergyBurned": 1635.4550000000004,
    "distanceWalkingRunning": 2.007819575,
    "flightsClimbed": 16,
    "stepCount": 4649,
    "walkingSpeed": 2.6416413793103444
  },
  {
    "date": "2024-05-12",
    "activeEnergyBurned": 217.517,
    "basalEnergyBurned": 1728.543,
    "distanceWalkingRunning": 2.86157606,
    "flightsClimbed": 13,
    "stepCount": 7804,
    "walkingSpeed": 2.5517950943396226
  },
  {
    "date": "2024-05-13",
    "activeEnergyBurned": 301.72999999999996,
    "basalEnergyBurned": 1659.549,
    "distanceWalkingRunning": 3.4636458599999997,
    "flightsClimbed": 26,
    "stepCount": 8168,
    "walkingSpeed": 2.642858536585366
  },
  {
    "date": "2024-05-14",
    "activeEnergyBurned": 250.94399999999996,
    "basalEnergyBurned": 1591.3729999999998,
    "distanceWalkingRunning": 3.13648202,
    "flightsClimbed": 22,
    "stepCount": 7707,
    "walkingSpeed": 2.612390784313725
  },
  {
    "date": "2024-05-15",
    "activeEnergyBurned": 320.576,
    "basalEnergyBurned": 1780.4909999999998,
    "distanceWalkingRunning": 4.07793409,
    "flightsClimbed": 28,
    "stepCount": 10017,
    "walkingSpeed": 2.7450404285714285
  },
  {
    "date": "2024-05-16",
    "activeEnergyBurned": 151.976,
    "basalEnergyBurned": 1619.4399999999998,
    "distanceWalkingRunning": 1.9305938870000001,
    "flightsClimbed": 13,
    "stepCount": 4446,
    "walkingSpeed": 2.767965652173913
  },
  {
    "date": "2024-05-17",
    "activeEnergyBurned": 190.227,
    "basalEnergyBurned": 1745.454,
    "distanceWalkingRunning": 2.467259,
    "flightsClimbed": 22,
    "stepCount": 6370,
    "walkingSpeed": 2.8228
  },
  {
    "date": "2024-05-18",
    "activeEnergyBurned": 149.91899999999998,
    "basalEnergyBurned": 1693.8110000000004,
    "distanceWalkingRunning": 1.8963449099999998,
    "flightsClimbed": 9,
    "stepCount": 2806,
    "walkingSpeed": 2.3085180000000003
  },
  {
    "date": "2024-05-19",
    "activeEnergyBurned": 10.51,
    "basalEnergyBurned": 1657.484,
    "distanceWalkingRunning": 0.28364959,
    "flightsClimbed": 2,
    "stepCount": 643,
    "walkingSpeed": 1.8454700000000002
  },
  {
    "date": "2024-05-20",
    "activeEnergyBurned": 163.346,
    "basalEnergyBurned": 1670.1909999999998,
    "distanceWalkingRunning": 2.07676632,
    "flightsClimbed": 8,
    "stepCount": 3120,
    "walkingSpeed": 2.3085180000000003
  },
  {
    "date": "2024-05-21",
    "activeEnergyBurned": 128.14699999999996,
    "basalEnergyBurned": 1510.419,
    "distanceWalkingRunning": 1.8705004099999993,
    "flightsClimbed": 5,
    "stepCount": 3659,
    "walkingSpeed": 2.4236048275862068
  },
  {
    "date": "2024-05-22",
    "activeEnergyBurned": 57.39600000000001,
    "basalEnergyBurned": 1823.8509999999999,
    "distanceWalkingRunning": 0.84438829,
    "flightsClimbed": 5,
    "stepCount": 1603,
    "walkingSpeed": 2.147455
  },
  {
    "date": "2024-05-23",
    "activeEnergyBurned": 164.91300000000004,
    "basalEnergyBurned": 1548.0790000000002,
    "distanceWalkingRunning": 2.09071522,
    "flightsClimbed": 7,
    "stepCount": 3216,
    "walkingSpeed": 2.4640723076923075
  },
  {
    "date": "2024-05-24",
    "activeEnergyBurned": 102.513,
    "basalEnergyBurned": 1765.6889999999999,
    "distanceWalkingRunning": 1.60447956,
    "flightsClimbed": 6,
    "stepCount": 3022,
    "walkingSpeed": 2.268892857142857
  },
  {
    "date": "2024-05-25",
    "activeEnergyBurned": 117.071,
    "basalEnergyBurned": 1599.4409999999998,
    "distanceWalkingRunning": 1.8296271510000002,
    "flightsClimbed": 6,
    "stepCount": 4735,
    "walkingSpeed": 2.333355517241379
  },
  {
    "date": "2024-05-26",
    "activeEnergyBurned": 178.16700000000003,
    "basalEnergyBurned": 1720.9740000000002,
    "distanceWalkingRunning": 2.31987662,
    "flightsClimbed": 9,
    "stepCount": 3902,
    "walkingSpeed": 2.3108526086956522
  },
  {
    "date": "2024-05-27",
    "activeEnergyBurned": 290.301,
    "basalEnergyBurned": 1721.8749999999998,
    "distanceWalkingRunning": 4.72017945,
    "flightsClimbed": 9,
    "stepCount": 12217,
    "walkingSpeed": 2.5161675862068966
  },
  {
    "date": "2024-05-28",
    "activeEnergyBurned": 323.165,
    "basalEnergyBurned": 1696.173,
    "distanceWalkingRunning": 4.68355255,
    "flightsClimbed": 16,
    "stepCount": 11933,
    "walkingSpeed": 2.424984471544716
  },
  {
    "date": "2024-05-29",
    "activeEnergyBurned": 228.26599999999996,
    "basalEnergyBurned": 1671.6889999999999,
    "distanceWalkingRunning": 3.627219942,
    "flightsClimbed": 6,
    "stepCount": 9283,
    "walkingSpeed": 2.457260136986301
  },
  {
    "date": "2024-05-30",
    "activeEnergyBurned": 139.97699999999998,
    "basalEnergyBurned": 1631.702,
    "distanceWalkingRunning": 1.9626699969999999,
    "flightsClimbed": 7,
    "stepCount": 5190,
    "walkingSpeed": 2.596305652173913
  },
  {
    "date": "2024-05-31",
    "activeEnergyBurned": 234.82999999999996,
    "basalEnergyBurned": 1713.2879999999998,
    "distanceWalkingRunning": 3.32027274,
    "flightsClimbed": 17,
    "stepCount": 8470,
    "walkingSpeed": 2.6503698214285714
  },
  {
    "date": "2024-06-01",
    "activeEnergyBurned": 170.972,
    "basalEnergyBurned": 1710.4339999999997,
    "distanceWalkingRunning": 3.11799651,
    "flightsClimbed": 6,
    "stepCount": 8135,
    "walkingSpeed": 2.455332368421053
  },
  {
    "date": "2024-06-02",
    "activeEnergyBurned": 65.075,
    "basalEnergyBurned": 1546.058,
    "distanceWalkingRunning": 0.92734594,
    "flightsClimbed": 4,
    "stepCount": 1653,
    "walkingSpeed": 2.368667777777778
  },
  {
    "date": "2024-06-03",
    "activeEnergyBurned": 98.166,
    "basalEnergyBurned": 1767.5800000000002,
    "distanceWalkingRunning": 1.3525570199999999,
    "flightsClimbed": 8,
    "stepCount": 2514,
    "walkingSpeed": 2.35624
  },
  {
    "date": "2024-06-04",
    "activeEnergyBurned": 41.303999999999995,
    "basalEnergyBurned": 1564.164,
    "distanceWalkingRunning": 0.59951163,
    "flightsClimbed": 2,
    "stepCount": 1110,
    "walkingSpeed": 2.24812
  },
  {
    "date": "2024-06-05",
    "activeEnergyBurned": 100.57300000000001,
    "basalEnergyBurned": 1813.6680000000001,
    "distanceWalkingRunning": 1.60555565,
    "flightsClimbed": 6,
    "stepCount": 3469,
    "walkingSpeed": 2.543225769230769
  },
  {
    "date": "2024-06-06",
    "activeEnergyBurned": 154.595,
    "basalEnergyBurned": 1625.9569999999999,
    "distanceWalkingRunning": 2.2914666519999995,
    "flightsClimbed": 6,
    "stepCount": 4460,
    "walkingSpeed": 2.6775160869565213
  },
  {
    "date": "2024-06-07",
    "activeEnergyBurned": 101.895,
    "basalEnergyBurned": 1650.799,
    "distanceWalkingRunning": 1.4298561900000002,
    "flightsClimbed": 6,
    "stepCount": 2679,
    "walkingSpeed": 2.619701111111111
  },
  {
    "date": "2024-06-08",
    "activeEnergyBurned": 290.8040000000001,
    "basalEnergyBurned": 1691.701,
    "distanceWalkingRunning": 4.607684829999999,
    "flightsClimbed": 11,
    "stepCount": 11077,
    "walkingSpeed": 2.4391314285714287
  },
  {
    "date": "2024-06-09",
    "activeEnergyBurned": 237.29900000000004,
    "basalEnergyBurned": 1425.2730000000001,
    "distanceWalkingRunning": 3.2404064,
    "flightsClimbed": 17,
    "stepCount": 8221,
    "walkingSpeed": 2.4786826315789474
  },
  {
    "date": "2024-06-10",
    "activeEnergyBurned": 508.557,
    "basalEnergyBurned": 1887.5799999999997,
    "distanceWalkingRunning": 6.84717368,
    "flightsClimbed": 21,
    "stepCount": 16435,
    "walkingSpeed": 2.7293079120879122
  },
  {
    "date": "2024-06-11",
    "activeEnergyBurned": 518.139,
    "basalEnergyBurned": 1756.85,
    "distanceWalkingRunning": 6.814735068,
    "flightsClimbed": 18,
    "stepCount": 15703,
    "walkingSpeed": 2.681561728395062
  },
  {
    "date": "2024-06-12",
    "activeEnergyBurned": 381.70300000000003,
    "basalEnergyBurned": 1616.8629999999998,
    "distanceWalkingRunning": 4.7347456,
    "flightsClimbed": 24,
    "stepCount": 11985,
    "walkingSpeed": 2.7283
  },
  {
    "date": "2024-06-13",
    "activeEnergyBurned": 424.21200000000005,
    "basalEnergyBurned": 1772.3950000000002,
    "distanceWalkingRunning": 5.69454402,
    "flightsClimbed": 19,
    "stepCount": 14647,
    "walkingSpeed": 2.9741086363636366
  },
  {
    "date": "2024-06-14",
    "activeEnergyBurned": 425.14900000000006,
    "basalEnergyBurned": 1633.9119999999998,
    "distanceWalkingRunning": 5.5852327,
    "flightsClimbed": 22,
    "stepCount": 13619,
    "walkingSpeed": 2.5988463414634144
  },
  {
    "date": "2024-06-15",
    "activeEnergyBurned": 411.10299999999995,
    "basalEnergyBurned": 1754.168,
    "distanceWalkingRunning": 5.77617138,
    "flightsClimbed": 20,
    "stepCount": 13903
  },
  {
    "date": "2024-06-16",
    "activeEnergyBurned": 498.726,
    "basalEnergyBurned": 1820.098,
    "distanceWalkingRunning": 6.89155309,
    "flightsClimbed": 15,
    "stepCount": 16444,
    "walkingSpeed": 2.662636158536585
  },
  {
    "date": "2024-06-17",
    "activeEnergyBurned": 438.516,
    "basalEnergyBurned": 1561.195,
    "distanceWalkingRunning": 5.68564697,
    "flightsClimbed": 25,
    "stepCount": 13856,
    "walkingSpeed": 2.6629269565217393
  },
  {
    "date": "2024-06-18",
    "activeEnergyBurned": 290.046,
    "basalEnergyBurned": 1702.7649999999999,
    "distanceWalkingRunning": 3.7352728,
    "flightsClimbed": 14,
    "stepCount": 8087,
    "walkingSpeed": 2.7789264583333337
  },
  {
    "date": "2024-06-19",
    "activeEnergyBurned": 441.99999999999994,
    "basalEnergyBurned": 1682.5489999999998,
    "distanceWalkingRunning": 6.27472955,
    "flightsClimbed": 18,
    "stepCount": 14382,
    "walkingSpeed": 2.814592352941177
  },
  {
    "date": "2024-06-20",
    "activeEnergyBurned": 458.75199999999995,
    "basalEnergyBurned": 1729.576,
    "distanceWalkingRunning": 5.835631759999999,
    "flightsClimbed": 23,
    "stepCount": 12761,
    "walkingSpeed": 2.654233274336283
  },
  {
    "date": "2024-06-21",
    "activeEnergyBurned": 446.91499999999996,
    "basalEnergyBurned": 1767.206,
    "distanceWalkingRunning": 5.143922410000001,
    "flightsClimbed": 38,
    "stepCount": 11595,
    "walkingSpeed": 2.801363392857143
  },
  {
    "date": "2024-06-22",
    "activeEnergyBurned": 309.102,
    "basalEnergyBurned": 1599.5579999999995,
    "distanceWalkingRunning": 4.44485298,
    "flightsClimbed": 17,
    "stepCount": 11164,
    "walkingSpeed": 2.583284382022472
  },
  {
    "date": "2024-06-23",
    "activeEnergyBurned": 605.449,
    "basalEnergyBurned": 1710.9730000000002,
    "distanceWalkingRunning": 7.162752070000001,
    "flightsClimbed": 43,
    "stepCount": 17039,
    "walkingSpeed": 2.624847294117648
  },
  {
    "date": "2024-06-24",
    "activeEnergyBurned": 475.663,
    "basalEnergyBurned": 1677.543,
    "distanceWalkingRunning": 6.18807428,
    "flightsClimbed": 22,
    "stepCount": 14014,
    "walkingSpeed": 2.667409878048781
  },
  {
    "date": "2024-06-25",
    "activeEnergyBurned": 350.60699999999997,
    "basalEnergyBurned": 1681.445,
    "distanceWalkingRunning": 4.52740849,
    "flightsClimbed": 19,
    "stepCount": 9802,
    "walkingSpeed": 2.8135181632653063
  },
  {
    "date": "2024-06-26",
    "activeEnergyBurned": 370.88700000000006,
    "basalEnergyBurned": 1665.187,
    "distanceWalkingRunning": 4.79415459,
    "flightsClimbed": 14,
    "stepCount": 10656,
    "walkingSpeed": 2.773494794520548
  },
  {
    "date": "2024-06-27",
    "activeEnergyBurned": 632.2860000000001,
    "basalEnergyBurned": 1831.4869999999999,
    "distanceWalkingRunning": 8.165768725,
    "flightsClimbed": 17,
    "stepCount": 18147,
    "walkingSpeed": 2.7299945833333332
  },
  {
    "date": "2024-06-28",
    "activeEnergyBurned": 429.747,
    "basalEnergyBurned": 1568.261,
    "distanceWalkingRunning": 5.6137280800000005,
    "flightsClimbed": 18,
    "stepCount": 12639,
    "walkingSpeed": 2.6579131612903226
  },
  {
    "date": "2024-06-29",
    "activeEnergyBurned": 638.914,
    "basalEnergyBurned": 1715.943,
    "distanceWalkingRunning": 8.932915500000002,
    "flightsClimbed": 23,
    "stepCount": 21828,
    "walkingSpeed": 2.5499507692307692
  },
  {
    "date": "2024-06-30",
    "activeEnergyBurned": 142.26899999999998,
    "basalEnergyBurned": 1680.499,
    "distanceWalkingRunning": 1.89691104,
    "flightsClimbed": 12,
    "stepCount": 4504,
    "walkingSpeed": 2.6383405555555557
  },
  {
    "date": "2024-07-01",
    "activeEnergyBurned": 349.32800000000003,
    "basalEnergyBurned": 1663.102,
    "distanceWalkingRunning": 4.5595592,
    "flightsClimbed": 19,
    "stepCount": 10100,
    "walkingSpeed": 2.8252117543859647
  },
  {
    "date": "2024-07-02",
    "activeEnergyBurned": 408.416,
    "basalEnergyBurned": 1816.377,
    "distanceWalkingRunning": 5.85961149,
    "flightsClimbed": 12,
    "stepCount": 14295,
    "walkingSpeed": 2.8717637931034483
  },
  {
    "date": "2024-07-03",
    "activeEnergyBurned": 394.524,
    "basalEnergyBurned": 1565.3959999999997,
    "distanceWalkingRunning": 4.909397321999999,
    "flightsClimbed": 20,
    "stepCount": 10246,
    "walkingSpeed": 2.8162192452830186
  },
  {
    "date": "2024-07-04",
    "activeEnergyBurned": 506.5469999999999,
    "basalEnergyBurned": 1834.5549999999998,
    "distanceWalkingRunning": 6.392674630000001,
    "flightsClimbed": 23,
    "stepCount": 13641,
    "walkingSpeed": 2.788713589743589
  },
  {
    "date": "2024-07-05",
    "activeEnergyBurned": 256.883,
    "basalEnergyBurned": 1522.5829999999999,
    "distanceWalkingRunning": 3.78819484,
    "flightsClimbed": 16,
    "stepCount": 9766,
    "walkingSpeed": 2.706692834645669
  },
  {
    "date": "2024-07-06",
    "activeEnergyBurned": 374.209,
    "basalEnergyBurned": 1842.3849999999995,
    "distanceWalkingRunning": 4.979384400000001,
    "flightsClimbed": 9,
    "stepCount": 11086,
    "walkingSpeed": 2.7894598000000004
  },
  {
    "date": "2024-07-07",
    "activeEnergyBurned": 122.54899999999999,
    "basalEnergyBurned": 1630.0039999999997,
    "distanceWalkingRunning": 1.74922404,
    "flightsClimbed": 11,
    "stepCount": 3842,
    "walkingSpeed": 2.8447995652173907
  },
  {
    "date": "2024-07-08",
    "activeEnergyBurned": 113.364,
    "basalEnergyBurned": 1686.2979999999998,
    "distanceWalkingRunning": 1.5051489500000002,
    "flightsClimbed": 11,
    "stepCount": 3404,
    "walkingSpeed": 2.5442730434782606
  },
  {
    "date": "2024-07-09",
    "activeEnergyBurned": 345.58400000000006,
    "basalEnergyBurned": 1706.9709999999998,
    "distanceWalkingRunning": 4.370550207,
    "flightsClimbed": 17,
    "stepCount": 9856,
    "walkingSpeed": 2.715002
  },
  {
    "date": "2024-07-10",
    "activeEnergyBurned": 598.068,
    "basalEnergyBurned": 1577.601,
    "distanceWalkingRunning": 7.689290700000001,
    "flightsClimbed": 16,
    "stepCount": 15095,
    "walkingSpeed": 2.5721378787878786
  },
  {
    "date": "2024-07-11",
    "activeEnergyBurned": 231.03300000000002,
    "basalEnergyBurned": 1705.448,
    "distanceWalkingRunning": 3.1420797599999997,
    "flightsClimbed": 14,
    "stepCount": 7852,
    "walkingSpeed": 2.69718
  },
  {
    "date": "2024-07-12",
    "activeEnergyBurned": 302.719,
    "basalEnergyBurned": 1756.7330000000002,
    "distanceWalkingRunning": 3.95781033,
    "flightsClimbed": 8,
    "stepCount": 8567,
    "walkingSpeed": 2.6843230769230777
  },
  {
    "date": "2024-07-13",
    "activeEnergyBurned": 239.615,
    "basalEnergyBurned": 1682.1619999999998,
    "distanceWalkingRunning": 2.91154067,
    "flightsClimbed": 19,
    "stepCount": 6660,
    "walkingSpeed": 2.7570244444444443
  },
  {
    "date": "2024-07-14",
    "activeEnergyBurned": 227.94300000000004,
    "basalEnergyBurned": 1511.9729999999997,
    "distanceWalkingRunning": 3.0891709900000004,
    "flightsClimbed": 9,
    "stepCount": 7280,
    "walkingSpeed": 2.7054837837837833
  },
  {
    "date": "2024-07-15",
    "activeEnergyBurned": 643.875,
    "basalEnergyBurned": 1863.938,
    "distanceWalkingRunning": 8.73740958,
    "flightsClimbed": 18,
    "stepCount": 18314,
    "walkingSpeed": 2.6697832
  },
  {
    "date": "2024-07-16",
    "activeEnergyBurned": 225.977,
    "basalEnergyBurned": 1461.3719999999996,
    "distanceWalkingRunning": 3.0347518940000002,
    "flightsClimbed": 10,
    "stepCount": 7601,
    "walkingSpeed": 2.731642884615385
  },
  {
    "date": "2024-07-17",
    "activeEnergyBurned": 266.31300000000005,
    "basalEnergyBurned": 1852.8259999999998,
    "distanceWalkingRunning": 3.64447958,
    "flightsClimbed": 13,
    "stepCount": 9216,
    "walkingSpeed": 2.753029107142857
  },
  {
    "date": "2024-07-18",
    "activeEnergyBurned": 284.973,
    "basalEnergyBurned": 1705.578,
    "distanceWalkingRunning": 3.7245697000000004,
    "flightsClimbed": 12,
    "stepCount": 9140,
    "walkingSpeed": 2.8344473333333333
  },
  {
    "date": "2024-07-19",
    "activeEnergyBurned": 227.341,
    "basalEnergyBurned": 1716.0179999999998,
    "distanceWalkingRunning": 3.1437297589999997,
    "flightsClimbed": 11,
    "stepCount": 7146,
    "walkingSpeed": 2.7322577142857147
  },
  {
    "date": "2024-07-20",
    "activeEnergyBurned": 399.83799999999997,
    "basalEnergyBurned": 1698.56,
    "distanceWalkingRunning": 5.7918585600000005,
    "flightsClimbed": 13,
    "stepCount": 13333,
    "walkingSpeed": 2.589788608695652
  },
  {
    "date": "2024-07-21",
    "activeEnergyBurned": 286.627,
    "basalEnergyBurned": 1552.001,
    "distanceWalkingRunning": 3.8777785000000002,
    "flightsClimbed": 10,
    "stepCount": 8876,
    "walkingSpeed": 2.979475
  },
  {
    "date": "2024-07-22",
    "activeEnergyBurned": 387.63000000000005,
    "basalEnergyBurned": 1668.943,
    "distanceWalkingRunning": 4.8572041,
    "flightsClimbed": 17,
    "stepCount": 10639,
    "walkingSpeed": 2.9168175409836072
  },
  {
    "date": "2024-07-23",
    "activeEnergyBurned": 322.8310000000001,
    "basalEnergyBurned": 1767.0639999999999,
    "distanceWalkingRunning": 4.0206418799999994,
    "flightsClimbed": 11,
    "stepCount": 9808,
    "walkingSpeed": 2.79111935483871
  },
  {
    "date": "2024-07-24",
    "activeEnergyBurned": 322.333,
    "basalEnergyBurned": 1676.0859999999998,
    "distanceWalkingRunning": 4.261825439999999,
    "flightsClimbed": 12,
    "stepCount": 9384,
    "walkingSpeed": 2.8124730508474576
  },
  {
    "date": "2024-07-25",
    "activeEnergyBurned": 273.249,
    "basalEnergyBurned": 1697.8829999999998,
    "distanceWalkingRunning": 3.5694605399999997,
    "flightsClimbed": 8,
    "stepCount": 7881,
    "walkingSpeed": 2.8780097560975615
  },
  {
    "date": "2024-07-26",
    "activeEnergyBurned": 145.20100000000002,
    "basalEnergyBurned": 1706.584,
    "distanceWalkingRunning": 2.8842547400000003,
    "flightsClimbed": 1,
    "stepCount": 7172,
    "walkingSpeed": 2.4369696153846157
  },
  {
    "date": "2024-07-27",
    "activeEnergyBurned": 139.315,
    "basalEnergyBurned": 1695.1819999999998,
    "distanceWalkingRunning": 2.637818996,
    "flightsClimbed": 9,
    "stepCount": 6755,
    "walkingSpeed": 2.4150627777777776
  },
  {
    "date": "2024-07-28",
    "activeEnergyBurned": 217.98099999999997,
    "basalEnergyBurned": 1518.3719999999996,
    "distanceWalkingRunning": 2.76393961,
    "flightsClimbed": 15,
    "stepCount": 6368,
    "walkingSpeed": 2.6729426315789473
  },
  {
    "date": "2024-07-29",
    "activeEnergyBurned": 311.809,
    "basalEnergyBurned": 1708.002,
    "distanceWalkingRunning": 4.075247,
    "flightsClimbed": 16,
    "stepCount": 9447,
    "walkingSpeed": 2.9602123333333337
  },
  {
    "date": "2024-07-30",
    "activeEnergyBurned": 487.01099999999997,
    "basalEnergyBurned": 1754.0279999999998,
    "distanceWalkingRunning": 6.75149975,
    "flightsClimbed": 8,
    "stepCount": 15230,
    "walkingSpeed": 2.8547571428571428
  },
  {
    "date": "2024-07-31",
    "activeEnergyBurned": 631.8570000000001,
    "basalEnergyBurned": 1680.8349999999998,
    "distanceWalkingRunning": 8.07424076,
    "flightsClimbed": 16,
    "stepCount": 17007,
    "walkingSpeed": 2.836266886792453
  },
  {
    "date": "2024-08-01",
    "activeEnergyBurned": 299.353,
    "basalEnergyBurned": 1709.0159999999998,
    "distanceWalkingRunning": 4.00645098,
    "flightsClimbed": 9,
    "stepCount": 8983,
    "walkingSpeed": 2.793637735849057
  },
  {
    "date": "2024-08-02",
    "activeEnergyBurned": 245.31900000000002,
    "basalEnergyBurned": 1645.091,
    "distanceWalkingRunning": 3.074297741000001,
    "flightsClimbed": 17,
    "stepCount": 7382,
    "walkingSpeed": 2.8986964583333332
  },
  {
    "date": "2024-08-03",
    "activeEnergyBurned": 352.379,
    "basalEnergyBurned": 1778.926,
    "distanceWalkingRunning": 4.69960763,
    "flightsClimbed": 19,
    "stepCount": 10688,
    "walkingSpeed": 2.6509146753246755
  },
  {
    "date": "2024-08-04",
    "activeEnergyBurned": 49.544999999999995,
    "basalEnergyBurned": 1611.418,
    "distanceWalkingRunning": 0.8209871099999999,
    "flightsClimbed": 6,
    "stepCount": 2148,
    "walkingSpeed": 2.4258344444444444
  },
  {
    "date": "2024-08-05",
    "activeEnergyBurned": 344.672,
    "basalEnergyBurned": 1623.8439999999998,
    "distanceWalkingRunning": 5.134088009999999,
    "flightsClimbed": 15,
    "stepCount": 12482,
    "walkingSpeed": 2.348786666666667
  },
  {
    "date": "2024-08-06",
    "activeEnergyBurned": 114.762,
    "basalEnergyBurned": 1540.742,
    "distanceWalkingRunning": 1.6950301099999998,
    "flightsClimbed": 2,
    "stepCount": 4152,
    "walkingSpeed": 2.6081164406779656
  },
  {
    "date": "2024-08-07",
    "activeEnergyBurned": 41.675,
    "basalEnergyBurned": 1926.013,
    "distanceWalkingRunning": 0.65657627,
    "flightsClimbed": 5,
    "stepCount": 1268,
    "walkingSpeed": 2.406944
  },
  {
    "date": "2024-08-08",
    "activeEnergyBurned": 58.164,
    "basalEnergyBurned": 1629.448,
    "distanceWalkingRunning": 0.83213809,
    "flightsClimbed": 5,
    "stepCount": 1826,
    "walkingSpeed": 2.3842016666666663
  },
  {
    "date": "2024-08-09",
    "activeEnergyBurned": 59.75599999999999,
    "basalEnergyBurned": 1572.0169999999998,
    "distanceWalkingRunning": 0.8973928,
    "flightsClimbed": 6,
    "stepCount": 1801,
    "walkingSpeed": 2.742486
  },
  {
    "date": "2024-08-10",
    "activeEnergyBurned": 58.013999999999996,
    "basalEnergyBurned": 1723.457,
    "distanceWalkingRunning": 0.8008866099999999,
    "flightsClimbed": 5,
    "stepCount": 1544,
    "walkingSpeed": 2.52028
  },
  {
    "date": "2024-08-11",
    "activeEnergyBurned": 40.481,
    "basalEnergyBurned": 1721.696,
    "distanceWalkingRunning": 0.56443795,
    "flightsClimbed": 2,
    "stepCount": 998,
    "walkingSpeed": 2.59485
  },
  {
    "date": "2024-08-12",
    "activeEnergyBurned": 35.375,
    "basalEnergyBurned": 1513.6399999999996,
    "distanceWalkingRunning": 0.6305983900000001,
    "flightsClimbed": 5,
    "stepCount": 1457,
    "walkingSpeed": 2.455658888888889
  },
  {
    "date": "2024-08-13",
    "activeEnergyBurned": 109.442,
    "basalEnergyBurned": 1663.5359999999998,
    "distanceWalkingRunning": 1.65293389,
    "flightsClimbed": 9,
    "stepCount": 3485,
    "walkingSpeed": 2.4829999999999997
  },
  {
    "date": "2024-08-14",
    "activeEnergyBurned": 48.88900000000001,
    "basalEnergyBurned": 1704.88,
    "distanceWalkingRunning": 0.66461422,
    "flightsClimbed": 6,
    "stepCount": 1270,
    "walkingSpeed": 2.4126942857142857
  },
  {
    "date": "2024-08-15",
    "activeEnergyBurned": 175.998,
    "basalEnergyBurned": 1686.6290000000001,
    "distanceWalkingRunning": 2.69700524,
    "flightsClimbed": 11,
    "stepCount": 5938,
    "walkingSpeed": 2.682557631578948
  },
  {
    "date": "2024-08-16",
    "activeEnergyBurned": 46.877,
    "basalEnergyBurned": 1637.375,
    "distanceWalkingRunning": 0.76722502,
    "flightsClimbed": 8,
    "stepCount": 1731,
    "walkingSpeed": 2.2912628571428573
  },
  {
    "date": "2024-08-17",
    "activeEnergyBurned": 41.54299999999999,
    "basalEnergyBurned": 1588.093,
    "distanceWalkingRunning": 0.69776525,
    "flightsClimbed": 6,
    "stepCount": 1382,
    "walkingSpeed": 2.3935222222222223
  },
  {
    "date": "2024-08-18",
    "activeEnergyBurned": 40.019999999999996,
    "basalEnergyBurned": 1761.1560000000002,
    "distanceWalkingRunning": 0.69899547,
    "flightsClimbed": 6,
    "stepCount": 1512,
    "walkingSpeed": 2.266761666666667
  },
  {
    "date": "2024-08-19",
    "activeEnergyBurned": 32.690000000000005,
    "basalEnergyBurned": 1697.2279999999998,
    "distanceWalkingRunning": 0.6351787,
    "flightsClimbed": 5,
    "stepCount": 1528,
    "walkingSpeed": 2.1362750000000004
  },
  {
    "date": "2024-08-20",
    "activeEnergyBurned": 112.569,
    "basalEnergyBurned": 1688.7479999999998,
    "distanceWalkingRunning": 1.7304742799999997,
    "flightsClimbed": 9,
    "stepCount": 3707,
    "walkingSpeed": 2.305990869565217
  },
  {
    "date": "2024-08-21",
    "activeEnergyBurned": 42.273,
    "basalEnergyBurned": 1700.349,
    "distanceWalkingRunning": 0.726358071,
    "flightsClimbed": 5,
    "stepCount": 1468,
    "walkingSpeed": 2.5426516666666665
  },
  {
    "date": "2024-08-22",
    "activeEnergyBurned": 72.68400000000001,
    "basalEnergyBurned": 1602.783,
    "distanceWalkingRunning": 1.24913867,
    "flightsClimbed": 12,
    "stepCount": 2886,
    "walkingSpeed": 2.5483876923076925
  },
  {
    "date": "2024-08-23",
    "activeEnergyBurned": 221.32500000000002,
    "basalEnergyBurned": 1652.9980000000003,
    "distanceWalkingRunning": 3.5247240279999996,
    "flightsClimbed": 6,
    "stepCount": 8946,
    "walkingSpeed": 2.487556296296297
  },
  {
    "date": "2024-08-24",
    "activeEnergyBurned": 548.548,
    "basalEnergyBurned": 1709.6789999999999,
    "distanceWalkingRunning": 8.914702086,
    "flightsClimbed": 3,
    "stepCount": 22878,
    "walkingSpeed": 2.6324740397351
  },
  {
    "date": "2024-08-25",
    "activeEnergyBurned": 314.661,
    "basalEnergyBurned": 1781.3729999999998,
    "distanceWalkingRunning": 5.56248667,
    "flightsClimbed": 3,
    "stepCount": 14865,
    "walkingSpeed": 2.443813546099291
  },
  {
    "date": "2024-08-26",
    "activeEnergyBurned": 517.9739999999999,
    "basalEnergyBurned": 1597.979,
    "distanceWalkingRunning": 7.880395890000001,
    "flightsClimbed": 4,
    "stepCount": 18270,
    "walkingSpeed": 2.657515634920635
  },
  {
    "date": "2024-08-27",
    "activeEnergyBurned": 77.397,
    "basalEnergyBurned": 1598.218,
    "distanceWalkingRunning": 1.33959164,
    "flightsClimbed": 8,
    "stepCount": 3048,
    "walkingSpeed": 2.3297700000000003
  },
  {
    "date": "2024-08-28",
    "activeEnergyBurned": 74.41699999999999,
    "basalEnergyBurned": 1776.1689999999996,
    "distanceWalkingRunning": 1.28322969,
    "flightsClimbed": 7,
    "stepCount": 2807,
    "walkingSpeed": 2.5401666666666665
  },
  {
    "date": "2024-08-29",
    "activeEnergyBurned": 60.575,
    "basalEnergyBurned": 1704.3469999999998,
    "distanceWalkingRunning": 0.9874470800000001,
    "flightsClimbed": 5,
    "stepCount": 1957,
    "walkingSpeed": 2.5668841666666666
  },
  {
    "date": "2024-08-30",
    "activeEnergyBurned": 115.48,
    "basalEnergyBurned": 1661.2299999999998,
    "distanceWalkingRunning": 1.7936660199999996,
    "flightsClimbed": 10,
    "stepCount": 3883,
    "walkingSpeed": 2.466843888888889
  },
  {
    "date": "2024-08-31",
    "activeEnergyBurned": 191.90699999999998,
    "basalEnergyBurned": 1685.7530000000002,
    "distanceWalkingRunning": 2.76025647,
    "flightsClimbed": 11,
    "stepCount": 7030,
    "walkingSpeed": 2.6809336363636365
  },
  {
    "date": "2024-09-01",
    "activeEnergyBurned": 584.977,
    "basalEnergyBurned": 1654.3419999999999,
    "distanceWalkingRunning": 6.681233440000001,
    "flightsClimbed": 16,
    "stepCount": 12203,
    "walkingSpeed": 2.768015344827586
  },
  {
    "date": "2024-09-02",
    "activeEnergyBurned": 169.297,
    "basalEnergyBurned": 1407.646,
    "distanceWalkingRunning": 2.33795846,
    "flightsClimbed": 6,
    "stepCount": 6181,
    "walkingSpeed": 2.668582222222222
  },
  {
    "date": "2024-09-03",
    "activeEnergyBurned": 333.938,
    "basalEnergyBurned": 1922.2339999999997,
    "distanceWalkingRunning": 4.31998612,
    "flightsClimbed": 10,
    "stepCount": 10266,
    "walkingSpeed": 2.835453170731707
  },
  {
    "date": "2024-09-04",
    "activeEnergyBurned": 516.923,
    "basalEnergyBurned": 1764.5330000000001,
    "distanceWalkingRunning": 5.94805254,
    "flightsClimbed": 23,
    "stepCount": 13171,
    "walkingSpeed": 2.80076
  },
  {
    "date": "2024-09-05",
    "activeEnergyBurned": 516.115,
    "basalEnergyBurned": 1671.209,
    "distanceWalkingRunning": 7.052727088999999,
    "flightsClimbed": 23,
    "stepCount": 16985,
    "walkingSpeed": 2.6744659322033892
  },
  {
    "date": "2024-09-06",
    "activeEnergyBurned": 423.94100000000003,
    "basalEnergyBurned": 1729.549,
    "distanceWalkingRunning": 5.14717071,
    "flightsClimbed": 29,
    "stepCount": 12958,
    "walkingSpeed": 2.608201492537314
  },
  {
    "date": "2024-09-07",
    "activeEnergyBurned": 562.397,
    "basalEnergyBurned": 1703.4479999999999,
    "distanceWalkingRunning": 7.237697699999999,
    "flightsClimbed": 31,
    "stepCount": 16589,
    "walkingSpeed": 2.6765530526315793
  },
  {
    "date": "2024-09-08",
    "activeEnergyBurned": 306.884,
    "basalEnergyBurned": 1699.5729999999999,
    "distanceWalkingRunning": 3.7295983500000003,
    "flightsClimbed": 21,
    "stepCount": 9557,
    "walkingSpeed": 2.7052021666666666
  },
  {
    "date": "2024-09-09",
    "activeEnergyBurned": 409.8189999999999,
    "basalEnergyBurned": 1567.7949999999998,
    "distanceWalkingRunning": 5.4806942900000015,
    "flightsClimbed": 26,
    "stepCount": 14009,
    "walkingSpeed": 2.828163488372093
  },
  {
    "date": "2024-09-10",
    "activeEnergyBurned": 467.035,
    "basalEnergyBurned": 1809.896,
    "distanceWalkingRunning": 5.963817140000001,
    "flightsClimbed": 23,
    "stepCount": 14833,
    "walkingSpeed": 2.753076029411765
  },
  {
    "date": "2024-09-11",
    "activeEnergyBurned": 427.548,
    "basalEnergyBurned": 1652.9569999999999,
    "distanceWalkingRunning": 5.2279504800000005,
    "flightsClimbed": 27,
    "stepCount": 11834,
    "walkingSpeed": 2.7541895890410957
  },
  {
    "date": "2024-09-12",
    "activeEnergyBurned": 259.531,
    "basalEnergyBurned": 1680.1109999999996,
    "distanceWalkingRunning": 3.3437808400000004,
    "flightsClimbed": 12,
    "stepCount": 8355,
    "walkingSpeed": 2.7485451612903224
  },
  {
    "date": "2024-09-13",
    "activeEnergyBurned": 656.662,
    "basalEnergyBurned": 1760.155,
    "distanceWalkingRunning": 8.659036599999999,
    "flightsClimbed": 27,
    "stepCount": 18894
  },
  {
    "date": "2024-09-14",
    "activeEnergyBurned": 505.952,
    "basalEnergyBurned": 1625.2189999999998,
    "distanceWalkingRunning": 6.116534480000001,
    "flightsClimbed": 20,
    "stepCount": 13337,
    "walkingSpeed": 2.7484976502732246
  },
  {
    "date": "2024-09-15",
    "activeEnergyBurned": 367.86199999999997,
    "basalEnergyBurned": 1758.703,
    "distanceWalkingRunning": 4.9022346599999995,
    "flightsClimbed": 13,
    "stepCount": 12315,
    "walkingSpeed": 2.7895301562499997
  },
  {
    "date": "2024-09-16",
    "activeEnergyBurned": 435.57000000000005,
    "basalEnergyBurned": 1650.7359999999999,
    "distanceWalkingRunning": 5.21189555,
    "flightsClimbed": 23,
    "stepCount": 11341,
    "walkingSpeed": 2.768306315789474
  },
  {
    "date": "2024-09-17",
    "activeEnergyBurned": 327.11300000000006,
    "basalEnergyBurned": 1693.1259999999997,
    "distanceWalkingRunning": 3.989766712,
    "flightsClimbed": 23,
    "stepCount": 9698,
    "walkingSpeed": 2.626162888888889
  },
  {
    "date": "2024-09-18",
    "activeEnergyBurned": 482.705,
    "basalEnergyBurned": 1714.946,
    "distanceWalkingRunning": 5.708453390000001,
    "flightsClimbed": 29,
    "stepCount": 14219,
    "walkingSpeed": 2.8394177333333337
  },
  {
    "date": "2024-09-19",
    "activeEnergyBurned": 370.04999999999995,
    "basalEnergyBurned": 1665.606,
    "distanceWalkingRunning": 4.825917066000001,
    "flightsClimbed": 14,
    "stepCount": 10991,
    "walkingSpeed": 2.6127409090909097
  },
  {
    "date": "2024-09-20",
    "activeEnergyBurned": 319.09299999999996,
    "basalEnergyBurned": 1727.3129999999999,
    "distanceWalkingRunning": 3.7983058900000004,
    "flightsClimbed": 18,
    "stepCount": 8440,
    "walkingSpeed": 2.767010535714286
  },
  {
    "date": "2024-09-21",
    "activeEnergyBurned": 286.95400000000006,
    "basalEnergyBurned": 1567.036,
    "distanceWalkingRunning": 4.32882072,
    "flightsClimbed": 8,
    "stepCount": 9895,
    "walkingSpeed": 2.66829671641791
  },
  {
    "date": "2024-09-22",
    "activeEnergyBurned": 248.495,
    "basalEnergyBurned": 1753.5339999999999,
    "distanceWalkingRunning": 3.3448156599999996,
    "flightsClimbed": 12,
    "stepCount": 8486,
    "walkingSpeed": 2.5641527906976744
  },
  {
    "date": "2024-09-23",
    "activeEnergyBurned": 406.83599999999996,
    "basalEnergyBurned": 1693.4119999999998,
    "distanceWalkingRunning": 5.39635327,
    "flightsClimbed": 18,
    "stepCount": 12508,
    "walkingSpeed": 3.0122121052631576
  },
  {
    "date": "2024-09-24",
    "activeEnergyBurned": 460.273,
    "basalEnergyBurned": 1650.521,
    "distanceWalkingRunning": 5.640332549999999,
    "flightsClimbed": 24,
    "stepCount": 12227,
    "walkingSpeed": 2.7526091228070175
  },
  {
    "date": "2024-09-25",
    "activeEnergyBurned": 377.35699999999997,
    "basalEnergyBurned": 1777.0750000000003,
    "distanceWalkingRunning": 4.364115917,
    "flightsClimbed": 21,
    "stepCount": 10231,
    "walkingSpeed": 2.8226406666666666
  },
  {
    "date": "2024-09-26",
    "activeEnergyBurned": 459.202,
    "basalEnergyBurned": 1659.5190000000002,
    "distanceWalkingRunning": 5.759579560000001,
    "flightsClimbed": 20,
    "stepCount": 13600,
    "walkingSpeed": 2.66370140625
  },
  {
    "date": "2024-09-27",
    "activeEnergyBurned": 419.939,
    "basalEnergyBurned": 1726.7930000000001,
    "distanceWalkingRunning": 5.4757351860000005,
    "flightsClimbed": 24,
    "stepCount": 13511,
    "walkingSpeed": 2.7123911320754717
  },
  {
    "date": "2024-09-28",
    "activeEnergyBurned": 451.65100000000007,
    "basalEnergyBurned": 1696.7450000000001,
    "distanceWalkingRunning": 5.592241379999999,
    "flightsClimbed": 18,
    "stepCount": 13184,
    "walkingSpeed": 2.726652923076923
  },
  {
    "date": "2024-09-29",
    "activeEnergyBurned": 313.24100000000004,
    "basalEnergyBurned": 1655.5860000000005,
    "distanceWalkingRunning": 3.63719589,
    "flightsClimbed": 16,
    "stepCount": 8138,
    "walkingSpeed": 2.8741751282051284
  },
  {
    "date": "2024-09-30",
    "activeEnergyBurned": 392.839,
    "basalEnergyBurned": 1662.7169999999996,
    "distanceWalkingRunning": 4.9776798399999995,
    "flightsClimbed": 14,
    "stepCount": 11025,
    "walkingSpeed": 2.874125151515152
  },
  {
    "date": "2024-10-01",
    "activeEnergyBurned": 300.30299999999994,
    "basalEnergyBurned": 1738.3799999999997,
    "distanceWalkingRunning": 3.9383411,
    "flightsClimbed": 22,
    "stepCount": 10231,
    "walkingSpeed": 2.7271985714285716
  },
  {
    "date": "2024-10-02",
    "activeEnergyBurned": 347.21299999999997,
    "basalEnergyBurned": 1664.7859999999998,
    "distanceWalkingRunning": 4.23418651,
    "flightsClimbed": 19,
    "stepCount": 10818,
    "walkingSpeed": 2.7579261290322576
  },
  {
    "date": "2024-10-03",
    "activeEnergyBurned": 224.66899999999998,
    "basalEnergyBurned": 1699.927,
    "distanceWalkingRunning": 2.89730277,
    "flightsClimbed": 7,
    "stepCount": 7116,
    "walkingSpeed": 2.82792064516129
  },
  {
    "date": "2024-10-04",
    "activeEnergyBurned": 353.28099999999995,
    "basalEnergyBurned": 1641.551,
    "distanceWalkingRunning": 4.7690883600000005,
    "flightsClimbed": 15,
    "stepCount": 11057,
    "walkingSpeed": 2.7636074683544307
  },
  {
    "date": "2024-10-05",
    "activeEnergyBurned": 192.485,
    "basalEnergyBurned": 1701.4569999999999,
    "distanceWalkingRunning": 2.22527321,
    "flightsClimbed": 16,
    "stepCount": 5587,
    "walkingSpeed": 2.7402478125000003
  },
  {
    "date": "2024-10-06",
    "activeEnergyBurned": 160.18200000000002,
    "basalEnergyBurned": 1690.1879999999999,
    "distanceWalkingRunning": 2.05397937,
    "flightsClimbed": 10,
    "stepCount": 5241,
    "walkingSpeed": 2.6256034375
  },
  {
    "date": "2024-10-07",
    "activeEnergyBurned": 305.956,
    "basalEnergyBurned": 1679.45,
    "distanceWalkingRunning": 3.7702955300000003,
    "flightsClimbed": 15,
    "stepCount": 8500,
    "walkingSpeed": 2.7989656249999997
  },
  {
    "date": "2024-10-08",
    "activeEnergyBurned": 219.55899999999997,
    "basalEnergyBurned": 1648.702,
    "distanceWalkingRunning": 3.06504372,
    "flightsClimbed": 10,
    "stepCount": 7805,
    "walkingSpeed": 2.6370425
  },
  {
    "date": "2024-10-09",
    "activeEnergyBurned": 435.798,
    "basalEnergyBurned": 1716.318,
    "distanceWalkingRunning": 5.091043389999999,
    "flightsClimbed": 20,
    "stepCount": 11033,
    "walkingSpeed": 2.930778596491228
  },
  {
    "date": "2024-10-10",
    "activeEnergyBurned": 310.001,
    "basalEnergyBurned": 1661.9269999999997,
    "distanceWalkingRunning": 3.7495241399999997,
    "flightsClimbed": 18,
    "stepCount": 8396,
    "walkingSpeed": 2.6656827777777776
  },
  {
    "date": "2024-10-11",
    "activeEnergyBurned": 249.289,
    "basalEnergyBurned": 1636.9779999999996,
    "distanceWalkingRunning": 3.26133946,
    "flightsClimbed": 11,
    "stepCount": 7332,
    "walkingSpeed": 2.756594102564103
  },
  {
    "date": "2024-10-12",
    "activeEnergyBurned": 123.759,
    "basalEnergyBurned": 1465.021,
    "distanceWalkingRunning": 1.6810259999999997,
    "flightsClimbed": 4,
    "stepCount": 4013,
    "walkingSpeed": 2.770914838709677
  },
  {
    "date": "2024-10-13",
    "activeEnergyBurned": 136.398,
    "basalEnergyBurned": 1928.2029999999997,
    "distanceWalkingRunning": 2.4889544600000004,
    "flightsClimbed": 6,
    "stepCount": 6594,
    "walkingSpeed": 2.507090769230769
  },
  {
    "date": "2024-10-14",
    "activeEnergyBurned": 387.792,
    "basalEnergyBurned": 1727.852,
    "distanceWalkingRunning": 6.069265710999999,
    "flightsClimbed": 15,
    "stepCount": 15998,
    "walkingSpeed": 2.4599393827160494
  },
  {
    "date": "2024-10-15",
    "activeEnergyBurned": 199.829,
    "basalEnergyBurned": 1627.4689999999996,
    "distanceWalkingRunning": 2.6265730400000002,
    "flightsClimbed": 11,
    "stepCount": 6666,
    "walkingSpeed": 2.599210487804878
  },
  {
    "date": "2024-10-16",
    "activeEnergyBurned": 309.161,
    "basalEnergyBurned": 1726.998,
    "distanceWalkingRunning": 3.568868292,
    "flightsClimbed": 20,
    "stepCount": 8304,
    "walkingSpeed": 2.659468888888889
  },
  {
    "date": "2024-10-17",
    "activeEnergyBurned": 238.22899999999998,
    "basalEnergyBurned": 1591.2489999999998,
    "distanceWalkingRunning": 2.93867972,
    "flightsClimbed": 16,
    "stepCount": 6989,
    "walkingSpeed": 2.6392047457627124
  },
  {
    "date": "2024-10-18",
    "activeEnergyBurned": 385.9220000000001,
    "basalEnergyBurned": 1669.8189999999997,
    "distanceWalkingRunning": 4.449423680000001,
    "flightsClimbed": 22,
    "stepCount": 9855,
    "walkingSpeed": 2.8060638461538456
  },
  {
    "date": "2024-10-19",
    "activeEnergyBurned": 240.81899999999996,
    "basalEnergyBurned": 1768.4559999999997,
    "distanceWalkingRunning": 2.99846037,
    "flightsClimbed": 9,
    "stepCount": 6723,
    "walkingSpeed": 2.620944444444445
  },
  {
    "date": "2024-10-20",
    "activeEnergyBurned": 227.94399999999996,
    "basalEnergyBurned": 1655.6349999999998,
    "distanceWalkingRunning": 2.84828982,
    "flightsClimbed": 14,
    "stepCount": 6470,
    "walkingSpeed": 2.792175357142857
  },
  {
    "date": "2024-10-21",
    "activeEnergyBurned": 296.505,
    "basalEnergyBurned": 1687.5959999999998,
    "distanceWalkingRunning": 3.61417195,
    "flightsClimbed": 16,
    "stepCount": 8230,
    "walkingSpeed": 2.8552899999999997
  },
  {
    "date": "2024-10-22",
    "activeEnergyBurned": 414.17900000000003,
    "basalEnergyBurned": 1729.781,
    "distanceWalkingRunning": 4.912934716,
    "flightsClimbed": 17,
    "stepCount": 10749,
    "walkingSpeed": 2.7604744680851065
  },
  {
    "date": "2024-10-23",
    "activeEnergyBurned": 266.487,
    "basalEnergyBurned": 1576.4709999999995,
    "distanceWalkingRunning": 3.25143126,
    "flightsClimbed": 9,
    "stepCount": 6579,
    "walkingSpeed": 2.912299787234043
  },
  {
    "date": "2024-10-24",
    "activeEnergyBurned": 205.237,
    "basalEnergyBurned": 1721.1589999999999,
    "distanceWalkingRunning": 2.64499108,
    "flightsClimbed": 9,
    "stepCount": 6548,
    "walkingSpeed": 2.7135280555555554
  },
  {
    "date": "2024-10-25",
    "activeEnergyBurned": 314.45,
    "basalEnergyBurned": 1723.6289999999997,
    "distanceWalkingRunning": 3.8021222700000004,
    "flightsClimbed": 14,
    "stepCount": 8982,
    "walkingSpeed": 2.9120317948717944
  },
  {
    "date": "2024-10-26",
    "activeEnergyBurned": 170.80399999999997,
    "basalEnergyBurned": 1692.6439999999998,
    "distanceWalkingRunning": 2.21993037,
    "flightsClimbed": 5,
    "stepCount": 5864,
    "walkingSpeed": 2.696254222222222
  },
  {
    "date": "2024-10-27",
    "activeEnergyBurned": 182.865,
    "basalEnergyBurned": 1664.1529999999998,
    "distanceWalkingRunning": 2.353775221,
    "flightsClimbed": 11,
    "stepCount": 5663,
    "walkingSpeed": 2.631344736842106
  },
  {
    "date": "2024-10-28",
    "activeEnergyBurned": 428.568,
    "basalEnergyBurned": 1674.25,
    "distanceWalkingRunning": 5.206904639999999,
    "flightsClimbed": 26,
    "stepCount": 12240,
    "walkingSpeed": 2.794306833333334
  },
  {
    "date": "2024-10-29",
    "activeEnergyBurned": 430.554,
    "basalEnergyBurned": 1642.9810000000002,
    "distanceWalkingRunning": 4.861971199999999,
    "flightsClimbed": 22,
    "stepCount": 10609,
    "walkingSpeed": 2.7115862500000003
  },
  {
    "date": "2024-10-30",
    "activeEnergyBurned": 380.723,
    "basalEnergyBurned": 1670.7969999999998,
    "distanceWalkingRunning": 4.49196169,
    "flightsClimbed": 21,
    "stepCount": 10082,
    "walkingSpeed": 2.8607927777777773
  },
  {
    "date": "2024-10-31",
    "activeEnergyBurned": 286.904,
    "basalEnergyBurned": 1720.231,
    "distanceWalkingRunning": 3.2679412299999995,
    "flightsClimbed": 20,
    "stepCount": 7624,
    "walkingSpeed": 2.6882711764705878
  },
  {
    "date": "2024-11-01",
    "activeEnergyBurned": 438.245,
    "basalEnergyBurned": 1728.8609999999999,
    "distanceWalkingRunning": 5.09162904,
    "flightsClimbed": 30,
    "stepCount": 11412,
    "walkingSpeed": 2.871952448979592
  },
  {
    "date": "2024-11-02",
    "activeEnergyBurned": 399.379,
    "basalEnergyBurned": 1703.4659999999997,
    "distanceWalkingRunning": 4.444859881999999,
    "flightsClimbed": 22,
    "stepCount": 10100,
    "walkingSpeed": 2.6020213207547163
  },
  {
    "date": "2024-11-03",
    "activeEnergyBurned": 441.48199999999997,
    "basalEnergyBurned": 1622.0069999999998,
    "distanceWalkingRunning": 5.86736342,
    "flightsClimbed": 17,
    "stepCount": 13204,
    "walkingSpeed": 2.7768983076923077
  },
  {
    "date": "2024-11-04",
    "activeEnergyBurned": 315.54999999999995,
    "basalEnergyBurned": 1724.8339999999996,
    "distanceWalkingRunning": 3.8862536100000002,
    "flightsClimbed": 15,
    "stepCount": 9263,
    "walkingSpeed": 2.81714140625
  },
  {
    "date": "2024-11-05",
    "activeEnergyBurned": 394.594,
    "basalEnergyBurned": 1682.6209999999999,
    "distanceWalkingRunning": 4.61668269,
    "flightsClimbed": 23,
    "stepCount": 10491,
    "walkingSpeed": 2.6671173846153846
  },
  {
    "date": "2024-11-06",
    "activeEnergyBurned": 406.37100000000004,
    "basalEnergyBurned": 1716.9889999999998,
    "distanceWalkingRunning": 4.76353856,
    "flightsClimbed": 26,
    "stepCount": 10773,
    "walkingSpeed": 2.795176444444444
  },
  {
    "date": "2024-11-07",
    "activeEnergyBurned": 260.409,
    "basalEnergyBurned": 1669.8509999999997,
    "distanceWalkingRunning": 3.22356428,
    "flightsClimbed": 17,
    "stepCount": 7783,
    "walkingSpeed": 2.7306599999999994
  },
  {
    "date": "2024-11-08",
    "activeEnergyBurned": 142.00699999999998,
    "basalEnergyBurned": 1678.6259999999997,
    "distanceWalkingRunning": 1.9487853,
    "flightsClimbed": 10,
    "stepCount": 4626,
    "walkingSpeed": 2.6136368
  },
  {
    "date": "2024-11-09",
    "activeEnergyBurned": 279.15099999999995,
    "basalEnergyBurned": 1633.6979999999996,
    "distanceWalkingRunning": 3.39892643,
    "flightsClimbed": 14,
    "stepCount": 7854,
    "walkingSpeed": 2.15864
  },
  {
    "date": "2024-11-10",
    "activeEnergyBurned": 230.613,
    "basalEnergyBurned": 1734.4149999999997,
    "distanceWalkingRunning": 2.80689302,
    "flightsClimbed": 15,
    "stepCount": 6597,
    "walkingSpeed": 2.7076120547945206
  },
  {
    "date": "2024-11-11",
    "activeEnergyBurned": 414.07499999999993,
    "basalEnergyBurned": 1679.0300000000002,
    "distanceWalkingRunning": 5.18654925,
    "flightsClimbed": 17,
    "stepCount": 11056,
    "walkingSpeed": 2.7682086363636365
  },
  {
    "date": "2024-11-12",
    "activeEnergyBurned": 299.11899999999997,
    "basalEnergyBurned": 1672.8339999999998,
    "distanceWalkingRunning": 3.5198412799999996,
    "flightsClimbed": 21,
    "stepCount": 8384,
    "walkingSpeed": 2.716905217391304
  },
  {
    "date": "2024-11-13",
    "activeEnergyBurned": 276.68499999999995,
    "basalEnergyBurned": 1704.594,
    "distanceWalkingRunning": 3.26332318,
    "flightsClimbed": 13,
    "stepCount": 7600,
    "walkingSpeed": 3.0363468421052637
  },
  {
    "date": "2024-11-14",
    "activeEnergyBurned": 206.48,
    "basalEnergyBurned": 1654.694,
    "distanceWalkingRunning": 2.6086408100000003,
    "flightsClimbed": 8,
    "stepCount": 6677,
    "walkingSpeed": 2.6843234482758622
  },
  {
    "date": "2024-11-15",
    "activeEnergyBurned": 296.59900000000005,
    "basalEnergyBurned": 1675.455,
    "distanceWalkingRunning": 3.71081123,
    "flightsClimbed": 13,
    "stepCount": 8452,
    "walkingSpeed": 2.596215918367347
  },
  {
    "date": "2024-11-16",
    "activeEnergyBurned": 250.956,
    "basalEnergyBurned": 1661.819,
    "distanceWalkingRunning": 3.8307690799999996,
    "flightsClimbed": 5,
    "stepCount": 9929,
    "walkingSpeed": 2.5556140000000003
  },
  {
    "date": "2024-11-17",
    "activeEnergyBurned": 199.311,
    "basalEnergyBurned": 1501.537,
    "distanceWalkingRunning": 2.37833744,
    "flightsClimbed": 20,
    "stepCount": 5725,
    "walkingSpeed": 2.7875275
  },
  {
    "date": "2024-11-18",
    "activeEnergyBurned": 330.978,
    "basalEnergyBurned": 1908.195,
    "distanceWalkingRunning": 3.88337491,
    "flightsClimbed": 18,
    "stepCount": 9237,
    "walkingSpeed": 2.7665635294117648
  },
  {
    "date": "2024-11-19",
    "activeEnergyBurned": 307.12100000000004,
    "basalEnergyBurned": 1676.5549999999998,
    "distanceWalkingRunning": 3.74939665,
    "flightsClimbed": 21,
    "stepCount": 8868,
    "walkingSpeed": 2.6697352173913043
  },
  {
    "date": "2024-11-20",
    "activeEnergyBurned": 379.302,
    "basalEnergyBurned": 1633.714,
    "distanceWalkingRunning": 4.60536488,
    "flightsClimbed": 16,
    "stepCount": 10435,
    "walkingSpeed": 2.734033777777778
  },
  {
    "date": "2024-11-21",
    "activeEnergyBurned": 322.569,
    "basalEnergyBurned": 1714.777,
    "distanceWalkingRunning": 3.5975005,
    "flightsClimbed": 24,
    "stepCount": 7903,
    "walkingSpeed": 2.868072857142857
  },
  {
    "date": "2024-11-22",
    "activeEnergyBurned": 312.37600000000003,
    "basalEnergyBurned": 1657.517,
    "distanceWalkingRunning": 3.75249176,
    "flightsClimbed": 15,
    "stepCount": 8156,
    "walkingSpeed": 2.7628352941176475
  },
  {
    "date": "2024-11-23",
    "activeEnergyBurned": 161.96599999999998,
    "basalEnergyBurned": 1720.076,
    "distanceWalkingRunning": 2.65344863,
    "flightsClimbed": 7,
    "stepCount": 6483,
    "walkingSpeed": 2.361283529411765
  },
  {
    "date": "2024-11-24",
    "activeEnergyBurned": 269.6669999999999,
    "basalEnergyBurned": 1681.3599999999997,
    "distanceWalkingRunning": 4.03883744,
    "flightsClimbed": 7,
    "stepCount": 10118,
    "walkingSpeed": 2.506966607142857
  },
  {
    "date": "2024-11-25",
    "activeEnergyBurned": 28.799999999999997,
    "basalEnergyBurned": 1585.229,
    "distanceWalkingRunning": 0.55586382,
    "flightsClimbed": 4,
    "stepCount": 1456,
    "walkingSpeed": 2.383935
  },
  {
    "date": "2024-11-26",
    "activeEnergyBurned": 256.114,
    "basalEnergyBurned": 1717.4150000000004,
    "distanceWalkingRunning": 4.11151533,
    "flightsClimbed": 5,
    "stepCount": 9448,
    "walkingSpeed": 2.6469347142857145
  },
  {
    "date": "2024-11-27",
    "activeEnergyBurned": 109.725,
    "basalEnergyBurned": 1721.398,
    "distanceWalkingRunning": 1.8760754319999997,
    "flightsClimbed": 11,
    "stepCount": 4588,
    "walkingSpeed": 2.607112903225806
  },
  {
    "date": "2024-11-28",
    "activeEnergyBurned": 73.94300000000001,
    "basalEnergyBurned": 1660.7559999999999,
    "distanceWalkingRunning": 1.28092531,
    "flightsClimbed": 5,
    "stepCount": 3343,
    "walkingSpeed": 2.3487833333333334
  },
  {
    "date": "2024-11-29",
    "activeEnergyBurned": 344.88499999999993,
    "basalEnergyBurned": 1585.695,
    "distanceWalkingRunning": 5.635485869999999,
    "flightsClimbed": 6,
    "stepCount": 14529,
    "walkingSpeed": 2.723289677419355
  },
  {
    "date": "2024-11-30",
    "activeEnergyBurned": 47.718999999999994,
    "basalEnergyBurned": 1758.0559999999998,
    "distanceWalkingRunning": 0.96018888,
    "flightsClimbed": 8,
    "stepCount": 2356,
    "walkingSpeed": 2.3462094690265487
  },
  {
    "date": "2024-12-01",
    "activeEnergyBurned": 175.73399999999998,
    "basalEnergyBurned": 1568.854,
    "distanceWalkingRunning": 1.9962393299999999,
    "flightsClimbed": 21,
    "stepCount": 4525,
    "walkingSpeed": 2.4837985714285713
  },
  {
    "date": "2024-12-02",
    "activeEnergyBurned": 282.71700000000004,
    "basalEnergyBurned": 1688.4589999999998,
    "distanceWalkingRunning": 3.299492292,
    "flightsClimbed": 19,
    "stepCount": 7603,
    "walkingSpeed": 2.8576861111111116
  },
  {
    "date": "2024-12-03",
    "activeEnergyBurned": 188.22900000000004,
    "basalEnergyBurned": 1739.485,
    "distanceWalkingRunning": 2.38650617,
    "flightsClimbed": 9,
    "stepCount": 5661,
    "walkingSpeed": 2.547710357142857
  },
  {
    "date": "2024-12-04",
    "activeEnergyBurned": 394.197,
    "basalEnergyBurned": 1707.793,
    "distanceWalkingRunning": 4.534621899999999,
    "flightsClimbed": 26,
    "stepCount": 11064,
    "walkingSpeed": 2.7487039024390243
  },
  {
    "date": "2024-12-05",
    "activeEnergyBurned": 205.41,
    "basalEnergyBurned": 1418.663,
    "distanceWalkingRunning": 2.48497533,
    "flightsClimbed": 12,
    "stepCount": 6136,
    "walkingSpeed": 2.730079090909091
  },
  {
    "date": "2024-12-06",
    "activeEnergyBurned": 421.73999999999995,
    "basalEnergyBurned": 1925.7089999999998,
    "distanceWalkingRunning": 5.04649262,
    "flightsClimbed": 23,
    "stepCount": 11075,
    "walkingSpeed": 2.834101086956522
  },
  {
    "date": "2024-12-07",
    "activeEnergyBurned": 219.457,
    "basalEnergyBurned": 1657.685,
    "distanceWalkingRunning": 2.7882707399999997,
    "flightsClimbed": 17,
    "stepCount": 6234,
    "walkingSpeed": 2.7343605263157893
  },
  {
    "date": "2024-12-08",
    "activeEnergyBurned": 209.651,
    "basalEnergyBurned": 1723.618,
    "distanceWalkingRunning": 2.825682984,
    "flightsClimbed": 9,
    "stepCount": 7205,
    "walkingSpeed": 2.764127027027027
  },
  {
    "date": "2024-12-09",
    "activeEnergyBurned": 220.108,
    "basalEnergyBurned": 1673.1889999999999,
    "distanceWalkingRunning": 2.88721391,
    "flightsClimbed": 9,
    "stepCount": 6579,
    "walkingSpeed": 2.783969696969697
  },
  {
    "date": "2024-12-10",
    "activeEnergyBurned": 254.07100000000003,
    "basalEnergyBurned": 1701.68,
    "distanceWalkingRunning": 3.17535992,
    "flightsClimbed": 13,
    "stepCount": 7815,
    "walkingSpeed": 2.6206045454545457
  },
  {
    "date": "2024-12-11",
    "activeEnergyBurned": 248.8,
    "basalEnergyBurned": 1669.314,
    "distanceWalkingRunning": 2.6368625600000004,
    "flightsClimbed": 19,
    "stepCount": 6559,
    "walkingSpeed": 2.7087900000000005
  },
  {
    "date": "2024-12-12",
    "activeEnergyBurned": 307.924,
    "basalEnergyBurned": 1692.868,
    "distanceWalkingRunning": 3.433897300000001,
    "flightsClimbed": 24,
    "stepCount": 7809,
    "walkingSpeed": 2.729808333333333
  },
  {
    "date": "2024-12-13",
    "activeEnergyBurned": 295.273,
    "basalEnergyBurned": 1651.356,
    "distanceWalkingRunning": 3.4735289099999997,
    "flightsClimbed": 23,
    "stepCount": 8134,
    "walkingSpeed": 2.8656978378378377
  },
  {
    "date": "2024-12-14",
    "activeEnergyBurned": 238.65300000000005,
    "basalEnergyBurned": 1691.6209999999999,
    "distanceWalkingRunning": 2.8342263599999997,
    "flightsClimbed": 16,
    "stepCount": 6466,
    "walkingSpeed": 2.8191982352941176
  },
  {
    "date": "2024-12-15",
    "activeEnergyBurned": 157.486,
    "basalEnergyBurned": 1594.6139999999998,
    "distanceWalkingRunning": 1.9488784999999997,
    "flightsClimbed": 7,
    "stepCount": 4503,
    "walkingSpeed": 2.9281495000000004
  },
  {
    "date": "2024-12-16",
    "activeEnergyBurned": 174.60000000000002,
    "basalEnergyBurned": 1573.3559999999998,
    "distanceWalkingRunning": 1.9809530199999998,
    "flightsClimbed": 14,
    "stepCount": 4641,
    "walkingSpeed": 2.7447209999999993
  },
  {
    "date": "2024-12-17",
    "activeEnergyBurned": 287.41,
    "basalEnergyBurned": 1844.1459999999997,
    "distanceWalkingRunning": 3.66077088,
    "flightsClimbed": 15,
    "stepCount": 8231,
    "walkingSpeed": 2.7168121428571426
  },
  {
    "date": "2024-12-18",
    "activeEnergyBurned": 247.40699999999998,
    "basalEnergyBurned": 1539.114,
    "distanceWalkingRunning": 2.7415243,
    "flightsClimbed": 16,
    "stepCount": 6610,
    "walkingSpeed": 2.818539069767442
  },
  {
    "date": "2024-12-19",
    "activeEnergyBurned": 234.526,
    "basalEnergyBurned": 1807.587,
    "distanceWalkingRunning": 2.3705768499999995,
    "flightsClimbed": 29,
    "stepCount": 5613,
    "walkingSpeed": 2.6333216
  },
  {
    "date": "2024-12-20",
    "activeEnergyBurned": 310.75199999999995,
    "basalEnergyBurned": 1432.8099999999995,
    "distanceWalkingRunning": 3.2349522199999994,
    "flightsClimbed": 26,
    "stepCount": 7901,
    "walkingSpeed": 2.8146497826086954
  },
  {
    "date": "2024-12-21",
    "activeEnergyBurned": 384.514,
    "basalEnergyBurned": 1961.4859999999996,
    "distanceWalkingRunning": 5.232904889999999,
    "flightsClimbed": 20,
    "stepCount": 12710,
    "walkingSpeed": 2.6301659649122806
  },
  {
    "date": "2024-12-22",
    "activeEnergyBurned": 45.318999999999996,
    "basalEnergyBurned": 1579.217,
    "distanceWalkingRunning": 0.70793571,
    "flightsClimbed": 3,
    "stepCount": 1427,
    "walkingSpeed": 2.740993333333334
  },
  {
    "date": "2024-12-23",
    "activeEnergyBurned": 36.732,
    "basalEnergyBurned": 1745.406,
    "distanceWalkingRunning": 0.6313293200000001,
    "flightsClimbed": 4,
    "stepCount": 1365,
    "walkingSpeed": 2.37115
  },
  {
    "date": "2024-12-24",
    "activeEnergyBurned": 101.63,
    "basalEnergyBurned": 1643.3000000000002,
    "distanceWalkingRunning": 1.5842206499999998,
    "flightsClimbed": 7,
    "stepCount": 3090,
    "walkingSpeed": 2.418376666666667
  },
  {
    "date": "2024-12-25",
    "activeEnergyBurned": 44.00300000000001,
    "basalEnergyBurned": 1667.273,
    "distanceWalkingRunning": 0.8002502599999999,
    "flightsClimbed": 1,
    "stepCount": 1827,
    "walkingSpeed": 2.158644285714286
  },
  {
    "date": "2024-12-26",
    "activeEnergyBurned": 83.628,
    "basalEnergyBurned": 1548.7869999999996,
    "distanceWalkingRunning": 1.2433627400000002,
    "flightsClimbed": 7,
    "stepCount": 2558,
    "walkingSpeed": 2.261169166666667
  },
  {
    "date": "2024-12-27",
    "activeEnergyBurned": 98.024,
    "basalEnergyBurned": 1792.022,
    "distanceWalkingRunning": 1.45745587,
    "flightsClimbed": 7,
    "stepCount": 2785,
    "walkingSpeed": 2.6284000000000005
  },
  {
    "date": "2024-12-28",
    "activeEnergyBurned": 127.154,
    "basalEnergyBurned": 1521.106,
    "distanceWalkingRunning": 1.92190019,
    "flightsClimbed": 7,
    "stepCount": 3754,
    "walkingSpeed": 2.6204107142857143
  },
  {
    "date": "2024-12-29",
    "activeEnergyBurned": 185.71999999999997,
    "basalEnergyBurned": 1804.4819999999997,
    "distanceWalkingRunning": 3.35063408,
    "flightsClimbed": 4,
    "stepCount": 8048,
    "walkingSpeed": 2.62169
  },
  {
    "date": "2024-12-30",
    "activeEnergyBurned": 57.515,
    "basalEnergyBurned": 1644.7520000000002,
    "distanceWalkingRunning": 0.988935,
    "flightsClimbed": 6,
    "stepCount": 2200,
    "walkingSpeed": 2.30124625
  },
  {
    "date": "2024-12-31",
    "activeEnergyBurned": 36.385,
    "basalEnergyBurned": 1636.5769999999998,
    "distanceWalkingRunning": 0.59278495,
    "flightsClimbed": 6,
    "stepCount": 1430,
    "walkingSpeed": 2.4214849999999997
  },
  {
    "date": "2025-01-01",
    "activeEnergyBurned": 84.009,
    "basalEnergyBurned": 1578.3129999999999,
    "distanceWalkingRunning": 1.2057124799999999,
    "flightsClimbed": 6,
    "stepCount": 2275,
    "walkingSpeed": 2.79617
  },
  {
    "date": "2025-01-02",
    "activeEnergyBurned": 72.88699999999999,
    "basalEnergyBurned": 1776.0069999999996,
    "distanceWalkingRunning": 1.08025174,
    "flightsClimbed": 3,
    "stepCount": 1888,
    "walkingSpeed": 3.713315
  },
  {
    "date": "2025-01-03",
    "activeEnergyBurned": 39.36,
    "basalEnergyBurned": 1610.343,
    "distanceWalkingRunning": 0.6062941399999999,
    "flightsClimbed": 5,
    "stepCount": 1265,
    "walkingSpeed": 2.408436666666667
  },
  {
    "date": "2025-01-04",
    "activeEnergyBurned": 45.653,
    "basalEnergyBurned": 1556.273,
    "distanceWalkingRunning": 0.88039876,
    "flightsClimbed": 5,
    "stepCount": 2232,
    "walkingSpeed": 2.5184175
  },
  {
    "date": "2025-01-05",
    "activeEnergyBurned": 96.93999999999998,
    "basalEnergyBurned": 1611.611,
    "distanceWalkingRunning": 1.48483811,
    "flightsClimbed": 3,
    "stepCount": 3640,
    "walkingSpeed": 2.5703461904761906
  },
  {
    "date": "2025-01-06",
    "activeEnergyBurned": 344.03700000000003,
    "basalEnergyBurned": 1833.601,
    "distanceWalkingRunning": 4.406290689999998,
    "flightsClimbed": 21,
    "stepCount": 10112,
    "walkingSpeed": 2.6885441509433963
  },
  {
    "date": "2025-01-07",
    "activeEnergyBurned": 187.50900000000001,
    "basalEnergyBurned": 1736.283,
    "distanceWalkingRunning": 2.1831015139999996,
    "flightsClimbed": 13,
    "stepCount": 4992,
    "walkingSpeed": 2.7430425
  },
  {
    "date": "2025-01-08",
    "activeEnergyBurned": 193.88200000000003,
    "basalEnergyBurned": 1682.2559999999999,
    "distanceWalkingRunning": 2.24281965,
    "flightsClimbed": 18,
    "stepCount": 5519,
    "walkingSpeed": 2.7290617647058824
  },
  {
    "date": "2025-01-09",
    "activeEnergyBurned": 230.938,
    "basalEnergyBurned": 1464.8049999999996,
    "distanceWalkingRunning": 2.7895261820000004,
    "flightsClimbed": 8,
    "stepCount": 6598,
    "walkingSpeed": 2.802561428571429
  },
  {
    "date": "2025-01-10",
    "activeEnergyBurned": 423.487,
    "basalEnergyBurned": 1902.254,
    "distanceWalkingRunning": 5.24388223,
    "flightsClimbed": 19,
    "stepCount": 12319,
    "walkingSpeed": 2.7867748
  },
  {
    "date": "2025-01-11",
    "activeEnergyBurned": 354.83299999999997,
    "basalEnergyBurned": 1674.3419999999999,
    "distanceWalkingRunning": 4.6341069500000005,
    "flightsClimbed": 17,
    "stepCount": 10664,
    "walkingSpeed": 2.816270869565218
  },
  {
    "date": "2025-01-12",
    "activeEnergyBurned": 51.426,
    "basalEnergyBurned": 1625.9339999999997,
    "distanceWalkingRunning": 0.7031925699999999,
    "flightsClimbed": 1,
    "stepCount": 1626,
    "walkingSpeed": 2.8819199999999996
  },
  {
    "date": "2025-01-13",
    "activeEnergyBurned": 316.51000000000005,
    "basalEnergyBurned": 1688.777,
    "distanceWalkingRunning": 3.8946575300000004,
    "flightsClimbed": 21,
    "stepCount": 9113,
    "walkingSpeed": 2.794450192307692
  },
  {
    "date": "2025-01-14",
    "activeEnergyBurned": 236.29000000000002,
    "basalEnergyBurned": 1589.3229999999996,
    "distanceWalkingRunning": 3.05791289,
    "flightsClimbed": 8,
    "stepCount": 6799,
    "walkingSpeed": 2.7408065
  },
  {
    "date": "2025-01-15",
    "activeEnergyBurned": 206.93,
    "basalEnergyBurned": 1537.7920000000001,
    "distanceWalkingRunning": 2.56254671,
    "flightsClimbed": 19,
    "stepCount": 6003,
    "walkingSpeed": 2.945765625
  },
  {
    "date": "2025-01-16",
    "activeEnergyBurned": 301.5690000000001,
    "basalEnergyBurned": 1911.6109999999999,
    "distanceWalkingRunning": 3.68662062,
    "flightsClimbed": 14,
    "stepCount": 8334,
    "walkingSpeed": 2.8703418421052636
  },
  {
    "date": "2025-01-17",
    "activeEnergyBurned": 274.863,
    "basalEnergyBurned": 1668.0449999999998,
    "distanceWalkingRunning": 3.56160219,
    "flightsClimbed": 10,
    "stepCount": 7895,
    "walkingSpeed": 2.8837314285714286
  },
  {
    "date": "2025-01-18",
    "activeEnergyBurned": 164.728,
    "basalEnergyBurned": 1640.062,
    "distanceWalkingRunning": 2.25226162,
    "flightsClimbed": 7,
    "stepCount": 4927,
    "walkingSpeed": 2.9498703225806455
  },
  {
    "date": "2025-01-19",
    "activeEnergyBurned": 87.22600000000001,
    "basalEnergyBurned": 1722.8399999999997,
    "distanceWalkingRunning": 1.25336234,
    "flightsClimbed": 5,
    "stepCount": 3143,
    "walkingSpeed": 2.5236713636363635
  },
  {
    "date": "2025-01-20",
    "activeEnergyBurned": 349.54799999999994,
    "basalEnergyBurned": 1594.884,
    "distanceWalkingRunning": 4.540152300000001,
    "flightsClimbed": 14,
    "stepCount": 10528,
    "walkingSpeed": 2.561825
  },
  {
    "date": "2025-01-21",
    "activeEnergyBurned": 349.735,
    "basalEnergyBurned": 1783.484,
    "distanceWalkingRunning": 3.8372457900000003,
    "flightsClimbed": 25,
    "stepCount": 9347,
    "walkingSpeed": 2.716720344827587
  },
  {
    "date": "2025-01-22",
    "activeEnergyBurned": 137.468,
    "basalEnergyBurned": 1658.0649999999998,
    "distanceWalkingRunning": 1.9620036800000002,
    "flightsClimbed": 5,
    "stepCount": 4468,
    "walkingSpeed": 2.5857590625
  },
  {
    "date": "2025-01-23",
    "activeEnergyBurned": 212.89200000000002,
    "basalEnergyBurned": 1468.6509999999998,
    "distanceWalkingRunning": 2.76944659,
    "flightsClimbed": 11,
    "stepCount": 6723,
    "walkingSpeed": 2.4941840625
  },
  {
    "date": "2025-01-24",
    "activeEnergyBurned": 198.138,
    "basalEnergyBurned": 1876.7129999999997,
    "distanceWalkingRunning": 2.76457198,
    "flightsClimbed": 12,
    "stepCount": 6229,
    "walkingSpeed": 2.700940857142857
  },
  {
    "date": "2025-01-25",
    "activeEnergyBurned": 137.703,
    "basalEnergyBurned": 1675.309,
    "distanceWalkingRunning": 1.83493124,
    "flightsClimbed": 9,
    "stepCount": 4213,
    "walkingSpeed": 2.848365925925926
  },
  {
    "date": "2025-01-26",
    "activeEnergyBurned": 195.39600000000004,
    "basalEnergyBurned": 1448.8009999999997,
    "distanceWalkingRunning": 2.4938390200000002,
    "flightsClimbed": 9,
    "stepCount": 5636,
    "walkingSpeed": 2.6683454761904764
  },
  {
    "date": "2025-01-27",
    "activeEnergyBurned": 312.62699999999995,
    "basalEnergyBurned": 1923.2929999999997,
    "distanceWalkingRunning": 3.73905535,
    "flightsClimbed": 21,
    "stepCount": 8821,
    "walkingSpeed": 2.86216075
  },
  {
    "date": "2025-01-28",
    "activeEnergyBurned": 403.01399999999995,
    "basalEnergyBurned": 1659.6979999999999,
    "distanceWalkingRunning": 4.6565900099999995,
    "flightsClimbed": 26,
    "stepCount": 9917,
    "walkingSpeed": 2.927112195121951
  },
  {
    "date": "2025-01-29",
    "activeEnergyBurned": 388.159,
    "basalEnergyBurned": 1696.9089999999999,
    "distanceWalkingRunning": 4.764286060000001,
    "flightsClimbed": 22,
    "stepCount": 10430,
    "walkingSpeed": 2.8569871875
  },
  {
    "date": "2025-01-30",
    "activeEnergyBurned": 333.11100000000005,
    "basalEnergyBurned": 1690.4980000000003,
    "distanceWalkingRunning": 3.7158188,
    "flightsClimbed": 34,
    "stepCount": 9168,
    "walkingSpeed": 2.717308983050847
  },
  {
    "date": "2025-01-31",
    "activeEnergyBurned": 362.732,
    "basalEnergyBurned": 1511.202,
    "distanceWalkingRunning": 4.30505937,
    "flightsClimbed": 9,
    "stepCount": 10031,
    "walkingSpeed": 2.9802095454545454
  },
  {
    "date": "2025-02-01",
    "activeEnergyBurned": 143.48299999999998,
    "basalEnergyBurned": 1815.058,
    "distanceWalkingRunning": 2.1866118109999997,
    "flightsClimbed": 7,
    "stepCount": 5495,
    "walkingSpeed": 2.595706538461538
  },
  {
    "date": "2025-02-02",
    "activeEnergyBurned": 141.171,
    "basalEnergyBurned": 1684.446,
    "distanceWalkingRunning": 1.6734854500000005,
    "flightsClimbed": 10,
    "stepCount": 4075,
    "walkingSpeed": 2.722351
  },
  {
    "date": "2025-02-03",
    "activeEnergyBurned": 268.27099999999996,
    "basalEnergyBurned": 1647.8799999999999,
    "distanceWalkingRunning": 3.14771912,
    "flightsClimbed": 13,
    "stepCount": 7156,
    "walkingSpeed": 2.860964137931034
  },
  {
    "date": "2025-02-04",
    "activeEnergyBurned": 448.16799999999995,
    "basalEnergyBurned": 1727.1239999999998,
    "distanceWalkingRunning": 4.998984190000001,
    "flightsClimbed": 36,
    "stepCount": 11111,
    "walkingSpeed": 2.787222888888889
  },
  {
    "date": "2025-02-05",
    "activeEnergyBurned": 351.65,
    "basalEnergyBurned": 1702.101,
    "distanceWalkingRunning": 4.36004367,
    "flightsClimbed": 19,
    "stepCount": 10248,
    "walkingSpeed": 2.8279846666666666
  },
  {
    "date": "2025-02-06",
    "activeEnergyBurned": 198.724,
    "basalEnergyBurned": 1682.882,
    "distanceWalkingRunning": 2.3032848500000003,
    "flightsClimbed": 11,
    "stepCount": 5365,
    "walkingSpeed": 3.0213546666666664
  },
  {
    "date": "2025-02-07",
    "activeEnergyBurned": 363.76099999999997,
    "basalEnergyBurned": 1667.093,
    "distanceWalkingRunning": 5.247008581,
    "flightsClimbed": 18,
    "stepCount": 11886,
    "walkingSpeed": 2.7152145238095238
  },
  {
    "date": "2025-02-08",
    "activeEnergyBurned": 256.647,
    "basalEnergyBurned": 1591.0779999999997,
    "distanceWalkingRunning": 2.88191142,
    "flightsClimbed": 18,
    "stepCount": 6614,
    "walkingSpeed": 2.7873481690140847
  },
  {
    "date": "2025-02-09",
    "activeEnergyBurned": 130.802,
    "basalEnergyBurned": 1747.6589999999997,
    "distanceWalkingRunning": 1.6176086500000002,
    "flightsClimbed": 8,
    "stepCount": 3953,
    "walkingSpeed": 2.6163553846153844
  },
  {
    "date": "2025-02-10",
    "activeEnergyBurned": 101.242,
    "basalEnergyBurned": 1591.3719999999998,
    "distanceWalkingRunning": 1.2612182799999998,
    "flightsClimbed": 9,
    "stepCount": 2827,
    "walkingSpeed": 2.684324666666667
  },
  {
    "date": "2025-02-11",
    "activeEnergyBurned": 18.781000000000006,
    "basalEnergyBurned": 1489.675,
    "distanceWalkingRunning": 0.22881995600000002,
    "flightsClimbed": 2,
    "stepCount": 568,
    "walkingSpeed": 2.4457166666666663
  },
  {
    "date": "2025-02-12",
    "activeEnergyBurned": 220.248,
    "basalEnergyBurned": 1748.4299999999998,
    "distanceWalkingRunning": 2.8508025100000003,
    "flightsClimbed": 6,
    "stepCount": 6612,
    "walkingSpeed": 2.982115625
  },
  {
    "date": "2025-02-13",
    "activeEnergyBurned": 293.666,
    "basalEnergyBurned": 1810.0079999999998,
    "distanceWalkingRunning": 3.45016316,
    "flightsClimbed": 24,
    "stepCount": 7914,
    "walkingSpeed": 2.8661781481481485
  },
  {
    "date": "2025-02-14",
    "activeEnergyBurned": 296.22299999999996,
    "basalEnergyBurned": 1726.37,
    "distanceWalkingRunning": 3.94741066,
    "flightsClimbed": 18,
    "stepCount": 8994,
    "walkingSpeed": 2.7358706521739133
  },
  {
    "date": "2025-02-15",
    "activeEnergyBurned": 129.43099999999998,
    "basalEnergyBurned": 1682.149,
    "distanceWalkingRunning": 1.43544277,
    "flightsClimbed": 6,
    "stepCount": 3581,
    "walkingSpeed": 2.3786077777777783
  },
  {
    "date": "2025-02-16",
    "activeEnergyBurned": 211.263,
    "basalEnergyBurned": 1548.3169999999998,
    "distanceWalkingRunning": 2.8743356079999995,
    "flightsClimbed": 6,
    "stepCount": 6810,
    "walkingSpeed": 2.3675109302325583
  },
  {
    "date": "2025-02-17",
    "activeEnergyBurned": 220.38000000000002,
    "basalEnergyBurned": 1804.913,
    "distanceWalkingRunning": 2.5639057100000007,
    "flightsClimbed": 17,
    "stepCount": 6207,
    "walkingSpeed": 2.8095932
  },
  {
    "date": "2025-02-18",
    "activeEnergyBurned": 292.35699999999997,
    "basalEnergyBurned": 1677.5879999999997,
    "distanceWalkingRunning": 3.3918777,
    "flightsClimbed": 31,
    "stepCount": 7776,
    "walkingSpeed": 2.792223235294118
  },
  {
    "date": "2025-02-19",
    "activeEnergyBurned": 359.4159999999999,
    "basalEnergyBurned": 1683.3919999999998,
    "distanceWalkingRunning": 4.38379538,
    "flightsClimbed": 20,
    "stepCount": 9972,
    "walkingSpeed": 2.76727625
  },
  {
    "date": "2025-02-20",
    "activeEnergyBurned": 250.914,
    "basalEnergyBurned": 1612.14,
    "distanceWalkingRunning": 2.8729088000000003,
    "flightsClimbed": 22,
    "stepCount": 6539,
    "walkingSpeed": 2.834518571428571
  },
  {
    "date": "2025-02-21",
    "activeEnergyBurned": 314.99,
    "basalEnergyBurned": 1735.1529999999998,
    "distanceWalkingRunning": 3.90976501,
    "flightsClimbed": 20,
    "stepCount": 8730,
    "walkingSpeed": 2.9409126470588234
  },
  {
    "date": "2025-02-22",
    "activeEnergyBurned": 352.43799999999993,
    "basalEnergyBurned": 1700.685,
    "distanceWalkingRunning": 4.473926690000001,
    "flightsClimbed": 21,
    "stepCount": 9782,
    "walkingSpeed": 2.9916354761904764
  },
  {
    "date": "2025-02-23",
    "activeEnergyBurned": 148.399,
    "basalEnergyBurned": 1661.9199999999996,
    "distanceWalkingRunning": 1.9767040900000004,
    "flightsClimbed": 7,
    "stepCount": 4541,
    "walkingSpeed": 2.7149336842105263
  },
  {
    "date": "2025-02-24",
    "activeEnergyBurned": 242.44399999999996,
    "basalEnergyBurned": 1677.074,
    "distanceWalkingRunning": 3.4115666599999996,
    "flightsClimbed": 8,
    "stepCount": 8860,
    "walkingSpeed": 2.7422548717948714
  },
  {
    "date": "2025-02-25",
    "activeEnergyBurned": 295.07500000000005,
    "basalEnergyBurned": 1685.2390000000003,
    "distanceWalkingRunning": 3.17605091,
    "flightsClimbed": 19,
    "stepCount": 7313,
    "walkingSpeed": 2.828003269230769
  },
  {
    "date": "2025-02-26",
    "activeEnergyBurned": 366.485,
    "basalEnergyBurned": 1689.214,
    "distanceWalkingRunning": 4.748535887,
    "flightsClimbed": 18,
    "stepCount": 10775,
    "walkingSpeed": 2.893971395348837
  },
  {
    "date": "2025-02-27",
    "activeEnergyBurned": 341.086,
    "basalEnergyBurned": 1668.328,
    "distanceWalkingRunning": 3.98972219,
    "flightsClimbed": 28,
    "stepCount": 9235,
    "walkingSpeed": 2.76030873015873
  },
  {
    "date": "2025-02-28",
    "activeEnergyBurned": 241.41600000000003,
    "basalEnergyBurned": 1690.8100000000002,
    "distanceWalkingRunning": 2.77824872,
    "flightsClimbed": 22,
    "stepCount": 6307,
    "walkingSpeed": 2.38234
  },
  {
    "date": "2025-03-01",
    "activeEnergyBurned": 436.9910000000001,
    "basalEnergyBurned": 1688.369,
    "distanceWalkingRunning": 5.02016738,
    "flightsClimbed": 26,
    "stepCount": 10945,
    "walkingSpeed": 2.9581882857142854
  },
  {
    "date": "2025-03-02",
    "activeEnergyBurned": 89.65399999999998,
    "basalEnergyBurned": 1558.9729999999997,
    "distanceWalkingRunning": 1.00304742,
    "flightsClimbed": 10,
    "stepCount": 2315,
    "walkingSpeed": 2.7029650000000003
  },
  {
    "date": "2025-03-03",
    "activeEnergyBurned": 349.21999999999997,
    "basalEnergyBurned": 1781.6509999999998,
    "distanceWalkingRunning": 4.29565662,
    "flightsClimbed": 12,
    "stepCount": 9159,
    "walkingSpeed": 3.0092123809523805
  },
  {
    "date": "2025-03-04",
    "activeEnergyBurned": 279.032,
    "basalEnergyBurned": 1694.616,
    "distanceWalkingRunning": 3.3825471100000004,
    "flightsClimbed": 16,
    "stepCount": 8067,
    "walkingSpeed": 2.8132410526315788
  },
  {
    "date": "2025-03-05",
    "activeEnergyBurned": 413.065,
    "basalEnergyBurned": 1691.892,
    "distanceWalkingRunning": 5.26207063,
    "flightsClimbed": 16,
    "stepCount": 12327,
    "walkingSpeed": 2.8715454347826084
  },
  {
    "date": "2025-03-06",
    "activeEnergyBurned": 323.14000000000004,
    "basalEnergyBurned": 1679.2219999999998,
    "distanceWalkingRunning": 3.7443741799999994,
    "flightsClimbed": 19,
    "stepCount": 8230,
    "walkingSpeed": 2.776539591836735
  },
  {
    "date": "2025-03-07",
    "activeEnergyBurned": 421.20000000000005,
    "basalEnergyBurned": 1679.096,
    "distanceWalkingRunning": 4.8537176099999995,
    "flightsClimbed": 30,
    "stepCount": 9970,
    "walkingSpeed": 3.0373229268292685
  },
  {
    "date": "2025-03-08",
    "activeEnergyBurned": 371.616,
    "basalEnergyBurned": 1704.866,
    "distanceWalkingRunning": 4.441370496999999,
    "flightsClimbed": 31,
    "stepCount": 9838,
    "walkingSpeed": 2.8502293749999996
  },
  {
    "date": "2025-03-09",
    "activeEnergyBurned": 345.07,
    "basalEnergyBurned": 1579.1730000000002,
    "distanceWalkingRunning": 4.32095303,
    "flightsClimbed": 12,
    "stepCount": 9921,
    "walkingSpeed": 3.0288116
  },
  {
    "date": "2025-03-10",
    "activeEnergyBurned": 430.871,
    "basalEnergyBurned": 1781.3429999999998,
    "distanceWalkingRunning": 4.981492660000001,
    "flightsClimbed": 28,
    "stepCount": 11926,
    "walkingSpeed": 2.797925294117647
  },
  {
    "date": "2025-03-11",
    "activeEnergyBurned": 330.68500000000006,
    "basalEnergyBurned": 1649.7989999999998,
    "distanceWalkingRunning": 3.6282253559999997,
    "flightsClimbed": 19,
    "stepCount": 8432,
    "walkingSpeed": 2.787862285714285
  },
  {
    "date": "2025-03-12",
    "activeEnergyBurned": 221.57900000000004,
    "basalEnergyBurned": 1622.007,
    "distanceWalkingRunning": 2.72255688,
    "flightsClimbed": 10,
    "stepCount": 6284,
    "walkingSpeed": 2.7992555172413787
  },
  {
    "date": "2025-03-13",
    "activeEnergyBurned": 296.748,
    "basalEnergyBurned": 1702.3459999999998,
    "distanceWalkingRunning": 3.60752471,
    "flightsClimbed": 15,
    "stepCount": 7928,
    "walkingSpeed": 2.8090330000000003
  },
  {
    "date": "2025-03-14",
    "activeEnergyBurned": 127.26899999999998,
    "basalEnergyBurned": 1678.981,
    "distanceWalkingRunning": 1.64019813,
    "flightsClimbed": 12,
    "stepCount": 3910,
    "walkingSpeed": 2.85489
  },
  {
    "date": "2025-03-15",
    "activeEnergyBurned": 300.6700000000001,
    "basalEnergyBurned": 1686.7290000000003,
    "distanceWalkingRunning": 3.88953793,
    "flightsClimbed": 17,
    "stepCount": 8658,
    "walkingSpeed": 2.725596619718311
  },
  {
    "date": "2025-03-16",
    "activeEnergyBurned": 92.994,
    "basalEnergyBurned": 1583.504,
    "distanceWalkingRunning": 1.1051691499999998,
    "flightsClimbed": 7,
    "stepCount": 2490,
    "walkingSpeed": 2.8632766666666662
  },
  {
    "date": "2025-03-17",
    "activeEnergyBurned": 149.248,
    "basalEnergyBurned": 1744.428,
    "distanceWalkingRunning": 1.9637017100000003,
    "flightsClimbed": 7,
    "stepCount": 4578,
    "walkingSpeed": 2.7914605263157894
  },
  {
    "date": "2025-03-18",
    "activeEnergyBurned": 397.2049999999999,
    "basalEnergyBurned": 1592.026,
    "distanceWalkingRunning": 5.258717799999999,
    "flightsClimbed": 9,
    "stepCount": 12288,
    "walkingSpeed": 2.742828
  },
  {
    "date": "2025-03-19",
    "activeEnergyBurned": 224.388,
    "basalEnergyBurned": 1797.5760000000002,
    "distanceWalkingRunning": 2.9855039,
    "flightsClimbed": 7,
    "stepCount": 6887,
    "walkingSpeed": 2.6990239999999996
  },
  {
    "date": "2025-03-20",
    "activeEnergyBurned": 401.11400000000003,
    "basalEnergyBurned": 1737.289,
    "distanceWalkingRunning": 5.493543150000001,
    "flightsClimbed": 3,
    "stepCount": 13149,
    "walkingSpeed": 2.7596726315789475
  },
  {
    "date": "2025-03-21",
    "activeEnergyBurned": 162.32599999999996,
    "basalEnergyBurned": 1640.164,
    "distanceWalkingRunning": 1.990140388,
    "flightsClimbed": 13,
    "stepCount": 5085,
    "walkingSpeed": 2.7449367741935484
  },
  {
    "date": "2025-03-22",
    "activeEnergyBurned": 30.346999999999998,
    "basalEnergyBurned": 1696.254,
    "distanceWalkingRunning": 0.625806152,
    "flightsClimbed": 4,
    "stepCount": 1711,
    "walkingSpeed": 2.2816746153846155
  },
  {
    "date": "2025-03-23",
    "activeEnergyBurned": 109.32600000000001,
    "basalEnergyBurned": 1479.693,
    "distanceWalkingRunning": 1.6253660499999998,
    "flightsClimbed": 3,
    "stepCount": 4009,
    "walkingSpeed": 2.5122515384615385
  },
  {
    "date": "2025-03-24",
    "activeEnergyBurned": 339.82800000000003,
    "basalEnergyBurned": 1854.4489999999998,
    "distanceWalkingRunning": 4.4622025800000005,
    "flightsClimbed": 11,
    "stepCount": 9843,
    "walkingSpeed": 2.7705280487804878
  },
  {
    "date": "2025-03-25",
    "activeEnergyBurned": 259.28400000000005,
    "basalEnergyBurned": 1599.69,
    "distanceWalkingRunning": 2.93672669,
    "flightsClimbed": 21,
    "stepCount": 6634,
    "walkingSpeed": 2.6901401999999996
  },
  {
    "date": "2025-03-26",
    "activeEnergyBurned": 278.193,
    "basalEnergyBurned": 1452.287,
    "distanceWalkingRunning": 4.252176779999999,
    "flightsClimbed": 9,
    "stepCount": 9333,
    "walkingSpeed": 2.879171842105263
  },
  {
    "date": "2025-03-27",
    "activeEnergyBurned": 349.534,
    "basalEnergyBurned": 1896.612,
    "distanceWalkingRunning": 4.865976290000001,
    "flightsClimbed": 11,
    "stepCount": 11007,
    "walkingSpeed": 2.7244802409638558
  },
  {
    "date": "2025-03-28",
    "activeEnergyBurned": 301.392,
    "basalEnergyBurned": 1799.8239999999996,
    "distanceWalkingRunning": 4.35994003,
    "flightsClimbed": 8,
    "stepCount": 9463,
    "walkingSpeed": 2.7656273076923075
  },
  {
    "date": "2025-03-29",
    "activeEnergyBurned": 373.37,
    "basalEnergyBurned": 1578.243,
    "distanceWalkingRunning": 4.146513426,
    "flightsClimbed": 28,
    "stepCount": 9456,
    "walkingSpeed": 2.865142291666667
  },
  {
    "date": "2025-03-30",
    "activeEnergyBurned": 273.038,
    "basalEnergyBurned": 1789.8560000000004,
    "distanceWalkingRunning": 3.2337420599999995,
    "flightsClimbed": 17,
    "stepCount": 7986,
    "walkingSpeed": 2.687192051282051
  },
  {
    "date": "2025-03-31",
    "activeEnergyBurned": 280.29200000000003,
    "basalEnergyBurned": 1624.781,
    "distanceWalkingRunning": 3.444493646,
    "flightsClimbed": 11,
    "stepCount": 7511,
    "walkingSpeed": 2.764420645161291
  },
  {
    "date": "2025-04-01",
    "activeEnergyBurned": 363.843,
    "basalEnergyBurned": 1744.921,
    "distanceWalkingRunning": 4.113671137,
    "flightsClimbed": 24,
    "stepCount": 9140,
    "walkingSpeed": 2.819086341463415
  },
  {
    "date": "2025-04-02",
    "activeEnergyBurned": 349.23599999999993,
    "basalEnergyBurned": 1698.5349999999999,
    "distanceWalkingRunning": 4.11473466,
    "flightsClimbed": 19,
    "stepCount": 10317,
    "walkingSpeed": 2.8334527083333327
  },
  {
    "date": "2025-04-03",
    "activeEnergyBurned": 263.02700000000004,
    "basalEnergyBurned": 1525.1259999999997,
    "distanceWalkingRunning": 2.73579726,
    "flightsClimbed": 21,
    "stepCount": 6356,
    "walkingSpeed": 2.755498181818182
  },
  {
    "date": "2025-04-04",
    "activeEnergyBurned": 246.909,
    "basalEnergyBurned": 1762.0829999999999,
    "distanceWalkingRunning": 2.792267124,
    "flightsClimbed": 17,
    "stepCount": 6653,
    "walkingSpeed": 2.796170294117647
  },
  {
    "date": "2025-04-05",
    "activeEnergyBurned": 219.27,
    "basalEnergyBurned": 1730.671,
    "distanceWalkingRunning": 2.48364381,
    "flightsClimbed": 11,
    "stepCount": 5583,
    "walkingSpeed": 2.8815818181818185
  },
  {
    "date": "2025-04-06",
    "activeEnergyBurned": 172.798,
    "basalEnergyBurned": 1468.3359999999998,
    "distanceWalkingRunning": 2.51556191,
    "flightsClimbed": 6,
    "stepCount": 5861,
    "walkingSpeed": 2.8874139473684206
  },
  {
    "date": "2025-04-07",
    "activeEnergyBurned": 272.223,
    "basalEnergyBurned": 1758.702,
    "distanceWalkingRunning": 3.13437354,
    "flightsClimbed": 18,
    "stepCount": 7712,
    "walkingSpeed": 2.764336923076923
  },
  {
    "date": "2025-04-08",
    "activeEnergyBurned": 176.199,
    "basalEnergyBurned": 1595.013,
    "distanceWalkingRunning": 2.243921946,
    "flightsClimbed": 11,
    "stepCount": 5016,
    "walkingSpeed": 3.0113414285714293
  },
  {
    "date": "2025-04-09",
    "activeEnergyBurned": 215.03099999999998,
    "basalEnergyBurned": 1824.9899999999998,
    "distanceWalkingRunning": 2.6444382730000004,
    "flightsClimbed": 19,
    "stepCount": 6010,
    "walkingSpeed": 2.32641
  },
  {
    "date": "2025-04-10",
    "activeEnergyBurned": 342.57499999999993,
    "basalEnergyBurned": 1694.974,
    "distanceWalkingRunning": 3.95220374,
    "flightsClimbed": 22,
    "stepCount": 8944
  },
  {
    "date": "2025-04-11",
    "activeEnergyBurned": 176.04800000000003,
    "basalEnergyBurned": 1658.3349999999998,
    "distanceWalkingRunning": 2.3144282499999997,
    "flightsClimbed": 9,
    "stepCount": 5557,
    "walkingSpeed": 2.7231945901639345
  },
  {
    "date": "2025-04-12",
    "activeEnergyBurned": 105.528,
    "basalEnergyBurned": 1716.6819999999998,
    "distanceWalkingRunning": 1.6649932199999997,
    "flightsClimbed": 4,
    "stepCount": 3917,
    "walkingSpeed": 2.7034969047619044
  },
  {
    "date": "2025-04-13",
    "activeEnergyBurned": 229.57800000000003,
    "basalEnergyBurned": 1680.057,
    "distanceWalkingRunning": 2.8553738899999996,
    "flightsClimbed": 12,
    "stepCount": 6905,
    "walkingSpeed": 2.7523633333333337
  },
  {
    "date": "2025-04-14",
    "activeEnergyBurned": 153.358,
    "basalEnergyBurned": 1621.769,
    "distanceWalkingRunning": 1.83742282,
    "flightsClimbed": 8,
    "stepCount": 4652,
    "walkingSpeed": 2.6314518181818185
  },
  {
    "date": "2025-04-15",
    "activeEnergyBurned": 263.22100000000006,
    "basalEnergyBurned": 1632.982,
    "distanceWalkingRunning": 2.99188012,
    "flightsClimbed": 17,
    "stepCount": 6761,
    "walkingSpeed": 2.6279536
  },
  {
    "date": "2025-04-16",
    "activeEnergyBurned": 150.874,
    "basalEnergyBurned": 1711.6829999999998,
    "distanceWalkingRunning": 1.96859641,
    "flightsClimbed": 9,
    "stepCount": 5026,
    "walkingSpeed": 2.73745
  },
  {
    "date": "2025-04-17",
    "activeEnergyBurned": 224.237,
    "basalEnergyBurned": 1637.9719999999998,
    "distanceWalkingRunning": 2.8831637699999995,
    "flightsClimbed": 11,
    "stepCount": 6463,
    "walkingSpeed": 2.6581353658536586
  },
  {
    "date": "2025-04-18",
    "activeEnergyBurned": 375.721,
    "basalEnergyBurned": 1755.049,
    "distanceWalkingRunning": 4.680916659999999,
    "flightsClimbed": 22,
    "stepCount": 11324,
    "walkingSpeed": 2.750843421052631
  },
  {
    "date": "2025-04-19",
    "activeEnergyBurned": 268.898,
    "basalEnergyBurned": 1614.8360000000002,
    "distanceWalkingRunning": 3.4845337499999998,
    "flightsClimbed": 13,
    "stepCount": 8748,
    "walkingSpeed": 2.724967042253521
  },
  {
    "date": "2025-04-20",
    "activeEnergyBurned": 179.543,
    "basalEnergyBurned": 1733.3549999999998,
    "distanceWalkingRunning": 2.427626253,
    "flightsClimbed": 3,
    "stepCount": 5911,
    "walkingSpeed": 2.682832
  },
  {
    "date": "2025-04-21",
    "activeEnergyBurned": 386.39599999999996,
    "basalEnergyBurned": 1664.078,
    "distanceWalkingRunning": 4.64651799,
    "flightsClimbed": 22,
    "stepCount": 10534,
    "walkingSpeed": 2.6535662500000003
  },
  {
    "date": "2025-04-22",
    "activeEnergyBurned": 291.73400000000004,
    "basalEnergyBurned": 1620.888,
    "distanceWalkingRunning": 4.0824579,
    "flightsClimbed": 11,
    "stepCount": 9476,
    "walkingSpeed": 2.738318735632184
  },
  {
    "date": "2025-04-23",
    "activeEnergyBurned": 368.356,
    "basalEnergyBurned": 1809.734,
    "distanceWalkingRunning": 4.34937436,
    "flightsClimbed": 17,
    "stepCount": 10302,
    "walkingSpeed": 2.859331176470588
  },
  {
    "date": "2025-04-24",
    "activeEnergyBurned": 363.62,
    "basalEnergyBurned": 1617.126,
    "distanceWalkingRunning": 4.37077613,
    "flightsClimbed": 18,
    "stepCount": 9732,
    "walkingSpeed": 2.701406000000001
  },
  {
    "date": "2025-04-25",
    "activeEnergyBurned": 192.70800000000003,
    "basalEnergyBurned": 1770.812,
    "distanceWalkingRunning": 2.75002053,
    "flightsClimbed": 12,
    "stepCount": 6652,
    "walkingSpeed": 2.797890769230769
  },
  {
    "date": "2025-04-26",
    "activeEnergyBurned": 522.3259999999999,
    "basalEnergyBurned": 1691.0829999999999,
    "distanceWalkingRunning": 6.842375870000001,
    "flightsClimbed": 22,
    "stepCount": 16449,
    "walkingSpeed": 2.6437951764705887
  },
  {
    "date": "2025-04-27",
    "activeEnergyBurned": 230.15300000000002,
    "basalEnergyBurned": 1504.3019999999995,
    "distanceWalkingRunning": 2.70910246,
    "flightsClimbed": 20,
    "stepCount": 6391,
    "walkingSpeed": 2.7362994117647057
  },
  {
    "date": "2025-04-28",
    "activeEnergyBurned": 363.5679999999999,
    "basalEnergyBurned": 1827.6899999999998,
    "distanceWalkingRunning": 4.380142049999999,
    "flightsClimbed": 12,
    "stepCount": 10866,
    "walkingSpeed": 2.7823544117647057
  },
  {
    "date": "2025-04-29",
    "activeEnergyBurned": 545.107,
    "basalEnergyBurned": 1654.0269999999998,
    "distanceWalkingRunning": 6.42946434,
    "flightsClimbed": 28,
    "stepCount": 14346,
    "walkingSpeed": 2.8070447222222223
  },
  {
    "date": "2025-04-30",
    "activeEnergyBurned": 396.982,
    "basalEnergyBurned": 1748.682,
    "distanceWalkingRunning": 4.96704114,
    "flightsClimbed": 15,
    "stepCount": 10979,
    "walkingSpeed": 2.9163259999999998
  },
  {
    "date": "2025-05-01",
    "activeEnergyBurned": 307.836,
    "basalEnergyBurned": 1692.7319999999997,
    "distanceWalkingRunning": 3.558985216,
    "flightsClimbed": 20,
    "stepCount": 7811,
    "walkingSpeed": 2.86098358974359
  },
  {
    "date": "2025-05-02",
    "activeEnergyBurned": 203.44300000000004,
    "basalEnergyBurned": 1597.3169999999998,
    "distanceWalkingRunning": 2.4638109700000004,
    "flightsClimbed": 13,
    "stepCount": 6258,
    "walkingSpeed": 2.6829249999999996
  },
  {
    "date": "2025-05-03",
    "activeEnergyBurned": 508.397,
    "basalEnergyBurned": 1790.5359999999998,
    "distanceWalkingRunning": 6.81313267,
    "flightsClimbed": 13,
    "stepCount": 15153,
    "walkingSpeed": 2.6509080246913577
  },
  {
    "date": "2025-05-04",
    "activeEnergyBurned": 413.955,
    "basalEnergyBurned": 1601.0769999999998,
    "distanceWalkingRunning": 4.943500929999999,
    "flightsClimbed": 22,
    "stepCount": 11248,
    "walkingSpeed": 2.7633618333333336
  },
  {
    "date": "2025-05-05",
    "activeEnergyBurned": 338.654,
    "basalEnergyBurned": 1771.8479999999997,
    "distanceWalkingRunning": 4.1585510569999995,
    "flightsClimbed": 13,
    "stepCount": 9267,
    "walkingSpeed": 2.7470825
  },
  {
    "date": "2025-05-06",
    "activeEnergyBurned": 291.36800000000005,
    "basalEnergyBurned": 1650.5449999999998,
    "distanceWalkingRunning": 3.3483733599999996,
    "flightsClimbed": 19,
    "stepCount": 8409,
    "walkingSpeed": 2.5935034000000003
  },
  {
    "date": "2025-05-07",
    "activeEnergyBurned": 372.9849999999999,
    "basalEnergyBurned": 1737.5349999999999,
    "distanceWalkingRunning": 4.82055733,
    "flightsClimbed": 16,
    "stepCount": 11244,
    "walkingSpeed": 2.6452723728813563
  },
  {
    "date": "2025-05-08",
    "activeEnergyBurned": 200.00300000000001,
    "basalEnergyBurned": 1514.3149999999996,
    "distanceWalkingRunning": 2.3124100999999997,
    "flightsClimbed": 14,
    "stepCount": 5494,
    "walkingSpeed": 2.8028823333333324
  },
  {
    "date": "2025-05-09",
    "activeEnergyBurned": 351.735,
    "basalEnergyBurned": 1833.3939999999996,
    "distanceWalkingRunning": 4.29280715,
    "flightsClimbed": 14,
    "stepCount": 10118,
    "walkingSpeed": 3.010588292682927
  },
  {
    "date": "2025-05-10",
    "activeEnergyBurned": 360.572,
    "basalEnergyBurned": 1720.8059999999998,
    "distanceWalkingRunning": 4.32552044,
    "flightsClimbed": 17,
    "stepCount": 8874,
    "walkingSpeed": 2.8280042307692312
  },
  {
    "date": "2025-05-11",
    "activeEnergyBurned": 248.19699999999997,
    "basalEnergyBurned": 1514.8419999999996,
    "distanceWalkingRunning": 3.29012026,
    "flightsClimbed": 11,
    "stepCount": 7429,
    "walkingSpeed": 2.7480934328358213
  },
  {
    "date": "2025-05-12",
    "activeEnergyBurned": 230.496,
    "basalEnergyBurned": 1604.607,
    "distanceWalkingRunning": 2.6927077400000003,
    "flightsClimbed": 16,
    "stepCount": 6107,
    "walkingSpeed": 2.885648275862069
  },
  {
    "date": "2025-05-13",
    "activeEnergyBurned": 538.726,
    "basalEnergyBurned": 1819.4059999999997,
    "distanceWalkingRunning": 6.421552980000001,
    "flightsClimbed": 32,
    "stepCount": 14958,
    "walkingSpeed": 2.79007
  },
  {
    "date": "2025-05-14",
    "activeEnergyBurned": 230.85399999999998,
    "basalEnergyBurned": 1646.0059999999999,
    "distanceWalkingRunning": 3.035850254,
    "flightsClimbed": 12,
    "stepCount": 7261,
    "walkingSpeed": 2.57575
  },
  {
    "date": "2025-05-15",
    "activeEnergyBurned": 306.131,
    "basalEnergyBurned": 1783.2969999999998,
    "distanceWalkingRunning": 4.136226870000001,
    "flightsClimbed": 22,
    "stepCount": 9764,
    "walkingSpeed": 2.3477171428571433
  },
  {
    "date": "2025-05-16",
    "activeEnergyBurned": 258.41099999999994,
    "basalEnergyBurned": 1688.1259999999997,
    "distanceWalkingRunning": 4.257682270000001,
    "flightsClimbed": 10,
    "stepCount": 10705,
    "walkingSpeed": 2.7105946511627907
  },
  {
    "date": "2025-05-17",
    "activeEnergyBurned": 78.19900000000001,
    "basalEnergyBurned": 1664.5769999999998,
    "distanceWalkingRunning": 1.6047283789999998,
    "flightsClimbed": 2,
    "stepCount": 4352,
    "walkingSpeed": 2.356239791666667
  },
  {
    "date": "2025-05-18",
    "activeEnergyBurned": 167.236,
    "basalEnergyBurned": 1704.2229999999997,
    "distanceWalkingRunning": 2.8411041699999995,
    "flightsClimbed": 6,
    "stepCount": 7177,
    "walkingSpeed": 2.3797563461538465
  },
  {
    "date": "2025-05-19",
    "activeEnergyBurned": 52.208,
    "basalEnergyBurned": 1655.018,
    "distanceWalkingRunning": 1.07068598,
    "flightsClimbed": 4,
    "stepCount": 2873,
    "walkingSpeed": 2.3208214285714286
  },
  {
    "date": "2025-05-20",
    "activeEnergyBurned": 91.25100000000002,
    "basalEnergyBurned": 1658.679,
    "distanceWalkingRunning": 1.8449364520000004,
    "flightsClimbed": 3,
    "stepCount": 4736,
    "walkingSpeed": 2.4668013793103443
  },
  {
    "date": "2025-05-21",
    "activeEnergyBurned": 139.29600000000002,
    "basalEnergyBurned": 1658.355,
    "distanceWalkingRunning": 2.452962904,
    "flightsClimbed": 2,
    "stepCount": 6194,
    "walkingSpeed": 2.48691425
  },
  {
    "date": "2025-05-22",
    "activeEnergyBurned": 56.471,
    "basalEnergyBurned": 1671.4450000000002,
    "distanceWalkingRunning": 1.26134531,
    "flightsClimbed": 3,
    "stepCount": 3199,
    "walkingSpeed": 2.3183616000000002
  },
  {
    "date": "2025-05-23",
    "activeEnergyBurned": 379.179,
    "basalEnergyBurned": 1671.488,
    "distanceWalkingRunning": 4.797243449999999,
    "flightsClimbed": 27,
    "stepCount": 11578,
    "walkingSpeed": 2.459677234042553
  },
  {
    "date": "2025-05-24",
    "activeEnergyBurned": 420.153,
    "basalEnergyBurned": 1742.707,
    "distanceWalkingRunning": 5.77712568,
    "flightsClimbed": 16,
    "stepCount": 14047,
    "walkingSpeed": 2.5414338775510203
  },
  {
    "date": "2025-05-25",
    "activeEnergyBurned": 265.721,
    "basalEnergyBurned": 1665.113,
    "distanceWalkingRunning": 3.9774854380000004,
    "flightsClimbed": 10,
    "stepCount": 9933,
    "walkingSpeed": 2.477981962616823
  },
  {
    "date": "2025-05-26",
    "activeEnergyBurned": 72.60699999999999,
    "basalEnergyBurned": 1635.9189999999999,
    "distanceWalkingRunning": 1.142403,
    "flightsClimbed": 13,
    "stepCount": 2864,
    "walkingSpeed": 2.299439705882353
  },
  {
    "date": "2025-05-27",
    "activeEnergyBurned": 149.72,
    "basalEnergyBurned": 1694.808,
    "distanceWalkingRunning": 2.3555245200000003,
    "flightsClimbed": 14,
    "stepCount": 5191,
    "walkingSpeed": 2.365217755102041
  },
  {
    "date": "2025-05-28",
    "activeEnergyBurned": 187.849,
    "basalEnergyBurned": 1668.984,
    "distanceWalkingRunning": 2.83846812,
    "flightsClimbed": 4,
    "stepCount": 6365,
    "walkingSpeed": 2.5957978723404254
  },
  {
    "date": "2025-05-29",
    "activeEnergyBurned": 456.43000000000006,
    "basalEnergyBurned": 1708.372,
    "distanceWalkingRunning": 7.53461598,
    "flightsClimbed": 4,
    "stepCount": 17807,
    "walkingSpeed": 2.4821903614457828
  },
  {
    "date": "2025-05-30",
    "activeEnergyBurned": 454.23400000000004,
    "basalEnergyBurned": 1700.3519999999999,
    "distanceWalkingRunning": 7.41531231,
    "flightsClimbed": 7,
    "stepCount": 19240,
    "walkingSpeed": 2.5025976106194694
  },
  {
    "date": "2025-05-31",
    "activeEnergyBurned": 656.2669999999999,
    "basalEnergyBurned": 1725.9859999999999,
    "distanceWalkingRunning": 9.791188029999999,
    "flightsClimbed": 38,
    "stepCount": 25669,
    "walkingSpeed": 2.508542567567568
  },
  {
    "date": "2025-06-01",
    "activeEnergyBurned": 170.78700000000003,
    "basalEnergyBurned": 1664.2639999999997,
    "distanceWalkingRunning": 3.2134434600000006,
    "stepCount": 8618,
    "walkingSpeed": 2.2694123493975904
  },
  {
    "date": "2025-06-02",
    "activeEnergyBurned": 208.76400000000004,
    "basalEnergyBurned": 1689.46,
    "distanceWalkingRunning": 3.3309949,
    "flightsClimbed": 6,
    "stepCount": 8656,
    "walkingSpeed": 2.438667090909091
  },
  {
    "date": "2025-06-03",
    "activeEnergyBurned": 422.25100000000003,
    "basalEnergyBurned": 1703.4329999999998,
    "distanceWalkingRunning": 7.2150828449999995,
    "flightsClimbed": 5,
    "stepCount": 19344,
    "walkingSpeed": 2.391973461538462
  },
  {
    "date": "2025-06-04",
    "activeEnergyBurned": 499.53,
    "basalEnergyBurned": 1703.3839999999998,
    "distanceWalkingRunning": 7.068883820000001,
    "flightsClimbed": 21,
    "stepCount": 17971,
    "walkingSpeed": 2.434
  },
  {
    "date": "2025-06-05",
    "activeEnergyBurned": 317.411,
    "basalEnergyBurned": 1616.382,
    "distanceWalkingRunning": 3.9148113299999996,
    "flightsClimbed": 27,
    "stepCount": 10139,
    "walkingSpeed": 2.318686181818182
  },
  {
    "date": "2025-06-06",
    "activeEnergyBurned": 101.929,
    "basalEnergyBurned": 1112.3529999999998,
    "distanceWalkingRunning": 1.641146615,
    "stepCount": 4032,
    "walkingSpeed": 2.5319325
  },
  {
    "date": "2025-06-07",
    "activeEnergyBurned": 21.658,
    "basalEnergyBurned": 2278.9310000000005,
    "distanceWalkingRunning": 0.569082902,
    "stepCount": 1508,
    "walkingSpeed": 2.1288191666666667
  },
  {
    "date": "2025-06-08",
    "activeEnergyBurned": 106.607,
    "basalEnergyBurned": 1665.4819999999997,
    "distanceWalkingRunning": 2.1863442,
    "stepCount": 5823,
    "walkingSpeed": 2.585259285714286
  },
  {
    "date": "2025-06-09",
    "activeEnergyBurned": 129.893,
    "basalEnergyBurned": 1679.271,
    "distanceWalkingRunning": 2.2498690999999997,
    "stepCount": 5735,
    "walkingSpeed": 2.2253211538461537
  },
  {
    "date": "2025-06-10",
    "activeEnergyBurned": 161.33200000000002,
    "basalEnergyBurned": 1640.51,
    "distanceWalkingRunning": 2.953508169999999,
    "stepCount": 7493,
    "walkingSpeed": 2.7569100000000004
  },
  {
    "date": "2025-06-11",
    "activeEnergyBurned": 157.047,
    "basalEnergyBurned": 1671.6509999999996,
    "distanceWalkingRunning": 2.9938044300000004,
    "flightsClimbed": 1,
    "stepCount": 7234,
    "walkingSpeed": 2.357654310344828
  },
  {
    "date": "2025-06-12",
    "activeEnergyBurned": 296.415,
    "basalEnergyBurned": 1720.2819999999997,
    "distanceWalkingRunning": 5.11628657,
    "flightsClimbed": 1,
    "stepCount": 13725,
    "walkingSpeed": 2.4319567272727274
  },
  {
    "date": "2025-06-13",
    "activeEnergyBurned": 483.78099999999995,
    "basalEnergyBurned": 1698.126,
    "distanceWalkingRunning": 7.942456,
    "flightsClimbed": 4,
    "stepCount": 18239,
    "walkingSpeed": 2.5463504580152674
  },
  {
    "date": "2025-06-14",
    "activeEnergyBurned": 518.712,
    "basalEnergyBurned": 1698.2849999999996,
    "distanceWalkingRunning": 8.675071652,
    "flightsClimbed": 2,
    "stepCount": 20472,
    "walkingSpeed": 2.533101989795919
  },
  {
    "date": "2025-06-15",
    "activeEnergyBurned": 158.09700000000004,
    "basalEnergyBurned": 1672.5819999999997,
    "distanceWalkingRunning": 2.3759625600000005,
    "flightsClimbed": 3,
    "stepCount": 5597,
    "walkingSpeed": 2.6823898765432097
  },
  {
    "date": "2025-06-16",
    "activeEnergyBurned": 51.471,
    "basalEnergyBurned": 1521.148,
    "distanceWalkingRunning": 0.849189894,
    "flightsClimbed": 3,
    "stepCount": 1699,
    "walkingSpeed": 2.4001011764705886
  },
  {
    "date": "2025-06-17",
    "activeEnergyBurned": 95.51100000000001,
    "basalEnergyBurned": 1669.985,
    "distanceWalkingRunning": 1.5756923999999997,
    "flightsClimbed": 8,
    "stepCount": 3400,
    "walkingSpeed": 2.5948464
  },
  {
    "date": "2025-06-18",
    "activeEnergyBurned": 105.441,
    "basalEnergyBurned": 1782.8759999999995,
    "distanceWalkingRunning": 1.6293263100000002,
    "flightsClimbed": 8,
    "stepCount": 3564,
    "walkingSpeed": 2.430271428571429
  },
  {
    "date": "2025-06-19",
    "activeEnergyBurned": 98.57300000000001,
    "basalEnergyBurned": 1622.437,
    "distanceWalkingRunning": 1.6115481999999999,
    "flightsClimbed": 9,
    "stepCount": 3635,
    "walkingSpeed": 2.6387566666666666
  },
  {
    "date": "2025-06-20",
    "activeEnergyBurned": 40.969,
    "basalEnergyBurned": 1651.8899999999999,
    "distanceWalkingRunning": 0.77866303,
    "flightsClimbed": 5,
    "stepCount": 1916,
    "walkingSpeed": 2.119498125
  },
  {
    "date": "2025-06-21",
    "activeEnergyBurned": 167.54,
    "basalEnergyBurned": 1630.4299999999994,
    "distanceWalkingRunning": 2.4745365300000004,
    "flightsClimbed": 6,
    "stepCount": 5008,
    "walkingSpeed": 2.463185714285714
  },
  {
    "date": "2025-06-22",
    "activeEnergyBurned": 120.75200000000001,
    "basalEnergyBurned": 1736.1709999999998,
    "distanceWalkingRunning": 1.9347675899999999,
    "flightsClimbed": 7,
    "stepCount": 4046,
    "walkingSpeed": 2.578277037037037
  },
  {
    "date": "2025-06-23",
    "activeEnergyBurned": 73.77199999999998,
    "basalEnergyBurned": 1584.5659999999996,
    "distanceWalkingRunning": 1.19875615,
    "flightsClimbed": 8,
    "stepCount": 2883,
    "walkingSpeed": 2.360828461538462
  },
  {
    "date": "2025-06-24",
    "activeEnergyBurned": 39.733,
    "basalEnergyBurned": 1697.915,
    "distanceWalkingRunning": 0.6638904499999999,
    "flightsClimbed": 4,
    "stepCount": 1463,
    "walkingSpeed": 2.4989757142857143
  },
  {
    "date": "2025-06-25",
    "activeEnergyBurned": 103.725,
    "basalEnergyBurned": 1655.934,
    "distanceWalkingRunning": 1.6564910599999998,
    "flightsClimbed": 13,
    "stepCount": 3694,
    "walkingSpeed": 2.4031085714285716
  },
  {
    "date": "2025-06-26",
    "activeEnergyBurned": 41.823999999999984,
    "basalEnergyBurned": 1586.561,
    "distanceWalkingRunning": 0.6470459399999999,
    "flightsClimbed": 5,
    "stepCount": 1531,
    "walkingSpeed": 2.399115
  },
  {
    "date": "2025-06-27",
    "activeEnergyBurned": 129.17899999999997,
    "basalEnergyBurned": 1713.8260000000002,
    "distanceWalkingRunning": 2.03080023,
    "flightsClimbed": 3,
    "stepCount": 4018,
    "walkingSpeed": 2.4305173076923077
  },
  {
    "date": "2025-06-28",
    "activeEnergyBurned": 105.514,
    "basalEnergyBurned": 1623.0989999999997,
    "distanceWalkingRunning": 1.86873008,
    "flightsClimbed": 2,
    "stepCount": 4695,
    "walkingSpeed": 2.4823605714285715
  },
  {
    "date": "2025-06-29",
    "activeEnergyBurned": 50.28099999999999,
    "basalEnergyBurned": 1701.134,
    "distanceWalkingRunning": 0.8504270999999998,
    "flightsClimbed": 7,
    "stepCount": 1925,
    "walkingSpeed": 2.568002
  },
  {
    "date": "2025-06-30",
    "activeEnergyBurned": 32.961,
    "basalEnergyBurned": 1489.636,
    "distanceWalkingRunning": 0.61663577,
    "flightsClimbed": 4,
    "stepCount": 1478,
    "walkingSpeed": 2.6880550000000003
  },
  {
    "date": "2025-07-01",
    "activeEnergyBurned": 72.72500000000001,
    "basalEnergyBurned": 1827.9819999999997,
    "distanceWalkingRunning": 1.06471688,
    "flightsClimbed": 7,
    "stepCount": 2406,
    "walkingSpeed": 2.6004408333333338
  },
  {
    "date": "2025-07-02",
    "activeEnergyBurned": 108.03300000000002,
    "basalEnergyBurned": 1675.072,
    "distanceWalkingRunning": 1.62227981,
    "flightsClimbed": 5,
    "stepCount": 3146,
    "walkingSpeed": 2.6379864285714283
  },
  {
    "date": "2025-07-03",
    "activeEnergyBurned": 90.63499999999999,
    "basalEnergyBurned": 1593.9599999999998,
    "distanceWalkingRunning": 1.4839976,
    "flightsClimbed": 7,
    "stepCount": 3167,
    "walkingSpeed": 2.223516
  },
  {
    "date": "2025-07-04",
    "activeEnergyBurned": 37.903,
    "basalEnergyBurned": 1608.991,
    "distanceWalkingRunning": 0.8617939219999999,
    "flightsClimbed": 4,
    "stepCount": 2261,
    "walkingSpeed": 2.36121
  },
  {
    "date": "2025-07-05",
    "activeEnergyBurned": 124.542,
    "basalEnergyBurned": 1750.6319999999998,
    "distanceWalkingRunning": 1.80704693,
    "flightsClimbed": 9,
    "stepCount": 3967,
    "walkingSpeed": 2.479610303030303
  },
  {
    "date": "2025-07-06",
    "activeEnergyBurned": 70.89100000000002,
    "basalEnergyBurned": 1655.2919999999997,
    "distanceWalkingRunning": 1.1577253299999999,
    "flightsClimbed": 4,
    "stepCount": 2259,
    "walkingSpeed": 2.4854833333333333
  },
  {
    "date": "2025-07-07",
    "activeEnergyBurned": 60.583,
    "basalEnergyBurned": 1635.1270000000002,
    "distanceWalkingRunning": 0.94131659,
    "flightsClimbed": 5,
    "stepCount": 2001,
    "walkingSpeed": 2.6768666666666667
  },
  {
    "date": "2025-07-08",
    "activeEnergyBurned": 51.232000000000006,
    "basalEnergyBurned": 1647.3329999999999,
    "distanceWalkingRunning": 0.86089732,
    "flightsClimbed": 7,
    "stepCount": 2075,
    "walkingSpeed": 2.3144826666666662
  },
  {
    "date": "2025-07-09",
    "activeEnergyBurned": 80.22200000000001,
    "basalEnergyBurned": 1656.4569999999997,
    "distanceWalkingRunning": 1.3124731499999998,
    "flightsClimbed": 4,
    "stepCount": 2671,
    "walkingSpeed": 2.2257522222222224
  },
  {
    "date": "2025-07-10",
    "activeEnergyBurned": 84.87700000000001,
    "basalEnergyBurned": 1437.677,
    "distanceWalkingRunning": 1.28563578,
    "flightsClimbed": 2,
    "stepCount": 2510,
    "walkingSpeed": 2.396717857142857
  },
  {
    "date": "2025-07-11",
    "activeEnergyBurned": 54.556,
    "basalEnergyBurned": 1909.344,
    "distanceWalkingRunning": 0.9158874979999999,
    "flightsClimbed": 6,
    "stepCount": 2086,
    "walkingSpeed": 2.2120811111111114
  },
  {
    "date": "2025-07-12",
    "activeEnergyBurned": 221.758,
    "basalEnergyBurned": 1546.946,
    "distanceWalkingRunning": 3.6147006900000003,
    "flightsClimbed": 4,
    "stepCount": 8525,
    "walkingSpeed": 2.3968221311475415
  },
  {
    "date": "2025-07-13",
    "activeEnergyBurned": 49.770999999999994,
    "basalEnergyBurned": 1784.2439999999997,
    "distanceWalkingRunning": 0.8155163900000002,
    "flightsClimbed": 3,
    "stepCount": 1703,
    "walkingSpeed": 2.3487842857142858
  },
  {
    "date": "2025-07-14",
    "activeEnergyBurned": 54.36899999999999,
    "basalEnergyBurned": 1606.5629999999996,
    "distanceWalkingRunning": 0.8007989600000001,
    "flightsClimbed": 3,
    "stepCount": 1698,
    "walkingSpeed": 2.4805144444444442
  },
  {
    "date": "2025-07-15",
    "activeEnergyBurned": 117.886,
    "basalEnergyBurned": 1673.6839999999997,
    "distanceWalkingRunning": 1.809671,
    "flightsClimbed": 3,
    "stepCount": 3427,
    "walkingSpeed": 2.6002152
  },
  {
    "date": "2025-07-16",
    "activeEnergyBurned": 137.899,
    "basalEnergyBurned": 1629.0269999999994,
    "distanceWalkingRunning": 1.88395424,
    "flightsClimbed": 6,
    "stepCount": 3338,
    "walkingSpeed": 2.3368540000000007
  },
  {
    "date": "2025-07-17",
    "activeEnergyBurned": 123.21099999999998,
    "basalEnergyBurned": 1684.4959999999996,
    "distanceWalkingRunning": 1.5691965019999998,
    "flightsClimbed": 3,
    "stepCount": 2551,
    "walkingSpeed": 2.632128333333333
  },
  {
    "date": "2025-07-18",
    "activeEnergyBurned": 93.951,
    "basalEnergyBurned": 1706.1139999999998,
    "distanceWalkingRunning": 1.3748158000000001,
    "flightsClimbed": 8,
    "stepCount": 2940,
    "walkingSpeed": 2.4189422727272727
  },
  {
    "date": "2025-07-19",
    "activeEnergyBurned": 87.90299999999999,
    "basalEnergyBurned": 1578.815,
    "distanceWalkingRunning": 1.454029856,
    "flightsClimbed": 4,
    "stepCount": 3118,
    "walkingSpeed": 2.238969090909091
  },
  {
    "date": "2025-07-20",
    "activeEnergyBurned": 106.632,
    "basalEnergyBurned": 1694.0269999999996,
    "distanceWalkingRunning": 1.8313859399999999,
    "flightsClimbed": 6,
    "stepCount": 4360,
    "walkingSpeed": 2.4152341176470586
  },
  {
    "date": "2025-07-21",
    "activeEnergyBurned": 43.906000000000006,
    "basalEnergyBurned": 1596.3349999999998,
    "distanceWalkingRunning": 0.7230249,
    "flightsClimbed": 6,
    "stepCount": 1490,
    "walkingSpeed": 2.2797299999999994
  },
  {
    "date": "2025-07-22",
    "activeEnergyBurned": 50.643000000000015,
    "basalEnergyBurned": 1674.745,
    "distanceWalkingRunning": 1.0030297099999999,
    "flightsClimbed": 4,
    "stepCount": 2529,
    "walkingSpeed": 2.385134375
  },
  {
    "date": "2025-07-23",
    "activeEnergyBurned": 58.872,
    "basalEnergyBurned": 1734.6179999999997,
    "distanceWalkingRunning": 1.1293862000000001,
    "flightsClimbed": 5,
    "stepCount": 2951,
    "walkingSpeed": 2.2379536363636365
  },
  {
    "date": "2025-07-24",
    "activeEnergyBurned": 27.073,
    "basalEnergyBurned": 1610.8259999999998,
    "distanceWalkingRunning": 0.5533187700000001,
    "flightsClimbed": 6,
    "stepCount": 1390,
    "walkingSpeed": 2.3537544444444447
  },
  {
    "date": "2025-07-25",
    "activeEnergyBurned": 55.472,
    "basalEnergyBurned": 1708.7669999999996,
    "distanceWalkingRunning": 0.98012184,
    "flightsClimbed": 5,
    "stepCount": 2224,
    "walkingSpeed": 2.348784
  },
  {
    "date": "2025-07-26",
    "activeEnergyBurned": 132.881,
    "basalEnergyBurned": 1590.2419999999997,
    "distanceWalkingRunning": 2.16534319,
    "flightsClimbed": 9,
    "stepCount": 5295,
    "walkingSpeed": 2.792049736842106
  },
  {
    "date": "2025-07-27",
    "activeEnergyBurned": 108.198,
    "basalEnergyBurned": 1727.7129999999997,
    "distanceWalkingRunning": 2.060433559,
    "flightsClimbed": 7,
    "stepCount": 5462,
    "walkingSpeed": 2.325321707317073
  },
  {
    "date": "2025-07-28",
    "activeEnergyBurned": 115.132,
    "basalEnergyBurned": 1575.4369999999997,
    "distanceWalkingRunning": 2.0934948799999997,
    "flightsClimbed": 4,
    "stepCount": 5550,
    "walkingSpeed": 2.4071378260869567
  },
  {
    "date": "2025-07-29",
    "activeEnergyBurned": 163.55,
    "basalEnergyBurned": 1642.8549999999998,
    "distanceWalkingRunning": 2.69293716,
    "flightsClimbed": 14,
    "stepCount": 6208,
    "walkingSpeed": 2.491844651162791
  },
  {
    "date": "2025-07-30",
    "activeEnergyBurned": 42.703,
    "basalEnergyBurned": 1673.311,
    "distanceWalkingRunning": 0.58835379,
    "flightsClimbed": 9,
    "stepCount": 1333,
    "walkingSpeed": 2.154916666666667
  },
  {
    "date": "2025-07-31",
    "activeEnergyBurned": 55.677,
    "basalEnergyBurned": 1566.0449999999996,
    "distanceWalkingRunning": 1.1143334999999999,
    "flightsClimbed": 3,
    "stepCount": 2945,
    "walkingSpeed": 2.518151428571428
  },
  {
    "date": "2025-08-01",
    "activeEnergyBurned": 104.19600000000001,
    "basalEnergyBurned": 1820.0419999999995,
    "distanceWalkingRunning": 1.8094906899999998,
    "flightsClimbed": 13,
    "stepCount": 4552,
    "walkingSpeed": 3.0124066666666667
  },
  {
    "date": "2025-08-02",
    "activeEnergyBurned": 36.544000000000004,
    "basalEnergyBurned": 1691.738,
    "distanceWalkingRunning": 0.48095381,
    "flightsClimbed": 15,
    "stepCount": 1207,
    "walkingSpeed": 2.2614703225806454
  },
  {
    "date": "2025-08-03",
    "activeEnergyBurned": 85.419,
    "basalEnergyBurned": 1507.2369999999994,
    "distanceWalkingRunning": 1.5938281010000002,
    "flightsClimbed": 10,
    "stepCount": 4112,
    "walkingSpeed": 2.3458964516129033
  },
  {
    "date": "2025-08-04",
    "activeEnergyBurned": 223.402,
    "basalEnergyBurned": 1820.1619999999998,
    "distanceWalkingRunning": 3.4592688800000007,
    "flightsClimbed": 7,
    "stepCount": 8348,
    "walkingSpeed": 2.697203636363637
  },
  {
    "date": "2025-08-05",
    "activeEnergyBurned": 154.717,
    "basalEnergyBurned": 1654.6899999999998,
    "distanceWalkingRunning": 2.2357727300000003,
    "flightsClimbed": 8,
    "stepCount": 4064,
    "walkingSpeed": 2.439981346153846
  },
  {
    "date": "2025-08-06",
    "activeEnergyBurned": 72.339,
    "basalEnergyBurned": 1668.887,
    "distanceWalkingRunning": 1.14476704,
    "flightsClimbed": 5,
    "stepCount": 2354,
    "walkingSpeed": 2.430805
  },
  {
    "date": "2025-08-07",
    "activeEnergyBurned": 95.00199999999998,
    "basalEnergyBurned": 1605.886,
    "distanceWalkingRunning": 1.4491420320000001,
    "flightsClimbed": 11,
    "stepCount": 3267,
    "walkingSpeed": 2.5044732
  },
  {
    "date": "2025-08-08",
    "activeEnergyBurned": 55.574,
    "basalEnergyBurned": 1678.7579999999996,
    "distanceWalkingRunning": 1.17231822,
    "flightsClimbed": 5,
    "stepCount": 3078,
    "walkingSpeed": 2.327135161290323
  },
  {
    "date": "2025-08-09",
    "activeEnergyBurned": 156.28900000000002,
    "basalEnergyBurned": 1472.326,
    "distanceWalkingRunning": 3.06837583,
    "flightsClimbed": 1,
    "stepCount": 7866,
    "walkingSpeed": 2.460063417721519
  },
  {
    "date": "2025-08-10",
    "activeEnergyBurned": 329.3299999999999,
    "basalEnergyBurned": 1651.3039999999999,
    "distanceWalkingRunning": 4.974611399999999,
    "flightsClimbed": 11,
    "stepCount": 11332,
    "walkingSpeed": 2.5061675
  },
  {
    "date": "2025-08-11",
    "activeEnergyBurned": 330.661,
    "basalEnergyBurned": 1888.4929999999997,
    "distanceWalkingRunning": 4.750651175,
    "flightsClimbed": 8,
    "stepCount": 10499,
    "walkingSpeed": 2.659048831168831
  },
  {
    "date": "2025-08-12",
    "activeEnergyBurned": 324.75600000000003,
    "basalEnergyBurned": 1345.364,
    "distanceWalkingRunning": 4.441066491999999,
    "flightsClimbed": 14,
    "stepCount": 10102,
    "walkingSpeed": 2.74799
  },
  {
    "date": "2025-08-13",
    "activeEnergyBurned": 280.22,
    "basalEnergyBurned": 1852.1229999999998,
    "distanceWalkingRunning": 3.920371831,
    "flightsClimbed": 10,
    "stepCount": 9146,
    "walkingSpeed": 2.6894081818181816
  },
  {
    "date": "2025-08-14",
    "activeEnergyBurned": 3.535,
    "basalEnergyBurned": 1690.1589999999997,
    "distanceWalkingRunning": 0.11973203,
    "stepCount": 314,
    "walkingSpeed": 1.92377
  },
  {
    "date": "2025-08-15",
    "activeEnergyBurned": 292.56500000000005,
    "basalEnergyBurned": 1479.35,
    "distanceWalkingRunning": 4.29669441,
    "flightsClimbed": 3,
    "stepCount": 9723,
    "walkingSpeed": 2.7617819402985075
  },
  {
    "date": "2025-08-16",
    "activeEnergyBurned": 175.309,
    "basalEnergyBurned": 1858.7539999999997,
    "distanceWalkingRunning": 2.4600368799999996,
    "flightsClimbed": 4,
    "stepCount": 6026,
    "walkingSpeed": 2.6186590322580643
  },
  {
    "date": "2025-08-17",
    "activeEnergyBurned": 44.992999999999995,
    "basalEnergyBurned": 1830.4479999999999,
    "distanceWalkingRunning": 0.66939279,
    "stepCount": 1479,
    "walkingSpeed": 2.49138625
  },
  {
    "date": "2025-08-18",
    "activeEnergyBurned": 332.64400000000006,
    "basalEnergyBurned": 1647.99,
    "distanceWalkingRunning": 4.67247817,
    "flightsClimbed": 9,
    "stepCount": 10806,
    "walkingSpeed": 2.9026054838709676
  },
  {
    "date": "2025-08-19",
    "activeEnergyBurned": 159.00200000000004,
    "basalEnergyBurned": 1474.8819999999998,
    "distanceWalkingRunning": 2.187309105,
    "flightsClimbed": 4,
    "stepCount": 4611,
    "walkingSpeed": 2.748635833333333
  },
  {
    "date": "2025-08-20",
    "activeEnergyBurned": 78.40700000000001,
    "basalEnergyBurned": 1842.7919999999995,
    "distanceWalkingRunning": 1.34003815,
    "flightsClimbed": 1,
    "stepCount": 3266,
    "walkingSpeed": 2.5285670370370372
  },
  {
    "date": "2025-08-21",
    "activeEnergyBurned": 210.631,
    "basalEnergyBurned": 1264.082,
    "distanceWalkingRunning": 2.869898899,
    "flightsClimbed": 7,
    "stepCount": 6942,
    "walkingSpeed": 2.593032162162162
  },
  {
    "date": "2025-08-22",
    "activeEnergyBurned": 310.707,
    "basalEnergyBurned": 1934.3929999999996,
    "distanceWalkingRunning": 4.091281330000001,
    "flightsClimbed": 9,
    "stepCount": 8696,
    "walkingSpeed": 2.6632205660377357
  },
  {
    "date": "2025-08-23",
    "activeEnergyBurned": 10.136,
    "basalEnergyBurned": 1629.2710000000002,
    "distanceWalkingRunning": 0.28140044000000003,
    "stepCount": 760,
    "walkingSpeed": 2.4382633333333334
  },
  {
    "date": "2025-08-24",
    "activeEnergyBurned": 6.541,
    "basalEnergyBurned": 1292.5349999999996,
    "distanceWalkingRunning": 0.13376891000000002,
    "stepCount": 284,
    "walkingSpeed": 2.0132433333333335
  },
  {
    "date": "2025-08-25",
    "activeEnergyBurned": 399.851,
    "basalEnergyBurned": 2065.6329999999994,
    "distanceWalkingRunning": 4.970713248999999,
    "flightsClimbed": 17,
    "stepCount": 11521,
    "walkingSpeed": 2.8606458823529413
  },
  {
    "date": "2025-08-26",
    "activeEnergyBurned": 513.685,
    "basalEnergyBurned": 1862.074,
    "distanceWalkingRunning": 7.11701661,
    "flightsClimbed": 11,
    "stepCount": 15116,
    "walkingSpeed": 2.8490209890109894
  },
  {
    "date": "2025-08-27",
    "activeEnergyBurned": 481.73999999999995,
    "basalEnergyBurned": 1699.3919999999998,
    "distanceWalkingRunning": 6.30873498,
    "flightsClimbed": 17,
    "stepCount": 14136,
    "walkingSpeed": 2.91696525
  },
  {
    "date": "2025-08-28",
    "activeEnergyBurned": 238.883,
    "basalEnergyBurned": 1428.4629999999997,
    "distanceWalkingRunning": 3.38721722,
    "flightsClimbed": 2,
    "stepCount": 7343,
    "walkingSpeed": 3.003886190476191
  },
  {
    "date": "2025-08-29",
    "activeEnergyBurned": 147.027,
    "basalEnergyBurned": 1875.5929999999996,
    "distanceWalkingRunning": 2.04790948,
    "flightsClimbed": 6,
    "stepCount": 4290,
    "walkingSpeed": 2.8359370370370374
  },
  {
    "date": "2025-08-30",
    "activeEnergyBurned": 5.251,
    "basalEnergyBurned": 1559.079,
    "distanceWalkingRunning": 0.140075736,
    "stepCount": 337,
    "walkingSpeed": 2.72626875
  },
  {
    "date": "2025-08-31",
    "activeEnergyBurned": 6.772,
    "basalEnergyBurned": 1731.2929999999997,
    "distanceWalkingRunning": 0.20328771,
    "stepCount": 520
  },
  {
    "date": "2025-09-01",
    "activeEnergyBurned": 25.081999999999997,
    "basalEnergyBurned": 1669.2989999999995,
    "distanceWalkingRunning": 0.502478227,
    "stepCount": 1213,
    "walkingSpeed": 2.77753
  },
  {
    "date": "2025-09-02",
    "activeEnergyBurned": 258.55,
    "basalEnergyBurned": 1735.6979999999999,
    "distanceWalkingRunning": 3.5504956999999995,
    "flightsClimbed": 8,
    "stepCount": 7771,
    "walkingSpeed": 2.8073550000000003
  },
  {
    "date": "2025-09-03",
    "activeEnergyBurned": 247.38099999999997,
    "basalEnergyBurned": 1592.785,
    "distanceWalkingRunning": 3.45489281,
    "flightsClimbed": 6,
    "stepCount": 7428,
    "walkingSpeed": 2.8013317948717944
  },
  {
    "date": "2025-09-04",
    "activeEnergyBurned": 286.145,
    "basalEnergyBurned": 1746.3919999999998,
    "distanceWalkingRunning": 3.9429503799999996,
    "flightsClimbed": 10,
    "stepCount": 8749,
    "walkingSpeed": 2.809219
  },
  {
    "date": "2025-09-05",
    "activeEnergyBurned": 359.77500000000003,
    "basalEnergyBurned": 1456.5700000000002,
    "distanceWalkingRunning": 4.887476355,
    "flightsClimbed": 11,
    "stepCount": 10762,
    "walkingSpeed": 2.7844777272727272
  },
  {
    "date": "2025-09-06",
    "activeEnergyBurned": 33.086,
    "basalEnergyBurned": 1753.2209999999998,
    "distanceWalkingRunning": 0.31445729,
    "flightsClimbed": 5,
    "stepCount": 815,
    "walkingSpeed": 2.7055745
  },
  {
    "date": "2025-09-07",
    "activeEnergyBurned": 338.868,
    "basalEnergyBurned": 1619.8449999999998,
    "distanceWalkingRunning": 4.36325394,
    "flightsClimbed": 13,
    "stepCount": 9924,
    "walkingSpeed": 2.7896460416666664
  },
  {
    "date": "2025-09-08",
    "activeEnergyBurned": 484.647,
    "basalEnergyBurned": 1843.2139999999995,
    "distanceWalkingRunning": 6.542856019999999,
    "flightsClimbed": 18,
    "stepCount": 15171,
    "walkingSpeed": 2.86024049382716
  },
  {
    "date": "2025-09-09",
    "activeEnergyBurned": 232.296,
    "basalEnergyBurned": 1727.5739999999998,
    "distanceWalkingRunning": 3.30972819,
    "flightsClimbed": 6,
    "stepCount": 7327,
    "walkingSpeed": 2.8959717307692303
  },
  {
    "date": "2025-09-10",
    "activeEnergyBurned": 458.927,
    "basalEnergyBurned": 1697.9269999999997,
    "distanceWalkingRunning": 5.9667962999999995,
    "flightsClimbed": 14,
    "stepCount": 14066,
    "walkingSpeed": 2.859283928571428
  },
  {
    "date": "2025-09-11",
    "activeEnergyBurned": 248.894,
    "basalEnergyBurned": 1540.572,
    "distanceWalkingRunning": 3.40726297,
    "flightsClimbed": 7,
    "stepCount": 7540,
    "walkingSpeed": 2.8717730379746835
  },
  {
    "date": "2025-09-12",
    "activeEnergyBurned": 12.49,
    "basalEnergyBurned": 1613.83,
    "distanceWalkingRunning": 0.25842199000000005,
    "stepCount": 634
  },
  {
    "date": "2025-09-13",
    "activeEnergyBurned": 315.0470000000001,
    "basalEnergyBurned": 1780.2469999999996,
    "distanceWalkingRunning": 4.01922877,
    "flightsClimbed": 13,
    "stepCount": 8812,
    "walkingSpeed": 3.48962
  },
  {
    "date": "2025-09-14",
    "activeEnergyBurned": 127.36800000000001,
    "basalEnergyBurned": 1499.451,
    "distanceWalkingRunning": 1.75804982,
    "flightsClimbed": 4,
    "stepCount": 4091,
    "walkingSpeed": 2.891693918918919
  },
  {
    "date": "2025-09-15",
    "activeEnergyBurned": 530.194,
    "basalEnergyBurned": 1777.837,
    "distanceWalkingRunning": 6.67026285,
    "flightsClimbed": 23,
    "stepCount": 14176,
    "walkingSpeed": 3.003826226415095
  },
  {
    "date": "2025-09-16",
    "activeEnergyBurned": 189.007,
    "basalEnergyBurned": 1696.9299999999998,
    "distanceWalkingRunning": 2.6053376499999996,
    "flightsClimbed": 4,
    "stepCount": 5455,
    "walkingSpeed": 2.964899714285714
  },
  {
    "date": "2025-09-17",
    "activeEnergyBurned": 430.991,
    "basalEnergyBurned": 1792.6929999999995,
    "distanceWalkingRunning": 5.82042373,
    "flightsClimbed": 8,
    "stepCount": 13008,
    "walkingSpeed": 2.9974948484848487
  },
  {
    "date": "2025-09-18",
    "activeEnergyBurned": 338.794,
    "basalEnergyBurned": 1552.5839999999998,
    "distanceWalkingRunning": 4.46833628,
    "flightsClimbed": 11,
    "stepCount": 9576,
    "walkingSpeed": 3.0515879999999997
  },
  {
    "date": "2025-09-19",
    "activeEnergyBurned": 183.27100000000002,
    "basalEnergyBurned": 1622.433,
    "distanceWalkingRunning": 2.6999866200000002,
    "flightsClimbed": 5,
    "stepCount": 5698,
    "walkingSpeed": 2.7593543750000005
  },
  {
    "date": "2025-09-20",
    "activeEnergyBurned": 232.882,
    "basalEnergyBurned": 1646.366,
    "distanceWalkingRunning": 3.0328719,
    "flightsClimbed": 8,
    "stepCount": 7071,
    "walkingSpeed": 2.8465000000000003
  },
  {
    "date": "2025-09-21",
    "activeEnergyBurned": 39.754999999999995,
    "basalEnergyBurned": 1821.254,
    "distanceWalkingRunning": 0.75429894,
    "stepCount": 1651,
    "walkingSpeed": 2.860906515151515
  },
  {
    "date": "2025-09-22",
    "activeEnergyBurned": 536.903,
    "basalEnergyBurned": 1609.8499999999997,
    "distanceWalkingRunning": 7.199707809,
    "flightsClimbed": 22,
    "stepCount": 16514,
    "walkingSpeed": 2.876157575757576
  },
  {
    "date": "2025-09-23",
    "activeEnergyBurned": 168.16899999999998,
    "basalEnergyBurned": 1669.498,
    "distanceWalkingRunning": 2.431865794,
    "flightsClimbed": 3,
    "stepCount": 5443,
    "walkingSpeed": 2.874077586206896
  },
  {
    "date": "2025-09-24",
    "activeEnergyBurned": 365.793,
    "basalEnergyBurned": 1553.604,
    "distanceWalkingRunning": 4.961241422,
    "flightsClimbed": 9,
    "stepCount": 11124,
    "walkingSpeed": 2.973127857142857
  },
  {
    "date": "2025-09-25",
    "activeEnergyBurned": 256.164,
    "basalEnergyBurned": 1765.1799999999998,
    "distanceWalkingRunning": 3.42136249,
    "flightsClimbed": 9,
    "stepCount": 7346,
    "walkingSpeed": 2.7557616129032256
  },
  {
    "date": "2025-09-26",
    "activeEnergyBurned": 138.553,
    "basalEnergyBurned": 1711.702,
    "distanceWalkingRunning": 1.8391984419999998,
    "flightsClimbed": 5,
    "stepCount": 4114,
    "walkingSpeed": 2.748235
  },
  {
    "date": "2025-09-27",
    "activeEnergyBurned": 211.38700000000003,
    "basalEnergyBurned": 1606.8809999999999,
    "distanceWalkingRunning": 2.8575419199999996,
    "flightsClimbed": 7,
    "stepCount": 6176,
    "walkingSpeed": 2.8864189655172416
  },
  {
    "date": "2025-09-28",
    "activeEnergyBurned": 70.836,
    "basalEnergyBurned": 1726.9609999999998,
    "distanceWalkingRunning": 1.03684394,
    "flightsClimbed": 2,
    "stepCount": 2184,
    "walkingSpeed": 2.808597777777778
  },
  {
    "date": "2025-09-29",
    "activeEnergyBurned": 369.70400000000006,
    "basalEnergyBurned": 1604.494,
    "distanceWalkingRunning": 5.001297243,
    "flightsClimbed": 17,
    "stepCount": 11361,
    "walkingSpeed": 2.883345294117647
  },
  {
    "date": "2025-09-30",
    "activeEnergyBurned": 176.53199999999998,
    "basalEnergyBurned": 1736.4519999999998,
    "distanceWalkingRunning": 2.5927779089999996,
    "flightsClimbed": 3,
    "stepCount": 5782,
    "walkingSpeed": 2.915474358974359
  },
  {
    "date": "2025-10-01",
    "activeEnergyBurned": 341.597,
    "basalEnergyBurned": 1562.9199999999998,
    "distanceWalkingRunning": 4.5883487700000005,
    "flightsClimbed": 11,
    "stepCount": 10732,
    "walkingSpeed": 2.736628529411765
  },
  {
    "date": "2025-10-02",
    "activeEnergyBurned": 208.43599999999995,
    "basalEnergyBurned": 1767.6989999999998,
    "distanceWalkingRunning": 2.6932826,
    "flightsClimbed": 6,
    "stepCount": 5661,
    "walkingSpeed": 2.9597871428571425
  },
  {
    "date": "2025-10-03",
    "activeEnergyBurned": 445.58599999999996,
    "basalEnergyBurned": 1700.9659999999997,
    "distanceWalkingRunning": 5.85710328,
    "flightsClimbed": 8,
    "stepCount": 11542,
    "walkingSpeed": 2.9096748148148146
  },
  {
    "date": "2025-10-04",
    "activeEnergyBurned": 220.02499999999998,
    "basalEnergyBurned": 1804.9489999999998,
    "distanceWalkingRunning": 2.75658803,
    "flightsClimbed": 13,
    "stepCount": 6104,
    "walkingSpeed": 2.9248806153846156
  },
  {
    "date": "2025-10-05",
    "activeEnergyBurned": 223.69100000000003,
    "basalEnergyBurned": 1420.9959999999999,
    "distanceWalkingRunning": 2.93311226,
    "flightsClimbed": 7,
    "stepCount": 6492,
    "walkingSpeed": 2.9231175
  },
  {
    "date": "2025-10-06",
    "activeEnergyBurned": 600.141,
    "basalEnergyBurned": 1975.155,
    "distanceWalkingRunning": 7.7511115,
    "flightsClimbed": 18,
    "stepCount": 16778,
    "walkingSpeed": 2.9469570370370373
  },
  {
    "date": "2025-10-07",
    "activeEnergyBurned": 194.23299999999998,
    "basalEnergyBurned": 1574.7229999999997,
    "distanceWalkingRunning": 2.674506,
    "flightsClimbed": 8,
    "stepCount": 6427,
    "walkingSpeed": 2.8225093548387106
  },
  {
    "date": "2025-10-08",
    "activeEnergyBurned": 360.625,
    "basalEnergyBurned": 1566.5249999999999,
    "distanceWalkingRunning": 4.8762386499999995,
    "flightsClimbed": 16,
    "stepCount": 11104,
    "walkingSpeed": 2.846855189873418
  },
  {
    "date": "2025-10-09",
    "activeEnergyBurned": 286.861,
    "basalEnergyBurned": 1629.3849999999995,
    "distanceWalkingRunning": 3.7733051899999994,
    "flightsClimbed": 10,
    "stepCount": 8101,
    "walkingSpeed": 2.8248192982456137
  },
  {
    "date": "2025-10-10",
    "activeEnergyBurned": 75.547,
    "basalEnergyBurned": 1757.3429999999994,
    "distanceWalkingRunning": 1.03099829,
    "flightsClimbed": 4,
    "stepCount": 2452,
    "walkingSpeed": 2.6955090000000004
  },
  {
    "date": "2025-10-11",
    "activeEnergyBurned": 183.86899999999997,
    "basalEnergyBurned": 1819.1489999999997,
    "distanceWalkingRunning": 2.6588177199999996,
    "flightsClimbed": 5,
    "stepCount": 5637,
    "walkingSpeed": 2.7738010714285712
  },
  {
    "date": "2025-10-12",
    "activeEnergyBurned": 500.7120000000001,
    "basalEnergyBurned": 1596.4899999999996,
    "distanceWalkingRunning": 7.795702199999998,
    "flightsClimbed": 9,
    "stepCount": 18729,
    "walkingSpeed": 2.531732380952381
  },
  {
    "date": "2025-10-13",
    "activeEnergyBurned": 102.22400000000002,
    "basalEnergyBurned": 1733.8469999999998,
    "distanceWalkingRunning": 1.57564656,
    "flightsClimbed": 2,
    "stepCount": 3438,
    "walkingSpeed": 2.9957746153846156
  },
  {
    "date": "2025-10-14",
    "activeEnergyBurned": 117.112,
    "basalEnergyBurned": 1423.81,
    "distanceWalkingRunning": 1.4963276629999998,
    "flightsClimbed": 5,
    "stepCount": 3121,
    "walkingSpeed": 3.018465625
  },
  {
    "date": "2025-10-15",
    "activeEnergyBurned": 256.704,
    "basalEnergyBurned": 1629.654,
    "distanceWalkingRunning": 3.43745992,
    "flightsClimbed": 9,
    "stepCount": 7639,
    "walkingSpeed": 2.8119304545454544
  },
  {
    "date": "2025-10-16",
    "activeEnergyBurned": 113.298,
    "basalEnergyBurned": 1797.9209999999998,
    "distanceWalkingRunning": 1.5767183200000001,
    "flightsClimbed": 5,
    "stepCount": 3854,
    "walkingSpeed": 2.7159041176470593
  },
  {
    "date": "2025-10-17",
    "activeEnergyBurned": 190.339,
    "basalEnergyBurned": 1746.1619999999996,
    "distanceWalkingRunning": 2.62973072,
    "flightsClimbed": 2,
    "stepCount": 5603,
    "walkingSpeed": 2.8142384615384617
  },
  {
    "date": "2025-10-18",
    "activeEnergyBurned": 114.82399999999998,
    "basalEnergyBurned": 1460.3989999999997,
    "distanceWalkingRunning": 1.57628792,
    "flightsClimbed": 4,
    "stepCount": 3330,
    "walkingSpeed": 3.086973333333333
  },
  {
    "date": "2025-10-19",
    "activeEnergyBurned": 6.263,
    "basalEnergyBurned": 1697.956,
    "distanceWalkingRunning": 0.16619817,
    "stepCount": 401,
    "walkingSpeed": 2.9013896296296298
  },
  {
    "date": "2025-10-20",
    "activeEnergyBurned": 514.705,
    "basalEnergyBurned": 1903.706,
    "distanceWalkingRunning": 6.810012619999999,
    "flightsClimbed": 13,
    "stepCount": 14646,
    "walkingSpeed": 2.922836625
  },
  {
    "date": "2025-10-21",
    "activeEnergyBurned": 160.275,
    "basalEnergyBurned": 1556.9049999999997,
    "distanceWalkingRunning": 2.16919615,
    "flightsClimbed": 6,
    "stepCount": 5160,
    "walkingSpeed": 2.778510789473684
  }
];